(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GallerySelectionScene = require("./scenes/GallerySelectionScene");

var _GallerySelectionScene2 = _interopRequireDefault(_GallerySelectionScene);

var _ImageSelectionScene = require("./scenes/ImageSelectionScene");

var _ImageSelectionScene2 = _interopRequireDefault(_ImageSelectionScene);

var _GameScene = require("./scenes/GameScene");

var _GameScene2 = _interopRequireDefault(_GameScene);

var _MainScene = require("./scenes/MainScene");

var _MainScene2 = _interopRequireDefault(_MainScene);

var _SavedData = require("./SavedData");

var _SavedData2 = _interopRequireDefault(_SavedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*

 var AudioParams = require("./AudioParams");
 var Common = require("./Common");
 var CommonGame = require("./CommonGame");
 var SavedData = require("./SavedData");
 var MainScene = require("./scenes/MainScene");
 var GameScene = require("./scenes/GameScene");
 var ImageSelectionScene = require("./scenes/ImageSelectionScene");
 var GallerySelectionScene = require("./scenes/GallerySelectionScene");
 */
var Application = function () {
    function Application() {
        _classCallCheck(this, Application);
    }

    _createClass(Application, null, [{
        key: "init",
        value: function init() {
            _Common2.default.assets.texture = _Common2.default.assets.texture.bind(_Common2.default.assets);

            Application.showMainScene();

            _Common2.default.savedData = new _SavedData2.default();
            _Common2.default.savedData.init();
        }

        /**
         * @returns {Scene}
         */

    }, {
        key: "showMainScene",
        value: function showMainScene() {

            _Common2.default.paused = false;

            var scene = new _MainScene2.default();

            scene.signals.next.add(function () {
                Application.showGallerySelectionScene();
            }, this);

            _Common2.default.scene.show(scene);

            return scene;
        }
    }, {
        key: "showGameScene",
        value: function showGameScene() {

            var scene = new _GameScene2.default();

            scene.signals.next.add(function (scene) {
                Application.showGameScene();
            }, this);

            scene.signals.previous.add(function (scene) {
                Application.showImageSelectionScene();
            }, this);

            scene.signals.home.add(function (scene) {
                Application.showMainScene();
            }, this);

            _Common2.default.scene.show(scene);

            return scene;
        }
    }, {
        key: "showImageSelectionScene",
        value: function showImageSelectionScene() {

            var scene = new _ImageSelectionScene2.default();

            scene.signals.next.add(function (scene) {
                Application.showGameScene();
            }, this);

            scene.signals.previous.add(function (scene) {
                Application.showGallerySelectionScene();
            }, this);

            scene.signals.home.add(function (scene) {
                Application.showMainScene();
            }, this);

            _Common2.default.scene.show(scene);

            return scene;
        }
    }, {
        key: "showGallerySelectionScene",
        value: function showGallerySelectionScene() {

            var scene = new _GallerySelectionScene2.default();

            scene.signals.next.add(function (scene) {
                Application.showImageSelectionScene();
            }, this);

            scene.signals.previous.add(function (scene) {
                Application.showMainScene();
            }, this);

            scene.signals.home.add(function (scene) {
                Application.showMainScene();
            }, this);

            _Common2.default.scene.show(scene);

            return scene;
        }
    }]);

    return Application;
}();

exports.default = Application;

},{"./Common":3,"./SavedData":6,"./scenes/GallerySelectionScene":27,"./scenes/GameScene":28,"./scenes/ImageSelectionScene":29,"./scenes/MainScene":30}],3:[function(require,module,exports){
"use strict";
//import Button from "./Button";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Common() {}
exports.default = Common;

//====================================//
//=====PROJECT SPECIFIC VARIABLES=====//
//====================================//

/**
 * Wrapper for legacy of jons old happo paint game
 * @type {{assetRes: number}}
 */

Common.main = { assetRes: 1 };

/**
 * Currently selected intellectual property
 * @type {string}
 */
Common.themeIndex = 0;

/**
 * @type {signals.Signal}
 */
Common.killGlowSignal = new signals.Signal();

/**
 * @type {signals.Signal}
 */
Common.toggleCurrentGlowSignal = new signals.Signal();

/**
 * @param arr
 */
Common.buttonsAppear = function (arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            delay: i * 0.15 + 0.25
        });
    }
};

//====================================//
//========PROJECT SPECIFIC END========//
//====================================//

/**
 * @type {null|P3.AssetManager}
 */
Common.assets = null;

/**
 * @type {P3.View}
 */
Common.view = null;

/**
 * @type {number}
 */
Common.paused = false;

/**
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 */
Common.isDebug = false;

/**
 * @type {boolean}
 */
Common.isMute = false;

//===============//
//==static vars==//
//===============//

/**
 * Semi unique key used as an identifier for save files, followed by the version
 * (useful if you want players to start a new game, increment version number)
 * @static
 * @type {string}
 */
Common.game_key = "rozhc7o7-dsn-create-v1.0";

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {P3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_WIDTH = 1664;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_HEIGHT = 768;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

//===============//
//==static ends==//
//===============//

//================================//
//=====save and load functions====//
//================================//

Common.saveMute = function () {
    var data = { isMute: Common.isMute };
    localStorage.setItem(Common.game_key + "_isMute", JSON.stringify(data));
};

Common.loadMute = function () {
    var data = JSON.parse(localStorage.getItem(Common.game_key + "_isMute"));
    if (data) {
        Common.isMute = data.isMute;
        Common.audio.mute(Common.isMute);
    }
};

Common.saveGame = function () {
    var gameData = { highestScore: Common.highestScore };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    var gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.highestScore = gameData.highestScore;
        Common.isFirstPlay = false;
    } else {
        Common.isFirstPlay = true;
    }
};

//=========================================================//
//=============Rest is all util type functions=============//
//=========================================================//

/**
 * Knuth shuffle variant
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    var a = string.split(""); //our array
    var n = a.length; //number of elements
    for (var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = function (a) {
    for (var i = a.length; i; i--) {
        var j = Math.floor(Math.random() * i);
        var _ref = [a[j], a[i - 1]];
        a[i - 1] = _ref[0];
        a[j] = _ref[1];
    }
    return a;
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    strLen = strLen || 8;
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    return Math.atan2(dy, dx);
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

/**
 * @param rad
 * @returns {number}
 */
Common.rad2deg = function (rad) {
    return rad * 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * Returns a new keyboard object that listens for keyboard input
 * @param keyCode
 * @returns {{}}
 */
Common.keyboard = function (keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.down = undefined;
    key.up = undefined;
    //The `downHandler`
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.down) key.down();
            key.isDown = true;
            key.isUp = false;
        }
        event.preventDefault();
    };

    //The `upHandler`
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.up) key.up();
            key.isDown = false;
            key.isUp = true;
        }
        event.preventDefault();
    };

    //Attach event listeners
    window.addEventListener("keydown", key.downHandler.bind(key), false);
    window.addEventListener("keyup", key.upHandler.bind(key), false);
    return key;
};

/**
 * @param width
 * @param height
 * @param colour
 * @param shape
 * @returns {Texture}
 */
Common.genTex = function (width, height, colour, shape) {
    var g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);else g.beginFill(0x000fff);
    if (shape === "rect") g.drawRect(0, 0, width, height);else if (shape === "circle") g.drawEllipse(0, 0, width, height);else g.drawRect(0, 0, width, height); //fallback to rect
    g.endFill();
    return Common.renderer.generateTexture(g);
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - should we return a texture or a sprite?
 * @returns {PIXI.Sprite|String}
 */
Common.generateRect = function (width, height, colour, retTexture) {
    var g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);else g.beginFill(0x000fff);
    g.lineStyle(5, 0xd9d9d9);
    g.drawRect(0, 0, width, height);
    g.endFill();
    var texture = Common.renderer.generateTexture(g);
    var sprite = new PIXI.Sprite(texture);
    sprite.anchor = { x: 0.5, y: 0.5 };
    g.destroy();
    if (!retTexture) return sprite;
    sprite.destroy();
    return texture;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - Should we return a texture or a sprite?
 * @returns {PIXI.Sprite|PIXI.Texture}
 */
Common.generateEllipse = function (width, height, colour, retTexture) {
    var g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);else g.beginFill(0xfff000);
    g.drawEllipse(0, 0, width, height);
    g.endFill();
    var texture = Common.renderer.generateTexture(g);
    var sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5);
    g.destroy();
    if (!retTexture) return sprite;else return texture;
};

/**
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (var i = 0; i < arguments.length; i++) {
        arguments[i].anchor.set(0.5);
    }
};

/**
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    var arr = [];
    for (var i = 0; i < numRows; i++) {
        var columns = [];
        for (var j = 0; j < numCols; j++) {
            columns[j] = initial;
        }arr[i] = columns;
    }
    return arr;
};

/**
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    var arr = [];
    for (var i = 0; i < size; i++) {
        arr.push(initial);
    }return arr;
};

/**
 * Uses quick sort to sort an array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sort = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first],
                index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i] < pivot) swap(index++, i);else if (highToLow && array[i] > pivot) swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts tiles (or any display object) by x, y coordinates so they are ordered lowest top to bottom , left to right
 * @param array
 * @returns {*}
 */
Common.sortTiles = function (array) {
    array.sort(function (a, b) {
        if (a.y == b.y) return a.x - b.x;else return a.y - b.y;
    });
    return array;
};

/**
 * Sorts object with an x or y property (such as sprites) by x or y dependant on flag
 * @param array - array to sort
 * @param highToLow - sort high to low?
 * @param sortX - flag to choose whether to sort by x or y
 * @returns {*}
 */
Common.sortBy = function (array, highToLow, sortX) {

    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {
        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }
        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first],
                index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow) {
                    if (x) {
                        if (array[i].x < pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y < pivot.y) swap(index++, i);
                    }
                } else {
                    if (x) {
                        if (array[i].x > pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y > pivot.y) swap(index++, i);
                    }
                }
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts object with a distance property
 * @param array - array to sort
 * @param highToLow - sort high to low?
 * @returns {*}
 */
Common.sortDistances = function (array, highToLow) {

    highToLow = highToLow || false;

    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {
        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }
        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first],
                index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow) {
                    if (array[i].distance < pivot.x) swap(index++, i);
                } else {
                    if (array[i].distance > pivot.distance) swap(index++, i);
                }
            }
            swap(index, last);
            return index;
        }
    }
};

Common.compareXY = function (point1, point2) {
    return Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y);
};

Common.lerpAxis = function (start, end, percent) {
    return (end - start) * percent + start;
};

Common.lerpVector = function (start, end, percent) {
    return Common.Vector.add(Common.Vector.scale(Common.Vector.sub(start, end), percent), start);
};

Common.Vector = {
    add: function add(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.add() must be passed a pair of vectors');
        return { x: a.x + b.x, y: a.y + b.y };
    },
    sub: function sub(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.sub() must be passed a pair of vectors');
        return { x: a.x - b.x, y: a.y - b.y };
    },
    mult: function mult(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.mult() must be passed a pair of vectors');
        return { x: a.x * b.x, y: a.y * b.y };
    },
    div: function div(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.div() must be passed a pair of vectors');
        return { x: a.x / b.x, y: a.y / b.y };
    },
    scale: function scale(a, scalePerc) {
        if (a.x === undefined) throw new Error('Vector.scale() must be passed a vector for first arg');
        return { x: a.x * scalePerc, y: a.y * scalePerc };
    }
};

Common.lookAt = function (sprite, target, update) {
    var rotation = Math.atan2(target.y - sprite.y, target.x - sprite.x);
    if (update) sprite.rotation = rotation;
    return rotation;
};

//--from stackoverflow-- https://stackoverflow.com/questions/14962018/detecting-and-fixing-circular-references-in-javascript //
Common.detectCircularRef = function (obj) {

    return detectCircularReferences(obj);

    function detectCircularReferences(toBeStringifiedValue) {
        var serializationKeyStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        Object.keys(toBeStringifiedValue).forEach(function (key) {
            var value = toBeStringifiedValue[key];
            var serializationKeyStackWithNewKey = serializationKeyStack.slice();
            serializationKeyStackWithNewKey.push(key);
            try {
                JSON.stringify(value);
            } catch (error) {
                var isCircularValue;
                var circularExcludingStringifyResult = "";
                try {
                    circularExcludingStringifyResult = JSON.stringify(value, replaceRootStringifyReplacer(value), 2);
                    isCircularValue = true;
                } catch (error) {
                    detectCircularReferences(value, serializationKeyStackWithNewKey);
                    isCircularValue = false;
                }
                if (isCircularValue) {
                    throw new Error("Circular reference detected:\nCircularly referenced value is value under path \"" + joinStrings(serializationKeyStackWithNewKey) + "\" of the given root object\n" + ("Calling stringify on this value but replacing itself with [Circular object --- fix me] ( <-- search for this string) results in:\n" + circularExcludingStringifyResult + "\n"));
                }
            }
        });
    }

    function replaceRootStringifyReplacer(toBeStringifiedValue) {
        var serializedObjectCounter = 0;
        return function (key, value) {
            if (serializedObjectCounter !== 0 && (typeof toBeStringifiedValue === "undefined" ? "undefined" : _typeof(toBeStringifiedValue)) === 'object' && toBeStringifiedValue === value) {
                return '[Circular object --- fix me]';
            }
            serializedObjectCounter++;
            return value;
        };
    }

    function joinStrings(arr) {
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";

        if (arr.length === 0) return "";
        return arr.reduce(function (v1, v2) {
            return "" + v1 + separator + v2;
        });
    }
};

//from github pixi-simple-gestures
Common.pinchable = function (sprite, inertia) {

    sprite.interactive = true;
    sprite.on('touchstart', start);
    sprite.on('touchend', end);
    sprite.on('touchendoutside', end);

    function start(e) {
        sprite.on('touchmove', move);
    }

    function move(e) {
        var t = e.data.originalEvent.targetTouches;
        if (!t || t.length < 2) {
            return;
        }
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (!sprite._pinch) {
            sprite._pinch = {
                p: {
                    distance: distance,
                    date: new Date()
                }
            };
            sprite.emit('pinchstart');
            return;
        }
        var now = new Date();
        var interval = now - sprite._pinch.p.date;
        if (interval < 12) {
            return;
        }
        var center = {
            x: (t[0].clientX + t[1].clientX) / 2,
            y: (t[0].clientY + t[1].clientY) / 2
        };
        var event = {
            scale: distance / sprite._pinch.p.distance,
            velocity: distance / interval,
            center: center,
            data: e.data
        };
        sprite.emit('pinchmove', event);
        sprite._pinch.pp = {
            distance: sprite._pinch.p.distance,
            date: sprite._pinch.p.date
        };
        sprite._pinch.p = {
            distance: distance,
            date: now
        };
    }

    function end(e) {
        sprite.removeListener('touchmove', move);
        if (!sprite._pinch) {
            return;
        }
        if (inertia && sprite._pinch.pp) {
            if (sprite._pinch.intervalId) {
                return;
            }
            var interval = new Date() - sprite._pinch.p.date;
            var velocity = (sprite._pinch.p.distance - sprite._pinch.pp.distance) / interval;
            var center = sprite._pinch.p.center;
            var distance = sprite._pinch.p.distance;
            sprite._pinch.intervalId = setInterval(function () {
                if (Math.abs(velocity) < 0.04) {
                    clearInterval(sprite._pinch.intervalId);
                    sprite.emit('pinchend');
                    sprite._pinch = null;
                    return;
                }
                var updatedDistance = distance + velocity * 12;
                var event = {
                    scale: updatedDistance / distance,
                    velocity: velocity,
                    center: center,
                    data: e.data
                };
                sprite.emit('pinchmove', event);
                distance = updatedDistance;
                velocity *= 0.8;
            }, 12);
        } else {
            sprite.emit('pinchend');
            sprite._pinch = null;
        }
    }
};

//from https://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
Common.getAndroidVersion = function (ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

/**
 * Custom tween
 * @param obj
 * @param time
 * @param params
 * @returns {TweenLite|TweenMax|TimelineLite|*}
 */
Common.erraticTween = function (obj, time) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { delay: 0 };

    params.ease = CustomEase.create("custom", "M0,0,C0,0,0.065,0.167,0.08,0.205,0.09,0.2,0.124,0.182,0.135,0.176,0.157,0.223,0.21,0.59,0.22,0.608,0.223,0.585,0.298,0.12,0.3,0.111,0.3,0.118,0.309,0.262,0.315,0.345,0.322,0.36,0.325,0.372,0.335,0.388,0.352,0.417,0.372,0.439,0.39,0.463,0.391,0.502,0.394,0.58,0.395,0.583,0.396,0.578,0.418,0.461,0.43,0.399,0.431,0.397,0.463,0.611,0.464,0.61,0.475,0.621,0.488,0.448,0.495,0.455,0.495,0.449,0.498,0.417,0.5,0.404,0.512,0.401,0.562,0.262,0.572,0.26,0.577,0.293,0.568,0.499,0.58,0.568,0.597,0.639,0.603,0.787,0.608,0.806,0.616,0.794,0.698,0.64,0.705,0.63,0.705,0.638,0.708,0.685,0.71,0.72,0.711,0.734,0.713,0.745,0.715,0.756,0.719,0.759,0.737,0.781,0.742,0.784,0.746,0.83,0.743,0.912,0.745,0.925,0.756,0.907,0.863,0.732,0.88,0.705,0.894,0.741,1,1,1,1");
    return TweenMax.to(obj, time, params);
};

/**
 * Dijkstra implementation of a path finder. Prefer this over A* if you have multiple agents with same starting position
 * and you are using a weighted graph. For non weighted graphics use BFS. For a single agent with a known single target destination use A*.
 * Or alternatively if you are unsure what your target is you can calc the path to all nodes, and then just retrieve the path to the target
 * node once you know it which could be useful depending on use case.
 *
 * @class
 */

var Dijkstra = function () {
    function Dijkstra() {
        _classCallCheck(this, Dijkstra);

        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        //todo - add findPath() function which terminates when u === v
        /**
         * @type {null}
         * @private
         */
        this._target = null; //note we may want to target if we only have one agent, but A* is probably better for this case so prefer that if you don't need to guarantee the shortest path

        /**
         * Vertex set Q
         * @type {Array}
         * @private
         */
        this._verts = [];

        /**
         * @type {null}
         * @private
         */
        this._paths = null;
    }

    _createClass(Dijkstra, [{
        key: "init",
        value: function init() {

            if (!this._graph) throw new Error('must set graph before init');
            if (!this._source) throw new Error('must set source before init');

            //--create vertex set Q--//
            for (var _x4 = 0; _x4 < this._graph.length; _x4++) {
                for (var y = 0; y < this._graph[_x4].length; y++) {
                    // All nodes initially in Q (unvisited nodes)
                    var vert = this._graph[_x4][y];

                    vert.distance = Number.POSITIVE_INFINITY;
                    vert.prev = null;
                    vert.neighbours = [];

                    if (_x4 > 0) vert.neighbours.push(this._graph[_x4 - 1][y]); //grid sq left
                    if (_x4 < this._graph.length - 1) vert.neighbours.push(this._graph[_x4 + 1][y]); //grid sq right
                    if (y > 0) vert.neighbours.push(this._graph[_x4][y - 1]); //grid sq above
                    if (y < this._graph[_x4].length - 1) vert.neighbours.push(this._graph[_x4][y + 1]); //grid sq below

                    this._verts.push(vert);
                }
            }
            var s = this._source;
            this._verts[this._graph.length * s.x + s.y].distance = 0; //set source to source distance as zero (ensures this is first in our list becaue it has the lowest dist)
        }
    }, {
        key: "findPaths",
        value: function findPaths() {

            var descending = function descending(a, b) {
                return b.distance - a.distance;
            }; //descending sort function

            var paths = [];

            while (this._verts.length > 0) {

                //TODO can we take the sort out for optimisation?

                //--find node with least dist by sorting--//
                // this._verts = Common.sortDistances(this._verts, true);   //highToLow
                this._verts.sort(descending); //way outperforms my quick sort function (100 to 300 percent quicker)

                var u = this._verts[this._verts.length - 1]; //take last element which is the one with the shortest distance

                this._verts.pop(); //remove u from vert list (Q)

                //--for each neighbour v of u--//
                for (var i = 0; i < u.neighbours.length; i++) {
                    var v = u.neighbours[i];
                    var sourceToV = u.distance + Common.distance(u.x, u.y, v.x, v.y);
                    if (sourceToV < v.distance) {
                        //we found a new shortest distance to this node v
                        v.distance = sourceToV; //store dist
                        v.prev = u; //store prev node

                        paths.push(v);
                    }
                }
            }

            this._paths = paths;

            return paths;
        }

        /**
         * Fetches the path from the this._paths pre calculated paths to all nodes
         * @param pos
         */

    }, {
        key: "retrievePathTo",
        value: function retrievePathTo(pos) {
            var node = void 0;
            for (var i = 0; i < this._paths.length; i++) {
                if (Common.compareXY(pos, this._paths[i])) {
                    node = this._paths[i];
                }
            }

            if (!node) {
                throw new Error("can't retrieve path, position not on graph");
            }

            var path = [];

            //--trace back to start node to create the path--//
            var recurse = function recurse() {
                //using a little recursive function to trace the path backwards
                path.push({ x: node.x, y: node.y });
                if (node.prev) {
                    node = node.prev;
                    recurse();
                }
            };
            recurse();

            return path;
        }
    }, {
        key: "reset",
        value: function reset() {
            this.init();
        }
    }, {
        key: "test",
        value: function test(scene) {

            var tWid = 50;
            var holder = new PIXI.Container();
            var gridSize = 15;
            var graph = Common.matrix(gridSize, gridSize);
            holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
            scene.addChild(holder);

            for (var _x5 = 0; _x5 < gridSize; _x5++) {
                for (var y = 0; y < gridSize; y++) {

                    var _sp = P3.createSprite(PIXI.Texture.WHITE, holder);
                    _sp.x = _x5 * tWid;
                    _sp.y = y * tWid;

                    _sp.width = tWid - 2;
                    _sp.height = tWid - 2;

                    _sp.tint = 0xD8D8D8;

                    graph[_x5][y] = { x: _x5, y: y }; //grid should be stored as int and we will multiply out to get tile pos
                }
            }

            this.graph = graph;
            this.source = graph[0][0]; //set source to be top left

            var t0 = performance.now();
            this.init();
            var paths = this.findPaths();
            var t1 = performance.now();
            console.warn("found paths in : " + (t1 - t0));

            var path = this.retrievePathTo({ x: gridSize - 1, y: gridSize - 1 }); //retrieve path to bottom right

            console.log(paths);
            console.log(path);

            var sp = P3.createSprite(PIXI.Texture.WHITE, holder);
            sp.anchor.set(0.5);
            sp.position.set(graph[0][0].x, graph[0][0].y);
            sp.width = tWid * 0.5;
            sp.height = tWid * 0.5;

            followPath(sp, tWid, path);

            function followPath(sprite, tWid, path) {
                var node = path[path.length - 1];
                TweenMax.to(sprite, 0.5, {
                    x: node.x * tWid,
                    y: node.y * tWid + tWid * 0.5,
                    ease: Power0.easeNone,
                    onComplete: function onComplete() {
                        path.pop();
                        if (path.length > 0) followPath(sprite, tWid, path);
                    }
                });
            }
        }
    }, {
        key: "graph",
        set: function set(value) {
            this._graph = value;
        }
    }, {
        key: "source",
        set: function set(value) {
            this._source = value;
        }
    }, {
        key: "target",
        set: function set(value) {
            this._target = value;
        }
    }]);

    return Dijkstra;
}();

Common.PathD = new Dijkstra();

/**
 * Best performing path finding algorithm in cases where node distances are all the same (unweighted graph / grid).
 * Could be adapted to use without a target in which case it will find path to every node,
 * a possible use for this could be enemies in an RTS game.
 * @class
 */

var BreadthFirst = function () {
    function BreadthFirst() {
        _classCallCheck(this, BreadthFirst);

        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        /**
         * @type {null}
         * @private
         */
        this._target = null;

        /**
         * List of nodes currently being explored
         * @type {Array}
         * @private
         */
        this._openList = [];
    }

    _createClass(BreadthFirst, [{
        key: "init",
        value: function init() {

            if (!this._graph) throw new Error('must set graph before init');
            if (!this._source) throw new Error('must set source before init');

            var startNode = void 0;

            for (var _x6 = 0; _x6 < this._graph.length; _x6++) {
                for (var y = 0; y < this._graph[_x6].length; y++) {
                    var vert = this._graph[_x6][y];

                    vert.neighbours = [];
                    vert.prev = null;

                    if (_x6 > 0) vert.neighbours.push(this._graph[_x6 - 1][y]); //grid sq left
                    if (_x6 < this._graph.length - 1) vert.neighbours.push(this._graph[_x6 + 1][y]); //grid sq right
                    if (y > 0) vert.neighbours.push(this._graph[_x6][y - 1]); //grid sq above
                    if (y < this._graph[_x6].length - 1) vert.neighbours.push(this._graph[_x6][y + 1]); //grid sq below

                    if (Common.compareXY({ x: _x6, y: y }, this._source)) {
                        //if node is source node we can immediately mark as visited
                        vert.visited = true;
                        startNode = vert;
                    }
                }
            }

            //--we want the list to be fifo--//
            this._openList.reverse();
            this._openList.push(startNode);
        }
    }, {
        key: "find",
        value: function find() {

            /*
             -PSUEDOCODE-
             unmark all vertices
             choose some starting vertex x
             mark x
             list L = x
             tree T = x
             while L nonempty
             choose some vertex u from front of list
             visit u
             for each unmarked neighbor v
             mark v
             add it to end of list
             add edge uv to T
             */

            if (!this._target) throw new Error('must set target before performing BFS');

            var endNode = void 0;

            var arr = [];
            while (this._openList.length > 0) {
                var u = this._openList[this._openList.length - 1]; //get our first vertex
                this._openList.pop();
                u.visited = true; //mark as visited

                if (Common.compareXY(u, this._target)) {
                    console.warn("found target");
                    endNode = u;
                    break;
                }

                for (var i = 0; i < u.neighbours.length; i++) {
                    var v = u.neighbours[i];
                    if (!v.visited) {
                        v.visited = true;
                        v.prev = u;

                        this._openList.unshift(v); //fifo

                        var edge = { start: u, end: v };
                        arr.push(edge);
                    }
                }
            }

            // console.log(this._closedList);

            // console.log(arr);

            var path = [];

            var node = endNode;
            //--trace back to start node to create the path--//
            var recurse = function recurse() {
                //using a little recursive function to trace the path backwards
                path.push({ x: node.x, y: node.y });
                if (node.prev) {
                    node = node.prev;
                    recurse();
                }
            };
            recurse();

            return path;
        }
    }, {
        key: "test",
        value: function test(scene) {

            var tWid = 25;
            var holder = new PIXI.Container();
            var gridSize = 25;
            var graph = Common.matrix(gridSize, gridSize);
            holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
            scene.addChild(holder);

            for (var _x7 = 0; _x7 < gridSize; _x7++) {
                for (var y = 0; y < gridSize; y++) {

                    var _sp2 = P3.createSprite(PIXI.Texture.WHITE, holder);
                    _sp2.x = _x7 * tWid;
                    _sp2.y = y * tWid;

                    _sp2.width = tWid - 2;
                    _sp2.height = tWid - 2;

                    _sp2.tint = 0xD8D8D8;

                    graph[_x7][y] = { x: _x7, y: y }; //grid should be stored as int and we will multiply out to get tile pos
                }
            }

            this.graph = graph;
            this.source = graph[0][0]; //set source to be top left
            this.target = { x: gridSize - 1, y: gridSize - 1 };

            var t0 = performance.now();
            this.init();
            var path = this.find();
            var t1 = performance.now();
            console.warn("found paths in : " + (t1 - t0));

            // const path = Common.Path.retrievePathTo({x: gridSize - 1, y: gridSize - 1}); //retrieve path to bottom right

            // return;
            //  console.log(paths);
            console.log(path);

            var sp = P3.createSprite(PIXI.Texture.WHITE, holder);
            sp.anchor.set(0.5);
            sp.position.set(graph[0][0].x, graph[0][0].y);
            sp.width = tWid * 0.5;
            sp.height = tWid * 0.5;

            followPath(sp, tWid, path);

            function followPath(sprite, tWid, path) {
                var node = path[path.length - 1];
                TweenMax.to(sprite, 0.5, {
                    x: node.x * tWid,
                    y: node.y * tWid + tWid * 0.5,
                    ease: Power0.easeNone,
                    onComplete: function onComplete() {
                        path.pop();
                        if (path.length > 0) followPath(sprite, tWid, path);
                    }
                });
            }
        }
    }, {
        key: "graph",
        set: function set(value) {
            this._graph = value;
        }
    }, {
        key: "source",
        set: function set(value) {
            this._source = value;
        }
    }, {
        key: "target",
        set: function set(value) {
            this._target = value;
        }
    }]);

    return BreadthFirst;
}();

Common.PathBFS = new BreadthFirst();

//===================================================
//
// Jon's Methods
//
//===================================================

/**
 * @type {boolean}
 * @static
 */
Common.randBool = function () {
    return Math.random() > 0.5;
};

/**
 * @type {boolean}
 * @static
 */
Common.toOneDecimalStr = function (a) {
    var result = a.toFixed(1);
    if (result[result.indexOf(".") + 1] == "0") result = result.substr(0, result.indexOf("."));

    return result;
};

/**
 * @type {number}
 * @static
 */
Common.randomInt = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

/**
 * @type {Array<object>}
 * @static
 */
Common.heapPermutations = function (arrElement) {
    var arr = arrElement.slice();
    var permutations = [];

    function swap(a, b) {
        var tmp = arr[a];
        arr[a] = arr[b];
        arr[b] = tmp;
    }

    function generate(n) {
        if (n == 1) permutations.push(arr.slice());else {
            for (var i = 0; i != n; ++i) {
                generate(n - 1);
                swap(n % 2 ? 0 : i, n - 1);
            }
        }
    }

    generate(arr.length);

    return permutations;
};

/**
 * @returns Number
 */
Common.getScreenPositionLeft = function () {
    return Math.max(0, Common.STAGE_WIDTH * 0.5 - P3.View.width * 0.5);
};

/**
 * @returns Number
 */
Common.getScreenPositionRight = function () {
    return Math.min(Common.STAGE_WIDTH, Common.STAGE_WIDTH * 0.5 + P3.View.width * 0.5);
};

Common.distanceBetween = function (point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};

Common.angleBetween = function (point1, point2) {
    return Math.atan2(point2.x - point1.x, point2.y - point1.y);
};

Common.randomFloat = function (min, max) {
    return Math.random() * (max - min) + min;
};

Common.midPointBtw = function (p1, p2) {
    return {
        x: p1.x + (p2.x - p1.x) / 2,
        y: p1.y + (p2.y - p1.y) / 2
    };
};

Common.hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};

/**
 * @type {number}
 * @static
 */
Common.findPositionInScene = function (sprite, scene) {
    var result = new PIXI.Point(sprite.x, sprite.y);

    var parent = sprite.parent;
    while (parent != scene) {
        result.x += parent.x;
        result.y += parent.y;

        parent = parent.parent;
    }

    return result;
};

window.Common = Common;

},{"./Application":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CommonGame() {}
exports.default = CommonGame;

//===================================================
//
// Enumerators
//
//===================================================

// Scene types.

CommonGame.SCENE_ID_MAIN = 0;
CommonGame.SCENE_ID_GAME = 1;
CommonGame.SCENE_ID_IMAGE_SELECTION = 2;
CommonGame.SCENE_ID_GALLERY_SELECTION = 3;

// Layer types.
CommonGame.LAYER_ID_FILL = 0;
CommonGame.LAYER_ID_DRAW = 1;

// Gallery types.
CommonGame.GALLERY_ID_DRAW_IT = 0;
CommonGame.GALLERY_ID_COLOUR_IT = 1;

CommonGame.ARR_COLOUR_IT_SPRITE_ID = ["colour_image_1", "colour_image_2", "colour_image_3", "colour_image_4", "colour_image_5", "colour_image_6", "colour_image_7", "colour_image_8", "colour_image_9", "colour_image_10"];

CommonGame.ARR_DRAW_IT_SPRITE_ID = ["draw_image_1", "draw_image_2", "draw_image_3", "draw_image_4", "draw_image_5", "draw_image_6", "draw_image_7_", "draw_image_8", "draw_image_9", "draw_image_10"];

CommonGame.TUT_EVENT = {
    TOOL_BAR_HIDDEN: 0,
    TOOL_BAR_VISIBLE: 1,
    PALETTE_SELECTED: 2,
    PALETTE_PANEL_HIDDEN: 3,
    TOOL_SELECTED: 4,
    CANVAS_DRAWN: 5,
    CANVAS_VISIBLE: 6,
    PALETTE_BUTTON_ENABLED: 7,
    PALETTE_BUTTON_DISABLED: 8,
    MENU_PANEL_SHOWN: 9,
    MENU_PANEL_HIDDEN: 10
};

CommonGame.TOOL = {
    PENCIL: 0,
    BRUSH: 1,
    STAMP: 2,
    BUCKET: 3,
    INK_POT: 4,
    SPRAY: 5,
    ERASER: 6
};

//===================================================
//
// Constants
//
//===================================================

CommonGame.GALLERY_BORDER_TINT = [0x87d027, // Draw it!
0x1e84c9 // Colour it!
];

CommonGame.TEXTURE_BUTTON_BASE_ID = "btns_colour_texture";
CommonGame.TEXTURE_SPRITE_BASE_ID = "texture_fill";

CommonGame.CANVAS_HEIGHT = 612;
CommonGame.CANVAS_WIDTH = 870;

//===================================================
//
// Attributes
//
//===================================================

CommonGame.selectedGallery = null;
CommonGame.selectedImageId = null;
CommonGame.drawItTextId = null;

//===================================================
//
// Methods
//
//===================================================

CommonGame.createCanvasBg = function () {
    var SCALE_FACTOR = 0.979;

    var galleryKey = "drawing";
    if (CommonGame.selectedGallery === 1) galleryKey = "colouring";

    var canvasTex = _Common2.default.assets.getTexture("canvas_" + galleryKey);
    var canvasBg = new PIXI.Graphics();
    canvasBg.beginFill(CommonGame.GALLERY_BORDER_TINT[CommonGame.selectedGallery], 1);
    canvasBg.drawRoundedRect(-canvasTex.width * 0.5 * SCALE_FACTOR, -canvasTex.height * 0.5 * SCALE_FACTOR, canvasTex.width * SCALE_FACTOR, canvasTex.height * SCALE_FACTOR, 30);
    canvasBg.endFill();

    return canvasBg;
};

CommonGame.findColourCode = function (selection) {
    var result = { r: 0, g: 0, b: 1 };

    var pages = _Common2.default.assets.getJSON("config").palettePanel.pages;
    for (var i = 0; i < pages.length; ++i) {
        var itemIndex = pages[i].indexOf(selection);
        if (itemIndex != -1) {
            result.r = i;
            result.g = itemIndex;

            break;
        }
    }

    return result;
};

},{"./Common":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _PreloaderScene = require("./scenes/PreloaderScene");

var _PreloaderScene2 = _interopRequireDefault(_PreloaderScene);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _pixiMultistyleText = require("./pixi-multistyle-text");

var _pixiMultistyleText2 = _interopRequireDefault(_pixiMultistyleText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Main = function () {
    /**
     * @param {number} width
     * @param {number} height
     */
    function Main(width, height) {
        _classCallCheck(this, Main);

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;
    }

    _createClass(Main, [{
        key: "init",
        value: function init(language) {

            _Common2.default.blankTexture = PIXI.Texture.WHITE;

            _Common2.default.assets = new P3.AssetManager();
            _Common2.default.audio = P3.Button.audio = new P3.AudioManager();
            _Common2.default.language = language;

            _Common2.default.assets.texture.bind(_Common2.default.assets);

            //--for legacy--//
            P3.Device = {};
            P3.Device.isMobile = _ismobilejs2.default.any;

            //wrapped to make compatible with p3lib v5
            _Common2.default.assets.getTexture = function (name) {
                return _Common2.default.assets.texture(name);
            };
            _Common2.default.assets.getJSON = function (name) {
                return _Common2.default.assets.json(name);
            };
            _Common2.default.assets.hasTexture = function (name) {
                var bool = true;
                try {
                    PIXI.Texture.fromFrame(name + ".png");
                } catch (err) {
                    bool = false;
                }
                return bool;
            };

            //Common.loadMute();
            //Common.loadGame();

            var isPortrait = false;

            var params = {};
            params.holderId = "game";
            params.width = this._width;
            params.height = this._height;
            params.portrait = isPortrait;
            params.aspectRatioFillHeight = !isPortrait;
            params.rotateImageUrl = "./assets/images/localisation/rotate/rotate_screen_" + language + ".jpg";
            params.rotateImageColor = "#000000";

            PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

            TweenMax.defaultOverwrite = "none";
            TweenMax.ticker.fps(60);

            var view = new P3.View(params);
            view.signals.ready.addOnce(function (canvas) {

                var options = {};
                options.view = canvas;
                options.transparent = false;
                options.antialias = false;
                options.preserveDrawingBuffer = false;
                options.resolution = 1.0;

                _Common2.default.stage = new PIXI.Container();

                // hotfix
                canvas.screencanvas = true;

                // const input = new Input();
                // input.init(stage, canvas);
                //  Common.input = input;

                //on clicking the document focus on canvas, fix for buttons not working on mobile
                document.onclick = function () {
                    canvas.focus();
                };

                var renderer = PIXI.autoDetectRenderer(this._width, this._height, options);
                renderer.backgroundColor = 0x000000;
                _Common2.default.renderer = renderer;
                _Common2.default.isWebGL = renderer instanceof PIXI.WebGLRenderer;

                var scene = new P3.SceneManager(renderer);
                scene.updateAll = true;
                _Common2.default.scene = scene;
                _Common2.default.stage.addChild(scene.view);

                PIXI.ticker.shared.add(function (deltaTime) {

                    window.P3.deltaTime = window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;
                    P3.Timestep.deltaTime = window.deltaTime;
                    scene.update();
                    renderer.render(_Common2.default.stage);
                }, this);

                window.delay = function (callback, delay, scope) {
                    TweenMax.delayedCall(delay, callback, [], scope);
                };
                window.translate = function (str) {
                    var s = _Common2.default.config.strings[str];
                    s = s && s[_Common2.default.language];
                    return typeof s !== "undefined" ? s : str;
                };

                this.loadPreloader();
            }, this);
            view.signals.resize.add(this.onCanvasResize, this);
            _Common2.default.view = view;
        }
    }, {
        key: "loadPreloader",
        value: function loadPreloader() {
            var files = [
            //sprite sheets
            { name: "ui_default_0_1x", url: "images/" + "ui_default_0_1x" + ".json" }, { name: "ui_default_1_1x", url: "images/" + "ui_default_1_1x" + ".json" }, { name: "preloader", url: "images/" + "preloader_1x" + ".json" }, { name: "aeromaticslight_50", url: "fonts/" + "aeromaticslight_50" + ".xml" //preloader font
            }];
            var sounds = [];
            if (files.length) {
                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.complete.addOnce(function () {
                    this.createConfig();
                    this.loadAssets();
                }, this);
                _Common2.default.assets.load();
                _Common2.default.audio.addSounds(sounds, [".mp3", ".ogg"], "");
            } else {
                this.loadAssets();
            }
        }
    }, {
        key: "loadAssets",
        value: function loadAssets() {

            var files = [
            // json.
            { name: "languages", url: "data/" + "languages" + ".json" }, { name: "config", url: "data/" + "config" + ".json" }, { name: "draw_it", url: "data/" + "draw_it" + ".json" },
            // texture sheets.
            { name: "ui_default_0_1x", url: "images/" + "ui_default_0_1x" + ".json" }, { name: "ui_default_1_1x", url: "images/" + "ui_default_1_1x" + ".json" },
            // raw images.
            { name: "game_title", url: "images/localisation/title/" + "title_" + _Common2.default.language + ".png" }, { name: "colour_image_1", url: "images/outlines/colour_it/" + "image_1" + ".png" }, { name: "colour_image_2", url: "images/outlines/colour_it/" + "image_2" + ".png" }, { name: "colour_image_3", url: "images/outlines/colour_it/" + "image_3" + ".png" }, { name: "colour_image_4", url: "images/outlines/colour_it/" + "image_4" + ".png" }, { name: "colour_image_5", url: "images/outlines/colour_it/" + "image_5" + ".png" }, { name: "colour_image_6", url: "images/outlines/colour_it/" + "image_6" + ".png" }, { name: "colour_image_7", url: "images/outlines/colour_it/" + "image_7" + ".png" }, { name: "colour_image_8", url: "images/outlines/colour_it/" + "image_8" + ".png" }, { name: "colour_image_9", url: "images/outlines/colour_it/" + "image_9" + ".png" }, { name: "colour_image_10", url: "images/outlines/colour_it/" + "image_10" + ".png" }, { name: "draw_image_1", url: "images/outlines/draw_it/" + "image_1" + ".png" }, { name: "draw_image_2", url: "images/outlines/draw_it/" + "image_2" + ".png" }, { name: "draw_image_3", url: "images/outlines/draw_it/" + "image_3" + ".png" }, { name: "draw_image_4", url: "images/outlines/draw_it/" + "image_4" + ".png" }, { name: "draw_image_5", url: "images/outlines/draw_it/" + "image_5" + ".png" }, { name: "draw_image_6", url: "images/outlines/draw_it/" + "image_6" + ".png" }, { name: "draw_image_7", url: "images/outlines/draw_it/" + "image_7" + ".png" }, { name: "draw_image_8", url: "images/outlines/draw_it/" + "image_8" + ".png" }, { name: "draw_image_9", url: "images/outlines/draw_it/" + "image_9" + ".png" }, { name: "draw_image_10", url: "images/outlines/draw_it/" + "image_10" + ".png" },

            // bgs.
            { name: "splash_bg", url: "images/bg/" + "splash_bg" + ".jpg" }, { name: "bg", url: "images/bg/" + "bg_1x" + ".jpg" },
            // fonts.

            // particles.
            { name: "eraser_ps", url: "particles/" + "particle_emitter_eraser_loop_00" + ".json" }, { name: "ink_ps", url: "particles/" + "particle_emitter_ink_loop_00" + ".json" }, { name: "ink_splatter_ps", url: "particles/" + "particle_emitter_inksplatter_loop_01" + ".json" }, { name: "brush_ps", url: "particles/" + "particle_emitter_paintbrush_loop_00" + ".json" }, { name: "pencil_ps", url: "particles/" + "particle_emitter_pencil_loop_00" + ".json" }, { name: "spray_ps", url: "particles/" + "particle_emitter_spray_loop_00" + ".json" }, { name: "stamp_ps", url: "particles/" + "particle_emitter_stamo_burst_00" + ".json" }, { name: "fill_ps", url: "particles/" + "particle_paintfill_burst_00" + ".json" },

            //--spine--//
            { name: "tutorial_hand", url: "images/" + "tutorial_hand" + ".json" }];
            var music = ["music_mainmenu_loop_00", "music_ready_loop_012"];
            var genericSfx = ["sfx_ambient_desert_loop_00", "sfx_drawer_hide_00", "sfx_drawer_reveal_00", "sfx_generic_colour_type_change_00", "sfx_tool_eraser_loop_03", "sfx_tool_eraser_select_00", "sfx_tool_inkpot_select_00", "sfx_tool_inkpot_use_splat_00", "sfx_tool_magictape_select_00", "sfx_tool_magictape_use_end_only_00", "sfx_tool_magictape_use_loop_00", "sfx_tool_paintbrush_dry_use_loop_00", "sfx_tool_paintbrush_select_00", "sfx_tool_paintbrush_wet_use_loop_00", "sfx_tool_paintpot_fill_select_01", "sfx_tool_paintpot_fill_use_02", "sfx_tool_pencil_select_00", "sfx_tool_pencil_use_loop_00", "sfx_tool_spraycan_select_00", "sfx_tool_spraycan_use_loop_00", "sfx_tool_stamp_use_00", "sfx_tool_stamps_select_00", "sfx_tool_sticker_end_only", "sfx_tool_sticker_place_00", "sfx_tool_sticker_use_00", "sfx_tool_stickers_select_00", "sfx_tool_trashcan_confirm_00", "sfx_tool_trashcan_select_00", "sfx_tool_undo_step_back_00", "sfx_ui_folder_save_00", "sfx_ui_newpage_00", "sfx_palette_select_00", "sfx_palette_close_00", "sfx_ui_carousel_swipe_00", "sfx_ui_click_00", "sfx_ui_rollover_00",
            //  "vo_happo_ok_00",
            //   "vo_happo_ooh_00",
            //   "vo_happo_ready_00",
            "sfx_btn_play_start_doorbell_00"];
            if (files.length) {
                this._preloader = new _PreloaderScene2.default();
                _Common2.default.scene.add(this._preloader);

                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.progress.add(this.onLoadingProgress, this);
                _Common2.default.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
                _Common2.default.assets.load();

                _Common2.default.audio.addSounds(music, [".m4a", ".ogg", ".mp3"], "assets/audio/music/");
                _Common2.default.audio.addSounds(genericSfx, [".m4a", ".ogg", ".mp3"], "assets/audio/sfx/");
            } else {
                this.startGame();
            }
        }
    }, {
        key: "createConfig",
        value: function createConfig() {
            var assets = _Common2.default.assets;

            var config = {};
            _Common2.default.config = config;
        }
    }, {
        key: "startGame",
        value: function startGame() {

            delay(function () {
                if (!_ismobilejs2.default.any) _Application2.default.init();
            }, 1.0, this);
        }
    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            this._preloader.loaded = event.progress / 100.0;
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            _Common2.default.assets.signals.progress.removeAll();
            _Common2.default.assets.signals.complete.removeAll();
            _Common2.default.finishedLoading = true;
            this._preloader.loaded = 1;

            this.startGame(1);
        }

        /**
         * @param {boolean} correct
         */

    }, {
        key: "onCanvasResize",
        value: function onCanvasResize(correct) {
            if (correct) {
                _Common2.default.renderer.resize(P3.View.width, P3.View.height);
                if (_Common2.default.scene) {
                    _Common2.default.scene.resize();
                }
            }
        }
    }]);

    return Main;
}();

exports.default = Main;


window.Main = Main;

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */
function simpleText(copy, fontName, size, holder, colour) {
    var col = colour | 0x000000;
    var textView = new PIXI.Text(copy, { fontFamily: fontName, fontSize: size, fill: col });
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    return textView;
}
P3.simpleText = simpleText;

/**
 * Creates and returns a new UI button
 * @param point {PIXI.Point}
 * @param type
 * @param callback
 * @param scope
 * @param params
 * @returns {Button}
 */
/*
 function createButton(point, type, callback, scope, params = {holder: null, text: null, icon: null}) {

 const states = new P3.ButtonStates();

 if (!type || type === "blank") {

 states.normal = PIXI.Texture.EMPTY;
 states.down = PIXI.Texture.EMPTY;

 } else if (typeof type === "string") {

 if (Common.assets.hasTexture("btn_" + type + "_up")) {
 states.normal = Common.assets.texture("btn_" + type + "_up");
 } else if (Common.assets.hasTexture("buttons/ui_" + "btn_" + type + "_up")) {
 states.normal = Common.assets.texture("buttons/ui_" + "btn_" + type + "_up");
 }

 if (Common.assets.hasTexture("btn_" + type + "_down")) {
 states.down = Common.assets.texture("btn_" + type + "_down");
 } else if (Common.assets.texture("buttons/ui_" + "btn_" + type + "_down")) {
 states.down = Common.assets.texture("buttons/ui_" + "btn_" + type + "_down");
 }

 if (Common.assets.hasTexture("btn_" + type + "_over")) {
 states.over = Common.assets.texture("btn_" + type + "_over");
 }

 } else {

 states.normal = type;

 }

 const button = new Button(states);
 button.x = point.x;
 button.y = point.y;
 button.anchor = new PIXI.Point(0.5, 0.5);
 button.animate = true;

 button.signals.click.add(callback, scope);

 //  buttons/ui_icon_close

 if (params) {
 if (params.holder) {
 params.holder.addChild(button);
 }
 if (params.icon) {
 let sp;
 if (Common.assets.hasTexture(params.icon)) {
 sp = P3.createSprite(params.icon);
 } else {
 sp = P3.createSprite("buttons/ui_" + params.icon);
 }
 sp.anchor.set(0.5);
 button.addChild(sp);
 button.icon = sp;
 }
 if (params.text) {
 let txtView = P3.simpleText(params.text, "consolas", 45, button, 0xffffff);//new PIXI.extras.BitmapText(text, {font: "45px Calibri"});
 txtView.anchor = {x: 0.5, y: 0.5};
 button.txtView = txtView;
 }
 }

 return button;
 }
 P3.createButton = createButton;
 */

/**
 * @param copy {string}
 * @param config {object}
 * @param override {string} - overrides default language font type
 * @param jsonName
 * @returns {PIXI.Text|PIXI.BitmapText}
 */
function createText(copy, config, override, jsonName) {
    var textView, conf;
    var str = jsonName || "languages";
    if (_Common2.default.language === "ar") {
        conf = {
            font: config.size + " Noto Kufi Arabic",
            fill: config.fill,
            align: "center",
            //  letterSpacing: 5,
            padding: config.padding || 0
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 4 || config.strokeThickness;
        }
        Object.assign(conf, config);
        textView = new PIXI.Text(_Common2.default.assets.getJSON(str)[copy][_Common2.default.language], conf);
    } else {
        conf = {
            font: config.size + " Duality",
            fill: config.fill,
            align: "center",
            letterSpacing: 4,
            padding: config.padding || 0,
            lineJoin: "round"
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 8;
        }
        Object.assign(conf, config);
        textView = new PIXI.Text(_Common2.default.assets.getJSON(str)[copy][_Common2.default.language], conf);
    }

    return textView;
}
P3.createText = createText;

/**
 * @param copy {string}
 * @param config
 */
function createMultiText(copy, config) {
    var textView, conf;
    var str = "languages";
    if (_Common2.default.language === "ar") {
        conf = {
            font: config.size + " Noto Kufi Arabic",
            fill: config.fill,
            align: "center",
            padding: config.padding || 0
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 4 || config.strokeThickness;
        }
        textView = new PIXI.Text(_Common2.default.assets.getJSON(str)[copy][_Common2.default.language], conf);
    } else {
        conf = {
            font: config.size + " Duality",
            fill: 0xffffff,
            align: "center",
            letterSpacing: 4,
            padding: config.padding || 0,
            lineJoin: "round"
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 8;
        }

        //LOL...
        var confCopy = Object.assign({}, conf);
        delete confCopy.fill;
        var realConfig = { //deliberately made larger than needs to be, trying to ovoid overflow
            "default": conf,
            "s0": Object.assign({ fill: "#fff200" }, confCopy), //
            "s1": Object.assign({ fill: "#00bff3" }, confCopy), //
            "s2": Object.assign({ fill: "#00a650" }, confCopy), //
            "s3": Object.assign({ fill: "#00bff3" }, confCopy), //
            "s4": Object.assign({ fill: "#ff4b96" }, confCopy), //
            "s5": Object.assign({ fill: "#ff2600" }, confCopy), //red
            "s6": Object.assign({ fill: "#f26522" }, confCopy), //orange
            "s7": Object.assign({ fill: "#fff200" }, confCopy), //yellow
            "s8": Object.assign({ fill: "#00a650" }, confCopy), //green
            "s9": Object.assign({ fill: "#fff200" }, confCopy),
            "s10": Object.assign({ fill: "#00bff3" }, confCopy),
            "s11": Object.assign({ fill: "#00a650" }, confCopy),
            "s12": Object.assign({ fill: "#00bff3" }, confCopy),
            "s13": Object.assign({ fill: "#ff4b96" }, confCopy),
            "s14": Object.assign({ fill: "#f26522" }, confCopy),
            "s15": Object.assign({ fill: "#fff200" }, confCopy),
            "s16": Object.assign({ fill: "#00a650" }, confCopy),
            "s17": Object.assign({ fill: "#ff2600" }, confCopy),
            "s18": Object.assign({ fill: "#00a650" }, confCopy),
            "s19": Object.assign({ fill: "#00a650" }, confCopy),
            "s20": Object.assign({ fill: "#00a650" }, confCopy),
            "s21": Object.assign({ fill: "#00a650" }, confCopy),
            "s22": Object.assign({ fill: "#00a650" }, confCopy),
            "s23": Object.assign({ fill: "#00a650" }, confCopy)
        };

        var realCopy = _Common2.default.assets.getJSON(str)[copy][_Common2.default.language];
        var copyArr = realCopy.split("");
        var finalCopy = "";
        for (var i = 0; i < copyArr.length; i++) {
            finalCopy += "<s" + i + ">";
            finalCopy += copyArr[i];
            finalCopy += "</s" + i + ">";
        }

        //--create the text--//
        textView = new _pixiMultistyleText2.default(finalCopy, realConfig);
    }

    return textView;
}
P3.createMultiText = createMultiText;

function createButton(icon, type) {
    type = type || 'primary_small';
    var buttonStates = new P3.ButtonStates(_Common2.default.assets.getTexture('btn_' + type + '_off'), _Common2.default.assets.getTexture('btn_' + type + '_over'), _Common2.default.assets.getTexture('btn_' + type + '_down'), _Common2.default.assets.getTexture("icon_" + icon + '_off'));

    buttonStates.iconOver = _Common2.default.assets.getTexture("icon_" + icon + '_over');
    buttonStates.iconDown = _Common2.default.assets.getTexture("icon_" + icon + '_down');

    var button = void 0;
    if (icon === 'sound') {
        buttonStates.iconAlt = _Common2.default.assets.getTexture('icon_' + "mute" + '_off');
        buttonStates.iconOverAlt = _Common2.default.assets.getTexture('icon_' + "mute" + '_over');
        buttonStates.iconDownAlt = _Common2.default.assets.getTexture('icon_' + "mute" + '_down');
        button = new P3.MuteButton(buttonStates);
    } else {
        button = new P3.Button(buttonStates);
    }
    return button;
}

window.createButton = createButton;

function Timestep() {}
Timestep.deltaTime = 0;
P3.Timestep = Timestep;

},{"./Application":2,"./Common":3,"./pixi-multistyle-text":26,"./scenes/PreloaderScene":31,"ismobilejs":1}],6:[function(require,module,exports){
"use strict";

var Common = require("./Common");
var CommonGame = require("./CommonGame");

//===================================================
//
// Constructor
//
//===================================================

function SavedData() {
	var assetManager = P3.AssetManager.instance;

	/**
  * @type {String}
  * @const
  */
	this.SAVE_NAME = "customer_focus";
	this.SAVE_VERSION = "0.0.18";
	this.SAVE_SEED = "y5k0Eo6R177mUkb";

	/**
  * @type {Boolean}
  */
	this._isToolTutorial = true;
	this._isDrawTutorial = true;
	this._isPaletteTutorial = true;
}
module.exports = SavedData;

//===================================================
//
// Public
//
//===================================================

SavedData.prototype.init = function () {
	if (!window.localStorage[this.SAVE_NAME + "_" + this.SAVE_VERSION]) {
		//console.log( 'reset' );
		this.reset();
		this.save();
	} else {
		//console.log( 'load' );
		this.load();
	}
};

SavedData.prototype.reset = function () {
	this._isToolTutorial = true;
	this._isDrawTutorial = true;
	this._isPaletteTutorial = true;
};

SavedData.prototype.load = function () {
	var data = window.localStorage[this.SAVE_NAME + "_" + this.SAVE_VERSION];
	data = JSON.parse(data);

	this._isToolTutorial = data.isToolTutorial;
	this._isDrawTutorial = data.isDrawTutorial;
	this._isPaletteTutorial = data.isPaletteTutorial;
};

SavedData.prototype.save = function () {
	//console.log( 'save' );
	var data = {};
	data.isToolTutorial = this._isToolTutorial;
	data.isDrawTutorial = this._isDrawTutorial;
	data.isPaletteTutorial = this._isPaletteTutorial;

	var json = JSON.stringify(data);
	data.hash = md5(json + this.SAVE_SEED);

	window.localStorage[this.SAVE_NAME + "_" + this.SAVE_VERSION] = JSON.stringify(data);
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(SavedData.prototype, "isToolTutorial", { get: function get() {
		return this._isToolTutorial;
	},
	set: function set(a) {
		this._isToolTutorial = a;
	} });

Object.defineProperty(SavedData.prototype, "isDrawTutorial", { get: function get() {
		return this._isDrawTutorial;
	},
	set: function set(a) {
		this._isDrawTutorial = a;
	} });

Object.defineProperty(SavedData.prototype, "isPaletteTutorial", { get: function get() {
		return this._isPaletteTutorial;
	},
	set: function set(a) {
		this._isPaletteTutorial = a;
	} });

},{"./Common":3,"./CommonGame":4}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

var _MagicBrush = require("./MagicBrush");

var _MagicBrush2 = _interopRequireDefault(_MagicBrush);

var _ColourBrush = require("./ColourBrush");

var _ColourBrush2 = _interopRequireDefault(_ColourBrush);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Brush() {
    // Attributes.
    this._drawLayer = null;
    this._magicBrush = null;
    this._colourBrush = null;
    this._paletteItem = null;
    this._curBrush = null;
    this._audio = null;
}
exports.default = Brush;
//module.exports = Brush;

Brush.prototype.constructor = Brush;

//===================================================
//
// Public
//
//===================================================

Brush.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;

    // Magic brush.
    this._magicBrush = new _MagicBrush2.default();
    this._magicBrush.init(drawLayer);

    // Colour brush.
    this._colourBrush = new _ColourBrush2.default();
    this._colourBrush.init(drawLayer);

    // Set initial brush.
    this._curBrush = this._colourBrush;
    this._curBrush.colour = _Common2.default.assets.getJSON("config").palettePanel.pages[0][0];
    this._paletteItem = this._curBrush.colour;

    // Signals.
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

Brush.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};

//===================================================
//
// Private
//
//===================================================

Brush.prototype._draw = function (from, to) {
    // TEST: DYN_OUT:
    var dynOutlineContext = _Common2.default.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.beginPath();
    dynOutlineContext.strokeStyle = "black";
    dynOutlineContext.lineWidth = this._curBrush.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(from.x, from.y);
    dynOutlineContext.lineTo(to.x, to.y);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();
};

Brush.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};

//===================================================
//
// Events
//
//===================================================

Brush.prototype.onDrawBegan = function (point) {
    this._curBrush.onDrawBegan(point);
    // TEST: DYN_OUT:
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

Brush.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null) this._audio = _Common2.default.audio.playSound("sfx_tool_paintbrush_wet_use_loop_00", { "loop": true });
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);

    this._curBrush.onDrawMoved(from, to);
    // TEST: DYN_OUT:
    this._draw(from, to);
};

Brush.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null) this._stopAudio();

    // TEST: DYN_OUT:
    _Common2.default.game.canvas.drawLayer.dynOutlineData = _Common2.default.game.canvas.drawLayer.dynOutlineContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);
};

Brush.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) {
        this._curBrush = this._colourBrush;
        this._colourBrush.colour = selection;
    } else {
        this._curBrush = this._magicBrush;
        this._magicBrush.textureId = selection;
    }

    this._paletteItem = selection;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(Brush.prototype, "paletteItem", {
    get: function get() {
        return this._paletteItem;
    }
});

},{"../Common":3,"../ui/overlays/PalettePanel":38,"./ColourBrush":9,"./MagicBrush":16}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _MyGame = require("./MyGame");

var _MyGame2 = _interopRequireDefault(_MyGame);

var _FillLayer = require("./FillLayer");

var _FillLayer2 = _interopRequireDefault(_FillLayer);

var _DrawLayer = require("./DrawLayer");

var _DrawLayer2 = _interopRequireDefault(_DrawLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Canvas() {
    PIXI.Container.call(this);

    // Attributes.
    this._fillLayer = null;
    this._drawLayer = null;

    // Sprites.
    this._bgSprite = null;
    this._borderSprite = null;

    // Constants.
    this.WIDTH = _CommonGame2.default.CANVAS_WIDTH; //Common.STAGE_WIDTH
    this.HEIGHT = _CommonGame2.default.CANVAS_HEIGHT; //Common.STAGE_HEIGHT
}
exports.default = Canvas;
//module.exports = Canvas;

Canvas.prototype = Object.create(PIXI.Container.prototype);
Canvas.prototype.constructor = Canvas;

//===================================================
//
// Public
//
//===================================================

Canvas.prototype.init = function () {
    // Bg.
    this.addChild(_CommonGame2.default.createCanvasBg());

    this._bgSprite = new PIXI.Sprite(_Common2.default.blankTexture);
    this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._bgSprite.width = this.WIDTH;
    this._bgSprite.height = this.HEIGHT;
    this._bgSprite.tint = 0xffffff;

    this.addChild(this._bgSprite);

    // Layers.
    // Fill.
    this._fillLayer = new _FillLayer2.default();
    this._fillLayer.init();
    this.addChild(this._fillLayer);
    // Draw.
    this._drawLayer = new _DrawLayer2.default();
    this._drawLayer.init();
    this.addChild(this._drawLayer);

    var galleryKey = "drawing";
    if (_CommonGame2.default.selectedGallery === 1) galleryKey = "colouring";

    // Border.
    this._borderSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("canvas_" + galleryKey));
    this._borderSprite.anchor = new PIXI.Point(0.5, 0.5);
    this.addChild(this._borderSprite);

    // Listen to HUD controls.
    _Common2.default.game.hud.signals.onDrawModeChanged.add(this._onDrawMode_Changed, this);

    // Start with the pencil
    this._onDrawMode_Changed(_CommonGame2.default.TOOL.PENCIL);
};

Canvas.prototype.update = function () {
    this._fillLayer.update();
    this._drawLayer.update();
};

Canvas.prototype.animateIn = function () {
    this.y -= 100;
    this.alpha = 0;
    TweenMax.to(this, 0.25, {
        alpha: 1,
        y: this.y + 100,
        ease: Sine.easeOut,
        onComplete: function onComplete() {
            _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.CANVAS_VISIBLE);
        },
        onCompleteScope: this
    });
};

Canvas.prototype.clear = function () {
    this._fillLayer.clear();
    this._drawLayer.clear();
};

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

Canvas.prototype._onDrawMode_Changed = function (selection) {
    if (selection == _CommonGame2.default.TOOL.PENCIL || selection == _CommonGame2.default.TOOL.BRUSH || selection == _CommonGame2.default.TOOL.SPRAY || selection == _CommonGame2.default.TOOL.STAMP || selection == _CommonGame2.default.TOOL.INK_POT || selection == _CommonGame2.default.TOOL.ERASER) {
        this._drawLayer.setEnabled(true);
        this._fillLayer.setEnabled(false);
    } else if (selection == _CommonGame2.default.TOOL.BUCKET) {
        this._drawLayer.setEnabled(false);
        this._fillLayer.setEnabled(true);
    }

    // Sfx.
    _Common2.default.audio.playSound("sfx_tool_paintbrush_select_00");
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(Canvas.prototype, "fillLayer", {
    get: function get() {
        return this._fillLayer;
    }
});

Object.defineProperty(Canvas.prototype, "drawLayer", {
    get: function get() {
        return this._drawLayer;
    }
});

},{"../Common":3,"../CommonGame":4,"./DrawLayer":11,"./FillLayer":13,"./MyGame":18}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function ColourBrush() {
    // Constants.
    this.LINE_THICKNESS = 10;

    // Attributes.
    this._drawLayer = null;
    this._colour = null;
}
exports.default = ColourBrush;
//module.exports               		= ColourBrush;

ColourBrush.prototype.constructor = ColourBrush;

//===================================================
//
// Public
//
//===================================================

ColourBrush.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
};

//===================================================
//
// Private
//
//===================================================

ColourBrush.prototype._draw = function (start, end) {
    var dist = Math.round(_Common2.default.distanceBetween(start, end));
    var angle = _Common2.default.angleBetween(start, end);

    var lastX = Math.round(start.x + Math.sin(angle) * dist),
        lastY = Math.round(start.y + Math.cos(angle) * dist);

    for (var i = 0; i < dist; i += 3) {
        var x = Math.round(start.x + Math.sin(angle) * i);
        var y = Math.round(start.y + Math.cos(angle) * i);

        var radGrad = this._drawLayer.context.createRadialGradient(lastX, lastY, this.LINE_THICKNESS, x, y, 0);
        var rgbColour = _Common2.default.hexToRgb(this._colour);
        radGrad.addColorStop(0, "rgba( " + rgbColour.r + "," + rgbColour.g + "," + rgbColour.b + ", 0 )");
        radGrad.addColorStop(1, "rgba( " + rgbColour.r + "," + rgbColour.g + "," + rgbColour.b + ", 1 )");

        this._drawLayer.context.fillStyle = radGrad;
        this._drawLayer.context.fillRect(x - this.LINE_THICKNESS, y - this.LINE_THICKNESS, this.LINE_THICKNESS * 2, this.LINE_THICKNESS * 2);

        lastX = x;
        lastY = y;
    }

    this._drawLayer.onContext_Changed();
};

//===================================================
//
// Events
//
//===================================================

ColourBrush.prototype.onDrawBegan = function (point) {
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

ColourBrush.prototype.onDrawMoved = function (from, to) {
    this._draw(from, to);
};

ColourBrush.prototype.onDrawEnded = function () {};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(ColourBrush.prototype, "colour", {
    get: function get() {
        return this._colour;
    },
    set: function set(a) {
        this._colour = a;
    }
});

},{"../Common":3}],10:[function(require,module,exports){
"use strict";

var Common = require("../Common");
var CommonGame = require("../CommonGame");

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function ColourPencil() {
	// Constants.
	this.LINE_THICKNESS = 5;

	// Attributes.
	this._drawLayer = null;
	this._colour = null;
}
module.exports = ColourPencil;
ColourPencil.prototype.constructor = ColourPencil;

//===================================================
//
// Public
//
//===================================================

ColourPencil.prototype.init = function (drawLayer) {
	this._drawLayer = drawLayer;
};

//===================================================
//
// Private
//
//===================================================

ColourPencil.prototype._draw = function (from, to) {
	this._drawLayer.context.beginPath();
	this._drawLayer.context.strokeStyle = this._colour;
	this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
	this._drawLayer.context.lineJoin = "round";
	this._drawLayer.context.moveTo(from.x, from.y);
	this._drawLayer.context.lineTo(to.x, to.y);
	this._drawLayer.context.closePath();
	this._drawLayer.context.stroke();

	this._drawLayer.onContext_Changed();
};

//===================================================
//
// Events
//
//===================================================

ColourPencil.prototype.onDrawBegan = function (point) {
	this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

ColourPencil.prototype.onDrawMoved = function (from, to) {
	this._draw(from, to);
};

ColourPencil.prototype.onDrawEnded = function () {};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(ColourPencil.prototype, "colour", { get: function get() {
		return this._colour;
	},
	set: function set(a) {
		this._colour = a;
	} });

},{"../Common":3,"../CommonGame":4}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _Pencil = require("./Pencil");

var _Pencil2 = _interopRequireDefault(_Pencil);

var _InkPot = require("./InkPot");

var _InkPot2 = _interopRequireDefault(_InkPot);

var _Brush = require("./Brush");

var _Brush2 = _interopRequireDefault(_Brush);

var _Spray = require("./Spray");

var _Spray2 = _interopRequireDefault(_Spray);

var _Stamp = require("./Stamp");

var _Stamp2 = _interopRequireDefault(_Stamp);

var _Eraser = require("./Eraser");

var _Eraser2 = _interopRequireDefault(_Eraser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function DrawLayer() {
    PIXI.Container.call(this);

    // States.
    this.STATE = {
        IDLE: 0,
        DRAWING: 1
    };

    // Attributes.
    this._state = this.STATE.IDLE;

    this._canvas2d = null;
    this._context = null;

    // TEST: DYN_OUT:
    this._dynOutline_c2d = null;
    this._dynOutlineContext = null;
    this._dynOutlineLayerData = null;

    this._pencil = null;
    this._brush = null;
    this._spray = null;
    this._stamp = null;
    this._inkPot = null;
    this._drawingTool = null;
    this._eraser = null;

    this._drawPS = null;

    // Sprites.
    this._layerSprite = null;

    // Input.
    this._lastInputLocalPosition = new PIXI.Point();
    this._updateInputLocalPosition = new PIXI.Point();
}
exports.default = DrawLayer;
//module.exports = DrawLayer;

DrawLayer.prototype = Object.create(PIXI.Container.prototype);
DrawLayer.prototype.constructor = DrawLayer;

//===================================================
//
// Public
//
//===================================================

DrawLayer.prototype.init = function () {
    // Canvas.
    this._canvas2d = document.createElement('canvas');
    this._canvas2d.width = _Common2.default.game.canvas.WIDTH;
    this._canvas2d.height = _Common2.default.game.canvas.HEIGHT;

    // Context.
    this._context = this._canvas2d.getContext('2d');

    // TEST: DYN_OUT:
    this._dynOutline_c2d = document.createElement('canvas');
    this._dynOutline_c2d.width = _Common2.default.game.canvas.WIDTH;
    this._dynOutline_c2d.height = _Common2.default.game.canvas.HEIGHT;

    this._dynOutlineContext = this._dynOutline_c2d.getContext('2d');
    this._dynOutlineContext.fillStyle = 'rgba(0, 0, 0, 0)';
    this._dynOutlineContext.fillRect(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    this._dynOutlineLayerData = this._dynOutlineContext.getImageData(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    // Tools.
    // Pencil.
    this._pencil = new _Pencil2.default();
    this._pencil.init(this);
    // Brush.
    this._brush = new _Brush2.default();
    this._brush.init(this);
    // Spray.
    this._spray = new _Spray2.default();
    this._spray.init(this);
    // Stamp.
    this._stamp = new _Stamp2.default();
    this._stamp.init(this);
    // Ink pot.
    this._inkPot = new _InkPot2.default();
    this._inkPot.init(this);
    // Eraser.
    this._eraser = new _Eraser2.default();
    this._eraser.init(this, _Common2.default.game.canvas.fillLayer);

    // Layer.
    this._layerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._canvas2d));
    this._layerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._layerSprite.interactive = true;
    this._layerSprite.mousedown = this._layerSprite.touchstart = this._onDrawLayer_MouseDown.bind(this);
    this._layerSprite.mousemove = this._layerSprite.touchmove = this._onDrawLayer_MouseMove.bind(this);
    this._layerSprite.mouseup = this._layerSprite.touchend = this._onDrawLayer_MouseUp.bind(this);
    this._layerSprite.mouseupoutside = this._layerSprite.touchendoutside = this._onDrawLayer_MouseOut.bind(this);
    this.addChild(this._layerSprite);

    // Default tool.
    this._onDrawMode_Changed(_CommonGame2.default.TOOL.PENCIL);

    // Listen to HUD controls.
    _Common2.default.game.hud.signals.onDrawModeChanged.add(this._onDrawMode_Changed, this);
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

DrawLayer.prototype.setEnabled = function (isEnabled) {
    this._layerSprite.interactive = isEnabled;
};

DrawLayer.prototype.update = function () {
    // Vfx.
    this._drawPS.update(P3.Timestep.deltaTime);

    if (this._drawingTool != this._spray && this._drawPS.emit && this._lastInputLocalPosition.x == this._updateInputLocalPosition.x && this._lastInputLocalPosition.y == this._updateInputLocalPosition.y) this._drawPS.emit = false;

    this._updateInputLocalPosition.x = this._lastInputLocalPosition.x;
    this._updateInputLocalPosition.y = this._lastInputLocalPosition.y;
};

DrawLayer.prototype.setLayerData = function (data, dynOutlineData) {
    this._context.putImageData(data, 0, 0);

    this._dynOutlineLayerData = dynOutlineData;
    this._dynOutlineContext.putImageData(dynOutlineData, 0, 0);

    this._layerSprite.texture.update();
};

DrawLayer.prototype.clear = function () {
    this._dynOutlineContext.clearRect(0, 0, this._canvas2d.width, this._canvas2d.height);
    this._dynOutlineLayerData = this._dynOutlineContext.getImageData(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    this._context.clearRect(0, 0, this._canvas2d.width, this._canvas2d.height);

    this._layerSprite.texture.update();
};

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

DrawLayer.prototype.onContext_Changed = function () {
    // Tutorial.
    _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.CANVAS_DRAWN);

    this._layerSprite.texture.update();
};

DrawLayer.prototype._onDrawLayer_MouseDown = function (mouseData) {
    //console.log( "mousedown" );

    // Undo manager.
    _Common2.default.game.undoManager.save();

    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._layerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + _Common2.default.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + _Common2.default.game.canvas.HEIGHT * 0.5);

    this._lastInputLocalPosition = new PIXI.Point(ctxCoordPosition.x, ctxCoordPosition.y);
    this._state = this.STATE.DRAWING;

    this._drawingTool.onDrawBegan(ctxCoordPosition);

    // Vfx.
    if (this._drawingTool == this._stamp || this._drawingTool == this._spray) {
        this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
        this._drawPS.emit = true;
    }
};

DrawLayer.prototype._onDrawLayer_MouseMove = function (mouseData) {
    //console.log( "mousemove" );

    if (this._state != this.STATE.DRAWING) return;

    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._layerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + _Common2.default.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + _Common2.default.game.canvas.HEIGHT * 0.5);

    this._drawingTool.onDrawMoved(this._lastInputLocalPosition, ctxCoordPosition);

    this._lastInputLocalPosition.x = ctxCoordPosition.x;
    this._lastInputLocalPosition.y = ctxCoordPosition.y;

    // Vfx.
    if (this._drawingTool != this._stamp) {
        if (!this._drawPS.emit) {
            this._drawPS.resetPositionTracking();
            this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
            this._drawPS.emit = true;
        } else this._drawPS.updateSpawnPos(localCoordsPosition.x, localCoordsPosition.y);
    }
};

DrawLayer.prototype._onDrawLayer_MouseUp = function (mouseData) {
    //console.log( "mouseup" );

    if (this._state == this.STATE.DRAWING) {
        this._drawingTool.onDrawEnded();

        this._state = this.STATE.IDLE;

        // Vfx.
        if (this._drawingTool != this._stamp) this._drawPS.emit = false;
    }
};

DrawLayer.prototype._onDrawLayer_MouseOut = function (mouseData) {
    //console.log( "mouseout" );

    if (this._state == this.STATE.DRAWING) {
        this._drawingTool.onDrawEnded();

        this._state = this.STATE.IDLE;
    }

    // Vfx.
    this._drawPS.emit = false;
};

DrawLayer.prototype._onThickness_Changed = function (selection) {
    this._thickness = this.BASE_LINE_THICKNESS * (selection + 1);
};

DrawLayer.prototype._onColour_Changed = function (selection) {
    if (this._drawingTool == this._pencil || this._drawingTool == this._brush || this._drawingTool == this._spray || this._drawingTool == this._inkPot) {
        var rgbColour = { r: 255, g: 255, b: 255 };

        if (this._drawingTool.paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._drawingTool.paletteItem);

        this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
        this._drawPS.endColor = this._drawPS.startColor;
    }
};

DrawLayer.prototype._onDrawMode_Changed = function (selection) {
    var rgbColour = { r: 255, g: 255, b: 255 };

    switch (selection) {
        case _CommonGame2.default.TOOL.PENCIL:
            {
                this._drawingTool = this._pencil;

                // Vfx.
                if (this._drawingTool.paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._drawingTool.paletteItem);
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_draw")], _Common2.default.assets.getJSON("pencil_ps"));
                this._drawPS.emitterLifetime = -1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_pencil_select_00" );
                break;
            }

        case _CommonGame2.default.TOOL.BRUSH:
            {
                this._drawingTool = this._brush;

                // Vfx.
                if (this._drawingTool.paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._drawingTool.paletteItem);
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_paintbrush")], _Common2.default.assets.getJSON("brush_ps"));
                this._drawPS.emitterLifetime = -1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_paintbrush_select_00" );
                break;
            }

        case _CommonGame2.default.TOOL.SPRAY:
            {
                this._drawingTool = this._spray;

                // Vfx.
                if (this._drawingTool.paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._drawingTool.paletteItem);
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_spray")], _Common2.default.assets.getJSON("spray_ps"));
                this._drawPS.emitterLifetime = -1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_spraycan_select_00" );
                break;
            }

        case _CommonGame2.default.TOOL.STAMP:
            {
                this._drawingTool = this._stamp;

                // Vfx.
                rgbColour = _Common2.default.hexToRgb("#ffe400");
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_stamp")], _Common2.default.assets.getJSON("stamp_ps"));
                this._drawPS.emitterLifetime = 0.1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_stamps_select_00" );
                break;
            }

        case _CommonGame2.default.TOOL.INK_POT:
            {
                this._drawingTool = this._inkPot;

                // Vfx.
                if (this._drawingTool.paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._drawingTool.paletteItem);
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_ink_splatter")], _Common2.default.assets.getJSON("ink_splatter_ps"));
                this._drawPS.emitterLifetime = -1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_inkpot_select_00" );
                break;
            }

        case _CommonGame2.default.TOOL.ERASER:
            {
                this._drawingTool = this._eraser;

                // Vfx.
                rgbColour = _Common2.default.hexToRgb("#fd93bd");
                this._drawPS = new PIXI.particles.Emitter(this, [_Common2.default.assets.getTexture("particle_erase")], _Common2.default.assets.getJSON("eraser_ps"));
                this._drawPS.emitterLifetime = -1;

                // Sfx.
                //Common.audio.playSound( "sfx_tool_eraser_select_00" );
                break;
            }
    }

    this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
    this._drawPS.endColor = this._drawPS.startColor;
    this._drawPS.emit = false;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(DrawLayer.prototype, "context", {
    get: function get() {
        return this._context;
    }
});

Object.defineProperty(DrawLayer.prototype, "dynOutlineContext", {
    get: function get() {
        return this._dynOutlineContext;
    }
});

Object.defineProperty(DrawLayer.prototype, "state", {
    get: function get() {
        return this._state;
    }
});

Object.defineProperty(DrawLayer.prototype, "drawingTool", {
    get: function get() {
        return this._drawingTool;
    }
});

Object.defineProperty(DrawLayer.prototype, "dynOutlineData", {
    get: function get() {
        return this._dynOutlineLayerData;
    },
    set: function set(a) {
        return this._dynOutlineLayerData = a;
    }
});

},{"../Common":3,"../CommonGame":4,"./Brush":7,"./Eraser":12,"./InkPot":15,"./Pencil":20,"./Spray":21,"./Stamp":22}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Eraser() {
    // Constants.
    this.LINE_THICKNESS = 10;

    // Attributes.
    this._drawLayer = null;
    this._fillLayer = null;
    this._audio = null;
    this._arrCanvasContext = [];
}
exports.default = Eraser;
//module.exports               	= Eraser;

Eraser.prototype.constructor = Eraser;

//===================================================
//
// Public
//
//===================================================

Eraser.prototype.init = function (drawLayer, fillLayer) {
    this._drawLayer = drawLayer;
    this._fillLayer = fillLayer;

    this._arrCanvasContext.push(this._drawLayer.context);
    this._arrCanvasContext.push(this._fillLayer._colourContext);
    this._arrCanvasContext.push(this._fillLayer._colourCodeContext);
};

//===================================================
//
// Private
//
//===================================================

Eraser.prototype._draw = function (context, from, to) {
    context.beginPath();
    context.lineWidth = this.LINE_THICKNESS;
    context.lineJoin = "round";
    context.moveTo(from.x, from.y);
    context.lineTo(to.x, to.y);
    context.closePath();
    context.stroke();
};

Eraser.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};

//===================================================
//
// Events
//
//===================================================

Eraser.prototype.onDrawBegan = function (point) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = this._arrCanvasContext[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var context = _step.value;

            context.save();
            context.globalCompositeOperation = "destination-out";
            context.strokeStyle = "rgba( 255, 255, 255, 255 )";

            this._draw(context, point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
        }

        // TEST: DYN_OUT:
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var dynOutlineContext = _Common2.default.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.save();
    dynOutlineContext.globalCompositeOperation = "destination-out";
    dynOutlineContext.beginPath();
    dynOutlineContext.strokeStyle = "rgba( 255, 255, 255, 255 )";
    dynOutlineContext.lineWidth = this.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(point.x, point.y);
    dynOutlineContext.lineTo(point.x + 0.1, point.y + 0.1);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();

    this._drawLayer.onContext_Changed();
    this._fillLayer.onContext_Changed();
};

Eraser.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null) this._audio = _Common2.default.audio.playSound("sfx_tool_eraser_loop_03", { "loop": true });
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);

    this._lastPosition = _Common2.default.renderer.plugins.interaction.mouse.global;

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = this._arrCanvasContext[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var context = _step2.value;

            this._draw(context, from, to);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    this._drawLayer.onContext_Changed();
    this._fillLayer.onContext_Changed();

    // TEST: DYN_OUT:
    var dynOutlineContext = _Common2.default.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.beginPath();
    dynOutlineContext.lineWidth = this.LINE_THICKNESS;
    dynOutlineContext.lineJoin = "round";
    dynOutlineContext.moveTo(from.x, from.y);
    dynOutlineContext.lineTo(to.x, to.y);
    dynOutlineContext.closePath();
    dynOutlineContext.stroke();
};

Eraser.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null) this._stopAudio();

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = this._arrCanvasContext[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var context = _step3.value;

            context.restore();
        } // TEST: DYN_OUT:
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var dynOutlineContext = _Common2.default.game.canvas.drawLayer.dynOutlineContext;
    dynOutlineContext.restore();
    _Common2.default.game.canvas.drawLayer._dynOutlineLayerData = dynOutlineContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);

    this._fillLayer.updateContextData();
};

//===================================================
//
// Getters / Setters
//
//===================================================

// TODO:

},{"../Common":3}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function FillLayer() {
    PIXI.Container.call(this);

    // Enumerators.
    this.STATE = {
        IDLE: 0,
        FILL_ANIM: 1
    };

    // Attributes.
    this._state = this.STATE.IDLE;
    this._paletteItem = null;

    this._colour_c2d = null;
    this._colourCode_c2d = null;
    this._fillAnim_c2d = null;

    this._colourContext = null;
    this._colourCodeContext = null;
    this._fillAnimContext = null;

    this._curColour = null;

    this._outlineImage = new Image();

    // Buffers.
    this._fillAnimLayerData = null;
    this._colourLayerData = null; // Contains the pixel colour for the painted areas (no outline) as they are seen on the screen.
    this._outlineLayerData = null; // Contains the pixel colour for the outline. Its content is not displayed.
    this._colourCodeLayerData = null; // Contains the pixel colour CODE for the painted areas (no outline). Its content is not displayed.
    // The flood fill algorithm implemented uses plain colours, so to make it compatible with textures it is necessary to use this auxiliary buffer.

    // Sprites.
    this._colourLayerSprite = null;
    this._fillAnimLayerSprite = null;
    this._outlineLayerSprite = null;
    this._fillAnimMask = null;

    // Input.
    this._lastInputGlobalPosition = new PIXI.Point();

    // Fill animation.
    this._fillAnimRadius = 0;
    this._fillAnimMaxDeltaX = 0;
    this._fillAnimMaxDeltaY = 0;
    this._textureStartPixelPos = -1; // The pixel position (as an index in colourLayerData ) where the selected texture is applied.

    this._drawPS = null;
}
exports.default = FillLayer;
//module.exports               		= FillLayer;

FillLayer.prototype = Object.create(PIXI.Container.prototype);
FillLayer.prototype.constructor = FillLayer;

//===================================================
//
// Public
//
//===================================================

FillLayer.prototype.init = function () {
    // Canvas.
    this._colour_c2d = document.createElement('canvas');
    this._colour_c2d.width = _Common2.default.game.canvas.WIDTH;
    this._colour_c2d.height = _Common2.default.game.canvas.HEIGHT;

    this._colourCode_c2d = document.createElement('canvas');
    this._colourCode_c2d.width = _Common2.default.game.canvas.WIDTH;
    this._colourCode_c2d.height = _Common2.default.game.canvas.HEIGHT;

    this._fillAnim_c2d = document.createElement('canvas');
    this._fillAnim_c2d.width = _Common2.default.game.canvas.WIDTH;
    this._fillAnim_c2d.height = _Common2.default.game.canvas.HEIGHT;

    // Context.
    this._colourContext = this._colour_c2d.getContext('2d');
    this._colourCodeContext = this._colourCode_c2d.getContext('2d');
    this._fillAnimContext = this._fillAnim_c2d.getContext('2d');

    // Layers.
    // Fill colour.
    this._colourLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._colour_c2d));
    this._colourLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._colourLayerSprite.interactive = true;
    this._colourLayerSprite.click = this._colourLayerSprite.touchend = this._onFillLayer_Click.bind(this);
    this.addChild(this._colourLayerSprite);
    // Fill animation.
    this._fillAnimMask = new PIXI.Graphics();
    this.addChild(this._fillAnimMask);
    this._fillAnimLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._fillAnim_c2d));
    this._fillAnimLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._fillAnimLayerSprite.mask = this._fillAnimMask;
    this.addChild(this._fillAnimLayerSprite);
    // Outline.
    var outlineTexture = PIXI.Texture.fromImage("assets/images/outlines/" + (_CommonGame2.default.selectedGallery == _CommonGame2.default.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/") + _CommonGame2.default.selectedImageId + ".png");
    this._outlineLayerSprite = new PIXI.Sprite(outlineTexture);
    var croppedOutlineTexture = new PIXI.Texture(outlineTexture, new PIXI.Rectangle(outlineTexture.width * 0.5 - _Common2.default.game.canvas.WIDTH * 0.5, outlineTexture.height * 0.5 - _Common2.default.game.canvas.HEIGHT * 0.5, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT));
    this._outlineLayerSprite.setTexture(croppedOutlineTexture);

    //this._outlineLayerSprite = new PIXI.Sprite( Common.assets.getTexture( CommonGame.selectedImageId ) );
    this._outlineLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this.addChild(this._outlineLayerSprite);

    // Buffers.
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Fill animation.
    this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
    // Colour.
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Colour code.
    this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Outline.
    this._outlineImage.src = "assets/images/outlines/" + (_CommonGame2.default.selectedGallery == _CommonGame2.default.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/") + _CommonGame2.default.selectedImageId + ".png";
    this._colourContext.drawImage(this._outlineImage, this._colourLayerSprite.width * 0.5 - this._outlineImage.width * 0.5 * this._outlineLayerSprite.scale.x, this._colourLayerSprite.height * 0.5 - this._outlineImage.height * 0.5 * this._outlineLayerSprite.scale.y, this._outlineImage.width * this._outlineLayerSprite.scale.x, this._outlineImage.height * this._outlineLayerSprite.scale.y);
    this._outlineLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    //this._colourContext.fillStyle = 'white';
    //this._colourContext.fillRect( 0, 0, this._colour_c2d.width, this._colour_c2d.height );

    // TODO: ???
    this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);

    // Initial empty canvas .
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    // Default colour.
    this._onColour_Changed(_Common2.default.assets.getJSON("config").palettePanel.pages[0][0], 0, 0);

    // Vfx.
    this._drawPS = new PIXI.particles.Emitter(this._outlineLayerSprite, [_Common2.default.assets.getTexture("particle_paintfill")], _Common2.default.assets.getJSON("fill_ps"));
    this._drawPS.emit = false;
    this._drawPS.emitterLifetime = 0.1;

    // Listen to HUD controls.
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

FillLayer.prototype.update = function () {
    // Vfx.
    this._drawPS.update(P3.Timestep.deltaTime);
};

FillLayer.prototype.setEnabled = function (isEnabled) {
    this._colourLayerSprite.interactive = isEnabled;
};

FillLayer.prototype.setLayerData = function (data, colourCodeData) {
    this._colourCodeLayerData = colourCodeData;
    this._colourCodeContext.putImageData(colourCodeData, 0, 0);
    //this._colourCodeLayerData = this._colourCodeContext.getImageData( 0, 0, this._colourCode_c2d.width, this._colourCode_c2d.height );

    this._colourLayerData = data;
    this._colourContext.putImageData(data, 0, 0);

    this._colourLayerSprite.texture.update();
};

FillLayer.prototype.clear = function () {
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    this._colourLayerSprite.texture.update();
};

FillLayer.prototype.updateContextData = function () {
    this._colourCodeLayerData = this._colourCodeContext.getImageData(0, 0, this._colourCode_c2d.width, this._colourCode_c2d.height);
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
};

//===================================================
//
// Private
//
//===================================================

FillLayer.prototype._fillAt = function (startX, startY) {
    //console.log( "_fillAt :: ini" );

    // Check same colour.
    var pixelIndex = (startY * this._colour_c2d.width + startX) * 4;
    var r = this._colourCodeLayerData.data[pixelIndex];
    var g = this._colourCodeLayerData.data[pixelIndex + 1];
    var b = this._colourCodeLayerData.data[pixelIndex + 2];
    var a = this._colourCodeLayerData.data[pixelIndex + 3];

    if (r == this._curColour.colourCode.r && g == this._curColour.colourCode.g && b == this._curColour.colourCode.b) {
        // Return because trying to fill with the same colour
        //console.log( "same colour!" );

        return;
    }

    // Check outline.
    a = this._outlineLayerData.data[pixelIndex + 3];
    if (a > 0) {
        // Return because clicked outline
        //console.log( "outline!" );

        return;
    }

    // Check dynamic outline.
    a = _Common2.default.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
    if (a > 0) {
        // Return because clicked dyn outline
        //console.log( "dyn outline!" );

        return;
    }

    // Flood fill.
    this._textureStartPixelPos = pixelIndex;
    this._floodFill(startX, startY);

    // Redraw.
    this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);
    this._colourContext.putImageData(this._colourLayerData, 0, 0);
    //this._colourLayerSprite.texture.update();

    // Filling animation.
    var targetRadius = Math.sqrt(Math.pow(this._fillAnimMaxDeltaX, 2) + Math.pow(this._fillAnimMaxDeltaY, 2));
    TweenMax.to(this, targetRadius / 600, {
        _fillAnimRadius: targetRadius,
        ease: Linear.easeInOut,
        onComplete: function onComplete() {
            this._updateFillAnimMask();

            this._fillAnimMaxDeltaX = 0;
            this._fillAnimMaxDeltaY = 0;
            this._fillAnimRadius = 0;
            this._state = this.STATE.IDLE;

            // Update layers and buffers.
            this._colourLayerSprite.texture.update();

            this._fillAnimMask.clear();

            this._fillAnimContext.clearRect(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
            this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
            this._fillAnimLayerSprite.texture.update();
        },
        onCompleteScope: this,
        onUpdate: function onUpdate() {
            this._updateFillAnimMask();
        },
        onUpdateScope: this
    });

    this._fillAnimContext.putImageData(this._fillAnimLayerData, 0, 0);
    this._fillAnimLayerSprite.texture.update();

    this._state = this.STATE.FILL_ANIM;

    //console.log( "_fillAt :: end" );
};

FillLayer.prototype._floodFill = function (startX, startY) {
    var newPos,
        x,
        y,
        pixelIndex,
        reachLeft,
        reachRight,
        drawingBoundLeft = 0,
        drawingBoundTop = 0,
        drawingBoundRight = _Common2.default.game.canvas.WIDTH - 1,
        drawingBoundBottom = _Common2.default.game.canvas.HEIGHT - 1,
        pixelStack = [[startX, startY]];

    while (pixelStack.length) {
        newPos = pixelStack.pop();
        x = newPos[0];
        y = newPos[1];

        //console.log( "dx = " + dx );
        var dx = x - startX;
        var dy = y - startY;

        // Update limits for filling animation.
        if (Math.abs(dy) > this._fillAnimMaxDeltaY) this._fillAnimMaxDeltaY = Math.abs(dy);
        if (Math.abs(dx) > this._fillAnimMaxDeltaX) this._fillAnimMaxDeltaX = Math.abs(dx);

        // Get current pixel index inside image data.
        pixelIndex = (y * this._colour_c2d.width + x) * 4;

        // Go up as long as the colour matches and are inside the canvas.
        while (y >= drawingBoundTop && this._isPixelToFill(pixelIndex)) {
            y -= 1;
            pixelIndex -= this._colour_c2d.width * 4;
        }

        pixelIndex += this._colour_c2d.width * 4;
        y += 1;
        reachLeft = false;
        reachRight = false;

        // Go down as long as the colour matches and in inside the canvas.
        while (y <= drawingBoundBottom && this._isPixelToFill(pixelIndex)) {
            this._paintPixel(pixelIndex);

            //console.log( "_floodFill :: pixelIndex = " + pixelIndex );

            if (x > drawingBoundLeft) {
                if (this._isPixelToFill(pixelIndex - 4)) {
                    if (!reachLeft) {
                        // Add pixel to stack
                        pixelStack.push([x - 1, y]);
                        reachLeft = true;
                    }
                } else if (reachLeft) reachLeft = false;
            }

            if (x < drawingBoundRight) {
                if (this._isPixelToFill(pixelIndex + 4)) {
                    if (!reachRight) {
                        // Add pixel to stack
                        pixelStack.push([x + 1, y]);
                        reachRight = true;
                    }
                } else if (reachRight) reachRight = false;
            }

            y += 1;
            pixelIndex += this._colour_c2d.width * 4;

            // Update limits for filling animation.
            dy = y - startY;
            if (Math.abs(dy) > this._fillAnimMaxDeltaY) this._fillAnimMaxDeltaY = Math.abs(dy);
        }
    }
};

FillLayer.prototype._isPixelToFill = function (pixelIndex) {
    var result = true;

    // If given pixel is not part of the outline.
    var r = this._outlineLayerData.data[pixelIndex];
    var g = this._outlineLayerData.data[pixelIndex + 1];
    var b = this._outlineLayerData.data[pixelIndex + 2];
    var a = this._outlineLayerData.data[pixelIndex + 3];

    // TODO: Adjust tolerance as necessary.
    result = a <= 255 * 0.5;

    // If current pixel doesn't match the new colour.
    if (result) {
        r = this._colourCodeLayerData.data[pixelIndex];
        g = this._colourCodeLayerData.data[pixelIndex + 1];
        b = this._colourCodeLayerData.data[pixelIndex + 2];

        result = r != this._curColour.colourCode.r || g != this._curColour.colourCode.g || b != this._curColour.colourCode.b;
    }

    // TEST: DYN_OUT:
    // If current pixel is not part of the dynamic outline.
    if (result) {
        a = _Common2.default.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
        // TODO: Adjust tolerance as necessary.
        result = a < 255;
    }

    return result;
};

FillLayer.prototype._paintPixel = function (pixelIndex) {
    // Find pixel colour.
    var r, g, b, a;
    if (this._curColour.isTexture) {
        // pixelIndex is not in canvas coordinates, but image data coordinates! Divide by 4 ( r + g + b + a ) to make the conversion.
        var dy = Math.floor(pixelIndex / 4 / this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 / this._colour_c2d.width);
        var dx = Math.floor(pixelIndex / 4 % this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 % this._colour_c2d.width);

        var textureY = dy % this._curColour.data.height;
        if (textureY < 0) textureY += this._curColour.data.height;
        var textureX = dx % this._curColour.data.height;
        if (textureX < 0) textureX += this._curColour.data.height;
        var basePixelPos = (this._curColour.data.height * textureY + textureX) * 4;

        //console.log( "dx,dy = " + dx + " :: " + dy );

        r = this._curColour.data.data[basePixelPos];
        g = this._curColour.data.data[basePixelPos + 1];
        b = this._curColour.data.data[basePixelPos + 2];
        a = this._curColour.data.data[basePixelPos + 3] !== undefined ? this._curColour.data.data[basePixelPos + 3] : 255;
    } else {
        r = this._curColour.r;
        g = this._curColour.g;
        b = this._curColour.b;
        a = this._curColour.a !== undefined ? this._curColour.a : 255;
    }

    // Buffers.
    // Colour.
    this._colourLayerData.data[pixelIndex] = r;
    this._colourLayerData.data[pixelIndex + 1] = g;
    this._colourLayerData.data[pixelIndex + 2] = b;
    this._colourLayerData.data[pixelIndex + 3] = a;
    // Filling.
    this._fillAnimLayerData.data[pixelIndex] = r;
    this._fillAnimLayerData.data[pixelIndex + 1] = g;
    this._fillAnimLayerData.data[pixelIndex + 2] = b;
    this._fillAnimLayerData.data[pixelIndex + 3] = a;
    // Colour code.
    this._colourCodeLayerData.data[pixelIndex] = this._curColour.colourCode.r;
    this._colourCodeLayerData.data[pixelIndex + 1] = this._curColour.colourCode.g;
    this._colourCodeLayerData.data[pixelIndex + 2] = this._curColour.colourCode.b;
    this._colourCodeLayerData.data[pixelIndex + 3] = 255;
};

FillLayer.prototype._updateFillAnimMask = function () {
    this._fillAnimMask.clear();
    this._fillAnimMask.beginFill();
    this._fillAnimMask.drawCircle(this._lastInputGlobalPosition.x, this._lastInputGlobalPosition.y, this._fillAnimRadius);
    this._fillAnimMask.endFill();
};

//===================================================
//
// Events
//
//===================================================

FillLayer.prototype.onContext_Changed = function () {
    this._colourLayerSprite.texture.update();
};

FillLayer.prototype._onColour_Changed = function (selection, pageIndex, itemIndex) {
    this._paletteItem = selection;
    if (selection.indexOf("#") == 0) {
        // Colour.
        var rgbColour = _Common2.default.hexToRgb(selection);

        this._curColour = {
            r: rgbColour.r,
            g: rgbColour.g,
            b: rgbColour.b,
            isTexture: false,
            colourCode: { r: pageIndex, g: itemIndex, b: 1 // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
            } };
    } else {
        // Texture.
        var texture = _Common2.default.assets.getTexture(selection);
        var frame = texture.frame;
        var canvas = document.createElement('canvas');
        canvas.width = frame.width;
        canvas.height = frame.height;
        var context = canvas.getContext('2d');
        context.drawImage(texture.baseTexture.source, frame.x * _Common2.default.main.assetRes, frame.y * _Common2.default.main.assetRes, frame.width * _Common2.default.main.assetRes, frame.height * _Common2.default.main.assetRes, 0, 0, frame.width, frame.height);

        this._curColour = {
            data: context.getImageData(0, 0, canvas.width, canvas.height),
            isTexture: true,
            colourCode: { r: pageIndex, g: itemIndex, b: 1 // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
            } };
    }
};

FillLayer.prototype._onFillLayer_Click = function (mouseData) {
    if (this._state == this.STATE.FILL_ANIM) return;

    // Undo manager.
    this._colourCodeContext.putImageData(this._colourCodeLayerData, 0, 0);
    _Common2.default.game.undoManager.save();

    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._colourLayerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + _Common2.default.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + _Common2.default.game.canvas.HEIGHT * 0.5);
    //console.log( localCoordsPosition.x + " :: " + localCoordsPosition.y );

    this._fillAt(Math.floor(ctxCoordPosition.x), Math.floor(ctxCoordPosition.y));

    this._lastInputGlobalPosition = new PIXI.Point(mouseData.data.global.x - _Common2.default.game.scene.x - _Common2.default.game.canvas.x, mouseData.data.global.y - _Common2.default.game.canvas.y);

    // Vfx.
    var rgbColour = { r: 255, g: 255, b: 255 };
    if (this._paletteItem.indexOf("#") == 0) rgbColour = _Common2.default.hexToRgb(this._paletteItem);
    this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
    this._drawPS.endColor = this._drawPS.startColor;
    this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
    this._drawPS.emit = true;

    // Sfx.
    _Common2.default.audio.playSound("sfx_tool_paintpot_fill_use_02");

    // Tutorial.
    _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.CANVAS_DRAWN);
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(FillLayer.prototype, "colourContext", {
    get: function get() {
        return this._colourContext;
    }
});

Object.defineProperty(FillLayer.prototype, "colourCodeContext", {
    get: function get() {
        return this._colourCodeContext;
    }
});

Object.defineProperty(FillLayer.prototype, "state", {
    get: function get() {
        return this._state;
    }
});

Object.defineProperty(FillLayer.prototype, "paletteItem", {
    get: function get() {
        return this._paletteItem;
    }
});

},{"../Common":3,"../CommonGame":4,"../ui/overlays/PalettePanel":38}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

var _PaletteButton = require("./PaletteButton");

var _PaletteButton2 = _interopRequireDefault(_PaletteButton);

var _OutlineFilter = require("../shaders/OutlineFilter");

var _OutlineFilter2 = _interopRequireDefault(_OutlineFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HUD = function (_PIXI$Container) {
    _inherits(HUD, _PIXI$Container);

    function HUD() {
        _classCallCheck(this, HUD);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (HUD.__proto__ || Object.getPrototypeOf(HUD)).call(this));

        _this._leftBarContainer = null;
        _this._rightBarContainer = null;
        _this._leftBarSprite = null;
        _this._rightBarSprite = null;
        _this._menuBtn = null;
        _this._undoBtn = null;
        _this._lastToolBtn = null;

        _this._pencilButton = null;
        _this._brushButton = null;
        _this._bucketButton = null;
        _this._stampButton = null;
        _this._inkPotButton = null;
        _this._sprayButton = null;
        _this._eraserButton = null;
        _this._paletteButton = null;

        _this._drawItText = null;
        _this._palettePanel = null;

        _this._drawMode = _CommonGame2.default.TOOL.PENCIL;

        // Signals.
        _this.signals = {};
        _this.signals.onMenuClick = new signals.Signal();
        _this.signals.onPaletteClick = new signals.Signal();
        _this.signals.onDrawModeChanged = new signals.Signal();
        return _this;
    }

    _createClass(HUD, [{
        key: "init",
        value: function init() {

            console.assert(_Common2.default.game.scene.palettePanel != null, "Initialization failed: Common.game.scene.palettePanel is null.");
            this._palettePanel = _Common2.default.game.scene.palettePanel;

            // Left bar.
            // Container.
            this._leftBarContainer = new PIXI.Container();
            this._leftBarContainer.anchor = new PIXI.Point(0, 0.5);
            this._leftBarContainer.x = _Common2.default.getScreenPositionLeft() - this.x;
            this.addChild(this._leftBarContainer);
            // Sprite.
            this._leftBarSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("panel_l"));
            this._leftBarSprite.anchor = new PIXI.Point(0, 0.5);
            this._leftBarContainer.addChild(this._leftBarSprite);
            // Right bar.
            // Container.
            this._rightBarContainer = new PIXI.Container();
            this._rightBarContainer.anchor = new PIXI.Point(0, 0.5);
            this._rightBarContainer.x = _Common2.default.getScreenPositionRight() - this.x;
            this.addChild(this._rightBarContainer);
            // Sprite.
            this._rightBarSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("panel_r"));
            this._rightBarSprite.anchor = new PIXI.Point(1, 0.5);
            this._rightBarContainer.addChild(this._rightBarSprite);

            //--buttons--//
            var buttonOffset = 90; //made an offset variable to use to offset the buttons

            // Menu button.
            //  var btnStatesAux = new P3.ButtonStates(
            ///     Common.assets.getTexture("btn_primary_small_off"),
            //     Common.assets.getTexture("btn_primary_small_over"),
            //    Common.assets.getTexture("btn_primary_small_down"),
            //    Common.assets.getTexture("icon_menu"));
            this._menuBtn = createButton("menu");
            this._menuBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._menuBtn.y = -280;
            this._menuBtn.x = buttonOffset;
            this._menuBtn.overSoundName = "sfx_ui_rollover_00";
            this._menuBtn.downSoundName = "sfx_ui_click_00";
            this._menuBtn.signals.click.add(this._onMenuButton_Click, this);
            this._leftBarSprite.addChild(this._menuBtn);

            // Undo button.
            var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_undo"), _Common2.default.assets.getTexture("icon_undo"), _Common2.default.assets.getTexture("icon_undo"));
            this._undoBtn = new P3.Button(btnStatesAux);
            this._undoBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._undoBtn.y = -280;
            this._undoBtn.x = -buttonOffset;
            this._undoBtn.signals.click.add(this._onUndoButton_Click, this);
            this._rightBarSprite.addChild(this._undoBtn);

            this._undoBtn.interactive = false;
            this._undoBtn.alpha = 0.5;

            // Tool buttons.
            // Left.
            // Palette.
            this._paletteButton = new _PaletteButton2.default();
            this._paletteButton.init();
            this._paletteButton.anchor = new PIXI.Point(0.5, 0.5);
            this._paletteButton.y = 260;
            this._paletteButton.x = buttonOffset;
            this._paletteButton.scale.x = -1;
            this._paletteButton.signals.onClick.add(this._onPaletteBtn_Click, this);
            this._leftBarSprite.addChild(this._paletteButton);
            //this._arrToolBtn.push( this._colourPaletteButton );
            this._paletteButton.setup(_Common2.default.assets.getJSON("config").palettePanel.pages[0][0], _CommonGame2.default.TOOL.PENCIL);
            // Pencil.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_pencil"), _Common2.default.assets.getTexture("icon_pencil"), _Common2.default.assets.getTexture("icon_pencil"));
            this._pencilButton = new P3.Button(btnStatesAux);
            this._pencilButton.anchor = new PIXI.Point(0.5, 0.5);
            this._pencilButton.y = 110;
            this._pencilButton.x = buttonOffset;
            this._pencilButton.drawMode = _CommonGame2.default.TOOL.PENCIL;
            this._pencilButton.signals.click.add(this._onDrawMode_Changed, this);
            this._leftBarSprite.addChild(this._pencilButton);
            // Brush.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_brush"), _Common2.default.assets.getTexture("icon_brush"), _Common2.default.assets.getTexture("icon_brush"));
            this._brushButton = new P3.Button(btnStatesAux);
            this._brushButton.anchor = new PIXI.Point(0.5, 0.5);
            this._brushButton.y = -10;
            this._brushButton.x = buttonOffset;
            this._brushButton.drawMode = _CommonGame2.default.TOOL.BRUSH;
            this._brushButton.signals.click.add(this._onDrawMode_Changed, this);
            this._leftBarSprite.addChild(this._brushButton);
            // Bucket.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_fill"), _Common2.default.assets.getTexture("icon_fill"), _Common2.default.assets.getTexture("icon_fill"));
            this._bucketButton = new P3.Button(btnStatesAux);
            this._bucketButton.anchor = new PIXI.Point(0.5, 0.5);
            this._bucketButton.y = -130;
            this._bucketButton.x = buttonOffset;
            this._bucketButton.drawMode = _CommonGame2.default.TOOL.BUCKET;
            this._bucketButton.signals.click.add(this._onDrawMode_Changed, this);
            this._leftBarSprite.addChild(this._bucketButton);
            // Right.
            // Stamp.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_stamp"), _Common2.default.assets.getTexture("icon_stamp"), _Common2.default.assets.getTexture("icon_stamp"));
            this._stampButton = new P3.Button(btnStatesAux);
            this._stampButton.anchor = new PIXI.Point(0.5, 0.5);
            this._stampButton.scale.x = -1;
            this._stampButton.defaultScale.x = this._stampButton.scale.x;
            this._stampButton.y = 230;
            this._stampButton.x = -buttonOffset;
            this._stampButton.drawMode = _CommonGame2.default.TOOL.STAMP;
            this._stampButton.signals.click.add(this._onDrawMode_Changed, this);
            this._rightBarSprite.addChild(this._stampButton);
            // Ink pot.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_ink"), _Common2.default.assets.getTexture("icon_ink"), _Common2.default.assets.getTexture("icon_ink"));
            this._inkPotButton = new P3.Button(btnStatesAux);
            this._inkPotButton.anchor = new PIXI.Point(0.5, 0.5);
            this._inkPotButton.y = 110;
            this._inkPotButton.x = -buttonOffset;
            this._inkPotButton.drawMode = _CommonGame2.default.TOOL.INK_POT;
            this._inkPotButton.signals.click.add(this._onDrawMode_Changed, this);
            this._rightBarSprite.addChild(this._inkPotButton);
            // Spray.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_spray"), _Common2.default.assets.getTexture("icon_spray"), _Common2.default.assets.getTexture("icon_spray"));
            this._sprayButton = new P3.Button(btnStatesAux);
            this._sprayButton.anchor = new PIXI.Point(0.5, 0.5);
            this._sprayButton.y = -10;
            this._sprayButton.x = -buttonOffset;
            this._sprayButton.drawMode = _CommonGame2.default.TOOL.SPRAY;
            this._sprayButton.signals.click.add(this._onDrawMode_Changed, this);
            this._rightBarSprite.addChild(this._sprayButton);
            // Eraser.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_eraser"), _Common2.default.assets.getTexture("icon_eraser"), _Common2.default.assets.getTexture("icon_eraser"));
            this._eraserButton = new P3.Button(btnStatesAux);
            this._eraserButton.anchor = new PIXI.Point(0.5, 0.5);
            this._eraserButton.y = -130;
            this._eraserButton.x = -buttonOffset;
            this._eraserButton.drawMode = _CommonGame2.default.TOOL.ERASER;
            this._eraserButton.signals.click.add(this._onDrawMode_Changed, this);
            this._rightBarSprite.addChild(this._eraserButton);

            // Draw it text (only for Draw It! mode).
            if (_CommonGame2.default.selectedGallery === _CommonGame2.default.GALLERY_ID_DRAW_IT) {
                this._drawItText = P3.createText(_CommonGame2.default.drawItTextId, {
                    size: "64px",
                    fill: [0xfff8b3, 0xfac109],
                    stroke: 0x4c2607,
                    strokeThickness: 4,
                    padding: 20,
                    wordWrapWidth: P3.View.width * 0.65
                }, "truetype", "draw_it");

                this._drawItText.y = -_Common2.default.STAGE_HEIGHT * 0.5 + 15;
                this._drawItText.anchor = new PIXI.Point(0.5, 0);
                this.addChild(this._drawItText);

                // Scale down.
                if (this._drawItText.width > _Common2.default.STAGE_MIN_WIDTH * 0.8) {
                    var scaleFactor = _Common2.default.STAGE_MIN_WIDTH * 0.8 / this._drawItText.width;
                    this._drawItText.y += (1 - scaleFactor) * this._drawItText.height * 0.5;
                    this._drawItText.scale = new PIXI.Point(scaleFactor, scaleFactor);
                }
            }

            // Initial state.
            this._highlightToolBtn(this._pencilButton);

            // Signals.
            _Common2.default.game.undoManager.signals.onStackEmpty.add(this._onUndoStack_Empty, this);
            _Common2.default.game.undoManager.signals.onStackIncreased.add(this._onUndoStack_Increased, this);

            this._palettePanel.signals.onColourChanged.add(this._onPaletteSelection_Changed, this);
            this._palettePanel.signals.onStampChanged.add(this._onPaletteSelection_Changed, this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this._leftBarContainer.x = _Common2.default.getScreenPositionLeft() - this.x;
            this._rightBarContainer.x = _Common2.default.getScreenPositionRight() - this.x;
        }
    }, {
        key: "getPaletteBtnPosition",
        value: function getPaletteBtnPosition() {
            return _Common2.default.findPositionInScene(this._paletteButton, _Common2.default.game.scene);
        }
    }, {
        key: "getBrushBtnPosition",
        value: function getBrushBtnPosition() {
            return _Common2.default.findPositionInScene(this._brushButton, _Common2.default.game.scene);
        }
    }, {
        key: "_highlightToolBtn",
        value: function _highlightToolBtn(btn) {
            if (this._lastToolBtn) {
                // Remove outline.
                this._lastToolBtn.filters = [];

                TweenMax.killTweensOf(this._lastToolBtn.scale);
                this._lastToolBtn.animate = true;
                TweenMax.to(this._lastToolBtn.scale, 0.25, {
                    x: this._lastToolBtn.scale.x < 0 ? -1 : 1,
                    y: 1,
                    ease: Sine.easeOut,
                    onComplete: function onComplete(btn) {
                        btn.interactive = true;
                    },
                    onCompleteParams: [this._lastToolBtn]
                });
            }

            btn.animate = false;
            btn.interactive = false;
            btn.stopAnimations();
            TweenMax.to(btn.scale, 0.5, {
                x: 1.1 * (btn.scale.x < 0 ? -1 : 1),
                y: 1.1,
                ease: Sine.easeInOut,
                yoyo: true,
                repeat: -1
            });

            this._lastToolBtn = btn;

            // Add outline.
            this._lastToolBtn.filters = [new _OutlineFilter2.default(9, 0xFFFFFF)];
        }

        //----EVENTS----//

    }, {
        key: "_onMenuButton_Click",
        value: function _onMenuButton_Click() {
            this.signals.onMenuClick.dispatch();
        }
    }, {
        key: "_onUndoButton_Click",
        value: function _onUndoButton_Click() {
            _Common2.default.game.undoManager.undo();

            // Sfx.
            _Common2.default.audio.playSound("sfx_tool_undo_step_back_00");
        }
    }, {
        key: "_onDrawMode_Changed",
        value: function _onDrawMode_Changed(btn) {
            // Highlight selected button.
            this._highlightToolBtn(btn);

            this._drawMode = btn.drawMode;

            this.signals.onDrawModeChanged.dispatch(btn.drawMode);

            // Palette button.
            if (btn.drawMode == _CommonGame2.default.TOOL.ERASER)
                // Disable it if the eraser is selected.
                this._paletteButton.setInteractive(false);else {
                // Otherwise, enable it.
                this._paletteButton.setInteractive(true);

                // Update visual elements.
                if (btn.drawMode == _CommonGame2.default.TOOL.BUCKET) this._paletteButton.setup(_Common2.default.game.canvas.fillLayer.paletteItem, btn.drawMode);else this._paletteButton.setup(_Common2.default.game.canvas.drawLayer.drawingTool.paletteItem, btn.drawMode);
            }

            // Tutorial.
            _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.TOOL_SELECTED);
            if (btn.drawMode != _CommonGame2.default.TOOL.ERASER) _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.PALETTE_BUTTON_ENABLED);else _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.PALETTE_BUTTON_DISABLED);
        }
    }, {
        key: "_onUndoStack_Empty",
        value: function _onUndoStack_Empty() {
            this._undoBtn.interactive = false;
            this._undoBtn.alpha = 0.5;
        }
    }, {
        key: "_onUndoStack_Increased",
        value: function _onUndoStack_Increased() {
            this._undoBtn.interactive = true;
            this._undoBtn.alpha = 1;
        }
    }, {
        key: "_onPaletteBtn_Click",
        value: function _onPaletteBtn_Click() {
            this.signals.onPaletteClick.dispatch(this._paletteButton.type);
        }
    }, {
        key: "_onPaletteSelection_Changed",
        value: function _onPaletteSelection_Changed(selection, paletteType) {
            this._paletteButton.setup(selection, this._paletteButton.type);
        }
    }]);

    return HUD;
}(PIXI.Container);

exports.default = HUD;

},{"../Common":3,"../CommonGame":4,"../shaders/OutlineFilter":33,"../ui/overlays/PalettePanel":38,"./PaletteButton":19}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function InkPot() {
    // Constants.
    this.MIN_RADIUS = 5;
    this.MAX_RADIUS = 20;

    // Attributes.
    this._drawLayer = null;
    this._colour = null;
}
exports.default = InkPot;
//module.exports               	= InkPot;

InkPot.prototype.constructor = InkPot;

//===================================================
//
// Public
//
//===================================================

InkPot.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._colour = _Common2.default.assets.getJSON("config").palettePanel.pages[0][0];

    // Signals.
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

//===================================================
//
// Private
//
//===================================================

InkPot.prototype._draw = function (from, to) {
    this._drawLayer.context.beginPath();
    this._drawLayer.context.globalAlpha = Math.random() * 0.25 + 0.15;
    this._drawLayer.context.arc(to.x, to.y, _Common2.default.randomInt(this.MIN_RADIUS, this.MAX_RADIUS), false, Math.PI * 2, false);
    this._drawLayer.context.fill();

    this._drawLayer.onContext_Changed();
};

//===================================================
//
// Events
//
//===================================================

InkPot.prototype.onDrawBegan = function (point) {
    this._drawLayer.context.save();

    this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
    this._drawLayer.context.fillStyle = this._colour;

    this._draw(point, point);

    // Sfx.
    _Common2.default.audio.playSound("sfx_tool_inkpot_use_splat_00");
};

InkPot.prototype.onDrawMoved = function (from, to) {
    this._draw(from, to);
};

InkPot.prototype.onDrawEnded = function () {
    this._drawLayer.context.restore();
};

InkPot.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) this._colour = selection;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(InkPot.prototype, "paletteItem", {
    get: function get() {
        return this._colour;
    }
});

},{"../Common":3}],16:[function(require,module,exports){
"use strict";

var Common = require("../Common");
var CommonGame = require("../CommonGame");

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function MagicBrush() {
	// Constants.
	this.LINE_THICKNESS = 20;

	// Attributes.
	this._drawLayer = null;
	this._textureId = null;
}
module.exports = MagicBrush;
MagicBrush.prototype.constructor = MagicBrush;

//===================================================
//
// Public
//
//===================================================

MagicBrush.prototype.init = function (drawLayer) {
	this._drawLayer = drawLayer;
};

//===================================================
//
// Private
//
//===================================================

MagicBrush.prototype._draw = function (from, to) {
	this._drawLayer.context.beginPath();
	this._drawLayer.context.moveTo(from.x, from.y);
	this._drawLayer.context.lineTo(to.x, to.y);
	this._drawLayer.context.stroke();

	this._drawLayer.onContext_Changed();
};

MagicBrush.prototype._createPattern = function () {
	var patternCanvas = document.createElement('canvas');
	var ctx = patternCanvas.getContext('2d');
	var texture = Common.assets.getTexture(this._textureId);
	var frame = texture.frame;
	patternCanvas.width = patternCanvas.height = frame.width;

	ctx.drawImage(texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);

	return ctx.createPattern(patternCanvas, 'repeat');
};

//===================================================
//
// Events
//
//===================================================

MagicBrush.prototype.onDrawBegan = function (point) {
	this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
	this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
	this._drawLayer.context.strokeStyle = this._createPattern();

	this._draw(point, point);
};

MagicBrush.prototype.onDrawMoved = function (from, to) {
	this._draw(from, to);
};

MagicBrush.prototype.onDrawEnded = function () {};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(MagicBrush.prototype, "textureId", { set: function set(a) {
		this._textureId = a;
	} });

},{"../Common":3,"../CommonGame":4}],17:[function(require,module,exports){
"use strict";

var Common = require("../Common");
var CommonGame = require("../CommonGame");

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function MagicPencil() {
	// Constants.
	this.LINE_THICKNESS = 5;

	// Attributes.
	this._drawLayer = null;
	this._textureId = null;
}
module.exports = MagicPencil;
MagicPencil.prototype.constructor = MagicPencil;

//===================================================
//
// Public
//
//===================================================

MagicPencil.prototype.init = function (drawLayer) {
	this._drawLayer = drawLayer;
};

//===================================================
//
// Private
//
//===================================================

MagicPencil.prototype._draw = function (from, to) {
	this._drawLayer.context.beginPath();
	this._drawLayer.context.moveTo(from.x, from.y);
	this._drawLayer.context.lineTo(to.x, to.y);
	this._drawLayer.context.stroke();

	this._drawLayer.onContext_Changed();
};

MagicPencil.prototype._createPattern = function () {
	var patternCanvas = document.createElement('canvas');
	var ctx = patternCanvas.getContext('2d');
	var texture = Common.assets.getTexture(this._textureId);
	var frame = texture.frame;
	patternCanvas.width = patternCanvas.height = frame.width;

	ctx.drawImage(texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);

	return ctx.createPattern(patternCanvas, 'repeat');
};

//===================================================
//
// Events
//
//===================================================

MagicPencil.prototype.onDrawBegan = function (point) {
	this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
	this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
	this._drawLayer.context.strokeStyle = this._createPattern();

	this._draw(point, point);
};

MagicPencil.prototype.onDrawMoved = function (from, to) {
	this._draw(from, to);
};

MagicPencil.prototype.onDrawEnded = function () {};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(MagicPencil.prototype, "textureId", { set: function set(a) {
		this._textureId = a;
	} });

},{"../Common":3,"../CommonGame":4}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _HUD = require("./HUD");

var _HUD2 = _interopRequireDefault(_HUD);

var _UndoManager = require("./UndoManager");

var _UndoManager2 = _interopRequireDefault(_UndoManager);

var _Canvas = require("./Canvas");

var _Canvas2 = _interopRequireDefault(_Canvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyGame = function () {
    function MyGame() {
        _classCallCheck(this, MyGame);

        // TODO:

        // Attributes.
        this._scene = null;
        this._decoration = null;
        this._hud = null;
        this._canvas = null;
        this._undoManager = null;
    }

    _createClass(MyGame, [{
        key: "init",
        value: function init() {
            console.assert(this._scene != null, "Initialization failed: this._scene is null.");

            // Undo manager.
            this._undoManager = new _UndoManager2.default();

            // Decoration.
            this._decoration = new PIXI.Container();
            this._initDecoration();

            // HUD.
            this._hud = new _HUD2.default();
            this._hud.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);
            this._hud.init();

            // Canvas.
            // - Initialization dependencies: HUD.
            this._canvas = new _Canvas2.default();
            this._canvas.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);
            this._canvas.init();

            this._scene.gameLayer.addChild(this._canvas);
            this._scene.gameLayer.addChild(this._decoration);
            this._scene.gameLayer.addChild(this._hud);

            //--add an extra overlay so the drawn / colouring is underneath the black lines--//
            var outlineTexture = PIXI.Texture.fromImage("assets/images/outlines/" + (_CommonGame2.default.selectedGallery == _CommonGame2.default.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/") + _CommonGame2.default.selectedImageId + ".png");
            var sp = new PIXI.Sprite(outlineTexture);
            sp.anchor.set(0.5);
            this._canvas.addChild(sp);
        }
    }, {
        key: "update",
        value: function update() {
            this._canvas.update();
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            this._canvas.animateIn();
        }
    }, {
        key: "resize",
        value: function resize() {
            this._hud.resize();
        }
    }, {
        key: "_initDecoration",
        value: function _initDecoration() {

            var t = _Common2.default.assets.texture;

            var topFlowers = new PIXI.Sprite(t("leaves"));
            var offset = topFlowers.height * 0.5;

            topFlowers.anchor.set(0.5, 0.5);
            topFlowers.x = _Common2.default.STAGE_WIDTH * 0.5;
            topFlowers.y = -offset;

            var botFlowers = new PIXI.Sprite(t("leaves"));
            botFlowers.anchor.set(0.5, 0.5);
            botFlowers.scale.y = -1;
            botFlowers.x = _Common2.default.STAGE_WIDTH * 0.5;
            botFlowers.y = _Common2.default.STAGE_HEIGHT + offset;

            this._decoration.addChild(topFlowers, botFlowers);

            TweenMax.to(topFlowers, 2 + Math.random() * 0.5, {
                y: 0,
                ease: Elastic.easeOut.config(1, 0.3 - 0.1 * Math.random()),
                delay: Math.random() * 0.25
            });

            TweenMax.to(botFlowers, 2 + Math.random() * 0.5, {
                y: _Common2.default.STAGE_HEIGHT,
                ease: Elastic.easeOut.config(1, 0.3 - 0.1 * Math.random()),
                delay: Math.random() * 0.25
            });
        }
    }, {
        key: "scene",
        get: function get() {
            return this._scene;
        },
        set: function set(value) {
            this._scene = value;
        }
    }, {
        key: "hud",
        get: function get() {
            return this._hud;
        }
    }, {
        key: "canvas",
        get: function get() {
            return this._canvas;
        }
    }, {
        key: "undoManager",
        get: function get() {
            return this._undoManager;
        }
    }]);

    return MyGame;
}();

exports.default = MyGame;

},{"../Common":3,"../CommonGame":4,"./Canvas":8,"./HUD":14,"./UndoManager":24}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

function PaletteButton() {
    PIXI.Container.call(this);

    // Attributes
    this._button = null;
    this._selectionSprite = null;
    this._shineOverlay = null;
    this._type = null;

    // Signals.
    this.signals = {};
    this.signals.onClick = new signals.Signal();
}

exports.default = PaletteButton;
//module.exports = PaletteButton;

PaletteButton.prototype = Object.create(PIXI.Container.prototype);
PaletteButton.prototype.constructor = PaletteButton;

//===================================================
//
// Public
//
//===================================================

PaletteButton.prototype.init = function () {
    // Button.
    var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_colour_palette_bg"), _Common2.default.assets.getTexture("icon_colour_palette_bg"), _Common2.default.assets.getTexture("icon_colour_palette_bg"));
    this._button = new P3.Button(btnStatesAux);
    this._button.anchor = new PIXI.Point(0.5, 0.5);
    this._button.signals.click.add(this.signals.onClick.dispatch, this);
    this.addChild(this._button);

    // Selection sprite.
    this._selectionSprite = new PIXI.Sprite(_Common2.default.blankTexture);
    this._selectionSprite.x = -60;
    this._selectionSprite.y = 21;
    this._selectionSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._button.addChild(this._selectionSprite);

    this._shineOverlay = new PIXI.Sprite(_Common2.default.assets.getTexture("btns_colour_overlay"));
    this._shineOverlay.anchor = new PIXI.Point(0.5, 0.5);
    this._shineOverlay.blendMode = PIXI.BLEND_MODES.ADD;
    this._shineOverlay.alpha = 0.4;
    this._selectionSprite.addChild(this._shineOverlay);
};

PaletteButton.prototype.setup = function (selection, toolType) {
    this._type = toolType;

    this._selectionSprite.tint = 0xffffff;

    switch (this._type) {
        case _CommonGame2.default.TOOL.BRUSH:
        case _CommonGame2.default.TOOL.PENCIL:
        case _CommonGame2.default.TOOL.INK_POT:
        case _CommonGame2.default.TOOL.SPRAY:
        case _CommonGame2.default.TOOL.BUCKET:
            {
                this._shineOverlay.visible = true;

                this._button._currentNormalTexture = _Common2.default.assets.getTexture("icon_colour_palette_bg");
                this._button._currentOverTexture = _Common2.default.assets.getTexture("icon_colour_palette_bg");
                this._button._currentDownTexture = _Common2.default.assets.getTexture("icon_colour_palette_bg");
                this._button._background.texture = this._button._currentNormalTexture;

                if (selection.indexOf("#") == 0) {
                    this._selectionSprite.texture = _Common2.default.assets.getTexture("btns_colour_white");
                    this._selectionSprite.tint = parseInt("0x" + selection.substring(1));
                } else this._selectionSprite.texture = _Common2.default.assets.getTexture(_CommonGame2.default.TEXTURE_BUTTON_BASE_ID + selection.substring(selection.length - 2));

                this._selectionSprite.scale.x = -0.8;
                this._selectionSprite.scale.y = 0.8;

                break;
            }

        case _CommonGame2.default.TOOL.STAMP:
            {
                this._shineOverlay.visible = false;

                this._button._currentNormalTexture = _Common2.default.assets.getTexture("icon_stamp_palette_bg");
                this._button._currentOverTexture = _Common2.default.assets.getTexture("icon_stamp_palette_bg");
                this._button._currentDownTexture = _Common2.default.assets.getTexture("icon_stamp_palette_bg");
                this._button._background.texture = this._button._currentNormalTexture;

                this._selectionSprite.texture = _Common2.default.assets.getTexture(selection);
                this._selectionSprite.scale.x = -1;
                this._selectionSprite.scale.y = 0.8;

                break;
            }
    }
};

PaletteButton.prototype.setInteractive = function (isInteractive) {
    this._button.interactive = isInteractive;
    this._button.alpha = isInteractive ? 1 : 0.5;
    this._selectionSprite.alpha = this._button.alpha;
};

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(PaletteButton.prototype, "type", {
    get: function get() {
        return this._type;
    }
});

},{"../Common":3,"../CommonGame":4,"../ui/overlays/PalettePanel":38}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

var _MagicPencil = require("./MagicPencil");

var _MagicPencil2 = _interopRequireDefault(_MagicPencil);

var _ColourPencil = require("./ColourPencil");

var _ColourPencil2 = _interopRequireDefault(_ColourPencil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Pencil() {
    // Attributes.
    this._drawLayer = null;
    this._magicPencil = null;
    this._colourPencil = null;
    this._paletteItem = null;
    this._curPencil = null;
    this._audio = null;
}
exports.default = Pencil;
//module.exports = Pencil;

Pencil.prototype.constructor = Pencil;

//===================================================
//
// Public
//
//===================================================

Pencil.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;

    // Magic pencil.
    this._magicPencil = new _MagicPencil2.default();
    this._magicPencil.init(drawLayer);

    // Colour pencil.
    this._colourPencil = new _ColourPencil2.default();
    this._colourPencil.init(drawLayer);

    // Set initial pencil.
    this._curPencil = this._colourPencil;
    this._curPencil.colour = _Common2.default.assets.getJSON("config").palettePanel.pages[0][0];
    this._paletteItem = this._curPencil.colour;

    // Signals.
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

//===================================================
//
// Private
//
//===================================================

Pencil.prototype._draw = function (from, to) {
    // TEST: DYN_OUT:
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.beginPath();
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.strokeStyle = "black";
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.lineWidth = this._curPencil.LINE_THICKNESS;
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.lineJoin = "round";
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.moveTo(from.x, from.y);
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.lineTo(to.x, to.y);
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.closePath();
    _Common2.default.game.canvas.drawLayer._dynOutlineContext.stroke();
};

Pencil.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};

//===================================================
//
// Events
//
//===================================================

Pencil.prototype.onDrawBegan = function (point) {
    this._curPencil.onDrawBegan(point);
    // TEST: DYN_OUT:
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

Pencil.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null) this._audio = _Common2.default.audio.playSound("sfx_tool_pencil_use_loop_00", { "loop": true });
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);

    this._curPencil.onDrawMoved(from, to);
    // TEST: DYN_OUT:
    this._draw(from, to);
};

Pencil.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null) this._stopAudio();

    // TEST: DYN_OUT:
    _Common2.default.game.canvas.drawLayer.dynOutlineData = _Common2.default.game.canvas.drawLayer._dynOutlineContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);
};

Pencil.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) {
        this._curPencil = this._colourPencil;
        this._colourPencil.colour = selection;
    } else {
        this._curPencil = this._magicPencil;
        this._magicPencil.textureId = selection;
    }

    this._paletteItem = selection;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(Pencil.prototype, "paletteItem", {
    get: function get() {
        return this._paletteItem;
    }
});

},{"../Common":3,"../ui/overlays/PalettePanel":38,"./ColourPencil":10,"./MagicPencil":17}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Spray() {
    // Constants.
    this.DENSITY = 40;
    this.PERIOD = 0.05;
    this.RADIUS = 15;

    // Attributes.
    this._drawLayer = null;
    this._drawPosition = null;
    this._colour = null;
    this._audio = null;
}
exports.default = Spray;
//module.exports               	= Spray;

Spray.prototype.constructor = Spray;

//===================================================
//
// Public
//
//===================================================

Spray.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._colour = _Common2.default.assets.getJSON("config").palettePanel.pages[0][0];

    // Signals.
    _Common2.default.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

Spray.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};

//===================================================
//
// Private
//
//===================================================

Spray.prototype._draw = function () {
    if (this._drawPosition == null) return;

    for (var i = this.DENSITY; i--;) {
        this._drawLayer.context.save();

        this._drawColour();

        this._drawLayer.context.restore();
    }

    TweenMax.delayedCall(this.PERIOD, this._draw, null, this);

    this._drawLayer.onContext_Changed();
};

Spray.prototype._drawColour = function () {
    var angle = _Common2.default.randomFloat(0, Math.PI * 2);
    var radius = _Common2.default.randomFloat(0, this.RADIUS);

    this._drawLayer.context.fillStyle = this._colour;
    this._drawLayer.context.globalAlpha = Math.random();
    this._drawLayer.context.fillRect(this._drawPosition.x + radius * Math.cos(angle), this._drawPosition.y + radius * Math.sin(angle), _Common2.default.randomFloat(1, 2), _Common2.default.randomFloat(1, 2));
};

//===================================================
//
// Events
//
//===================================================

Spray.prototype.onDrawBegan = function (point) {
    this._drawPosition = new PIXI.Point(point.x, point.y);

    this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';

    this._draw();

    // Sfx.
    this._audio = _Common2.default.audio.playSound("sfx_tool_spraycan_use_loop_00", { "loop": true });
};

Spray.prototype.onDrawMoved = function (from, to) {
    this._drawPosition.x = to.x;
    this._drawPosition.y = to.y;
};

Spray.prototype.onDrawEnded = function () {
    TweenMax.killTweensOf(this);
    this._drawPosition = null;

    // Sfx.
    this._stopAudio();
};

Spray.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) this._colour = selection;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(Spray.prototype, "paletteItem", {
    get: function get() {
        return this._colour;
    }
});

},{"../Common":3}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Stamp() {
    // Attributes.
    this._drawLayer = null;
    this._paletteItem = null;
}
exports.default = Stamp;
//module.exports = Stamp;

Stamp.prototype.constructor = Stamp;

//===================================================
//
// Public
//
//===================================================

Stamp.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._paletteItem = _Common2.default.assets.getJSON("config").palettePanel.pages[_Common2.default.assets.getJSON("config").palettePanel.tools.stamp[0]][0];

    // Listen to HUD controls.
    _Common2.default.game.scene.palettePanel.signals.onStampChanged.add(this._onStamp_Changed, this);
};

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

Stamp.prototype.onDrawBegan = function (point) {
    var scaleFactor = Math.random();

    this._drawLayer.context.save();
    this._drawLayer.context.translate(point.x, point.y);
    //this._drawLayer.context.scale( 0.6 + 0.4 * scaleFactor, 0.6 + 0.4 * scaleFactor );
    //this._drawLayer.context.rotate( Math.PI * 2 * Math.random() );
    //this._drawLayer.context.drawImage( this._image, -this._image.width * 0.5, -this._image.height * 0.5 );
    var texture = _Common2.default.assets.getTexture(this._paletteItem);
    var frame = texture.frame;
    this._drawLayer.context.drawImage(texture.baseTexture.source, frame.x * _Common2.default.main.assetRes, frame.y * _Common2.default.main.assetRes, frame.width * _Common2.default.main.assetRes, frame.height * _Common2.default.main.assetRes, 0.5 * -frame.width, 0.5 * -frame.height, frame.width, frame.height);
    this._drawLayer.context.restore();

    this._drawLayer.onContext_Changed();

    // Sfx.
    _Common2.default.audio.playSound("sfx_tool_stamp_use_00");
};

Stamp.prototype.onDrawMoved = function (from, to) {};

Stamp.prototype.onDrawEnded = function () {};

Stamp.prototype._onStamp_Changed = function (selection) {
    this._paletteItem = selection;
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(Stamp.prototype, "paletteItem", {
    get: function get() {
        return this._paletteItem;
    }
});

},{"../Common":3,"../CommonGame":4}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

var _PaletteButton = require("./PaletteButton");

var _PaletteButton2 = _interopRequireDefault(_PaletteButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

function Tutorial() {
    PIXI.Container.call(this);

    // Enumerators.
    this.STATE = {
        DRAW: 0,
        TOOL: 1,
        PALETTE: 2,
        IDLE: 3
    };

    // Constants.
    this.TUT_STEP_DELAY = 3;

    // Attributes.
    this._isPaused = false;
    this._tutorialStepTimer = 0;
    this._tutorialHand = null;
    this._state = this.STATE.IDLE;
    this._arrEvent = [];
    this._arrTutorialStep = [{
        state: this.STATE.DRAW,
        isValid: false,
        isDone: !_Common2.default.savedData.isDrawTutorial
    }, {
        state: this.STATE.TOOL,
        isValid: true,
        isDone: !_Common2.default.savedData.isToolTutorial
    }, {
        state: this.STATE.PALETTE,
        isValid: false,
        isDone: !_Common2.default.savedData.isPaletteTutorial
    }];

    // Signals.
    this.signals = {};
    this.signals.onCompleted = new signals.Signal();
}

exports.default = Tutorial;
//module.exports = Tutorial;

Tutorial.prototype = Object.create(PIXI.Container.prototype);
Tutorial.prototype.constructor = Tutorial;

//===================================================
//
// Public
//
//===================================================

Tutorial.prototype.init = function () {

    this._tutorialHand = new PIXI.spine.Spine(_Common2.default.assets.spineData("tutorial_hand"));
    this._tutorialHand.skeleton.setToSetupPose();
    this._tutorialHand.skeleton.setSkin(null);
    this._tutorialHand.skeleton.setSkinByName("default");
    this._tutorialHand.autoUpdate = false;
    this._tutorialHand.scale = new PIXI.Point(0.7, 0.7);
    this._tutorialHand.alpha = 0;
    this.addChild(this._tutorialHand);

    this._tutorialHand.state.setAnimationByName(0, "still_" + (P3.Device.isMobile ? "mobile" : "desktop"), true);
    this._tutorialHand.update(deltaTime);
};

Tutorial.prototype.end = function () {
    this.removeChild(this._tutorialHand);
    this._tutorialHand.destroy();
    this._tutorialHand = null;
};

Tutorial.prototype.update = function () {
    if (this._tutorialHand == null) return;

    this._tutorialHand.update(deltaTime);

    this._processEvents();

    // Delayed tutorial step activation.
    if (!this._isPaused) {
        this._tutorialStepTimer += deltaTime;
        if (this._tutorialStepTimer >= this.TUT_STEP_DELAY && this._state == this.STATE.IDLE) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._arrTutorialStep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tutorialStep = _step.value;

                    if (tutorialStep.isValid && !tutorialStep.isDone) {
                        this._state = tutorialStep.state;

                        switch (this._state) {
                            case this.STATE.DRAW:
                                {
                                    this._tutorialHand.state.setAnimationByName(0, "drag_" + (P3.Device.isMobile ? "mobile" : "desktop"), true);
                                    this._tutorialHand.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);

                                    this._showHand();

                                    break;
                                }

                            case this.STATE.TOOL:
                                {
                                    this._tutorialHand.state.setAnimationByName(0, "tap_" + (P3.Device.isMobile ? "mobile" : "desktop"), true);
                                    this._tutorialHand.position = _Common2.default.game.hud.getBrushBtnPosition();

                                    this._showHand();

                                    break;
                                }

                            case this.STATE.PALETTE:
                                {
                                    this._tutorialHand.state.setAnimationByName(0, "tap_" + (P3.Device.isMobile ? "mobile" : "desktop"), true);
                                    this._tutorialHand.position = _Common2.default.game.hud.getPaletteBtnPosition();

                                    this._showHand();

                                    break;
                                }
                        }
                    }

                    if (!tutorialStep.isDone) break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this._tutorialStepTimer = 0;
        }
    }
};

Tutorial.prototype.addEvent = function (tutorialEvent) {
    this._arrEvent.push(tutorialEvent);
};

Tutorial.prototype.resize = function () {
    if (this._tutorialHand == null) return;

    if (this._state == this.STATE.DRAW) this._tutorialHand.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);else if (this._state == this.STATE.TOOL) this._tutorialHand.position = _Common2.default.game.hud.getBrushBtnPosition();else if (this._state == this.STATE.PALETTE) this._tutorialHand.position = _Common2.default.game.hud.getPaletteBtnPosition();
};

//===================================================
//
// Private
//
//===================================================

Tutorial.prototype._processEvents = function () {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = this._arrEvent[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tutorialEvent = _step2.value;

            switch (tutorialEvent) {
                case _CommonGame2.default.TUT_EVENT.CANVAS_VISIBLE:
                    {
                        this._arrTutorialStep[this.STATE.DRAW].isValid = true;

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.PALETTE_SELECTED:
                    {
                        if (this._state == this.STATE.DRAW || this._state == this.STATE.TOOL) this._hideHand();else if (this._state == this.STATE.PALETTE) {
                            this._hideHand(this._checkTutorialEnd);

                            this._state = this.STATE.IDLE;
                        }

                        if (_Common2.default.savedData.isPaletteTutorial) {
                            this._arrTutorialStep[this.STATE.PALETTE].isDone = true;

                            _Common2.default.savedData.isPaletteTutorial = false;
                            _Common2.default.savedData.save();
                        }

                        this._isPaused = true;
                        this._tutorialStepTimer = 0;

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.MENU_PANEL_SHOWN:
                    {
                        if (this._state != this.STATE.IDLE) this._hideHand();

                        this._isPaused = true;
                        this._tutorialStepTimer = 0;

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.MENU_PANEL_HIDDEN:
                case _CommonGame2.default.TUT_EVENT.PALETTE_PANEL_HIDDEN:
                    {
                        if (this._state != this.STATE.IDLE) this._showHand();

                        this._isPaused = false;
                        this._tutorialStepTimer = 0;

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.PALETTE_BUTTON_ENABLED:
                    {
                        this._arrTutorialStep[this.STATE.PALETTE].isValid = true;

                        if (this._state == this.STATE.PALETTE) this._showHand();

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.PALETTE_BUTTON_DISABLED:
                    {
                        this._arrTutorialStep[this.STATE.PALETTE].isValid = false;

                        if (this._state == this.STATE.PALETTE) this._hideHand();

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.TOOL_SELECTED:
                    {
                        if (this._state == this.STATE.TOOL) {
                            this._hideHand(this._checkTutorialEnd);

                            this._state = this.STATE.IDLE;
                        }

                        if (_Common2.default.savedData.isToolTutorial) {
                            this._arrTutorialStep[this.STATE.TOOL].isDone = true;

                            _Common2.default.savedData.isToolTutorial = false;
                            _Common2.default.savedData.save();
                        }

                        this._tutorialStepTimer = 0;

                        break;
                    }

                case _CommonGame2.default.TUT_EVENT.CANVAS_DRAWN:
                    {
                        if (this._state == this.STATE.DRAW) {
                            this._hideHand(this._checkTutorialEnd);

                            this._state = this.STATE.IDLE;
                        }

                        if (_Common2.default.savedData.isDrawTutorial) {
                            this._arrTutorialStep[this.STATE.DRAW].isDone = true;

                            _Common2.default.savedData.isDrawTutorial = false;
                            _Common2.default.savedData.save();
                        }

                        this._tutorialStepTimer = 0;

                        break;
                    }
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    this._arrEvent = [];
};

Tutorial.prototype._showHand = function () {
    TweenMax.to(this._tutorialHand, 0.25, { alpha: 1 });
};

Tutorial.prototype._hideHand = function (onComplete) {
    var tm = TweenMax.to(this._tutorialHand, 0.25, { alpha: 0 });

    if (onComplete != null) tm.eventCallback("onComplete", onComplete, null, this);
};

Tutorial.prototype._checkTutorialEnd = function () {
    if (!_Common2.default.savedData.isDrawTutorial && !_Common2.default.savedData.isToolTutorial && !_Common2.default.savedData.isPaletteTutorial) this.signals.onCompleted.dispatch();
};

//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

// TODO:

},{"../Common":3,"../CommonGame":4,"../ui/overlays/PalettePanel":38,"./PaletteButton":19}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

function UndoManager() {
    // Constants.
    this.MAX_STACK_SIZE = 3;

    // Attributes.
    this._arrLayerState = [];

    // Signals.
    this.signals = {};
    this.signals.onStackEmpty = new signals.Signal();
    this.signals.onStackIncreased = new signals.Signal();
}
exports.default = UndoManager;
//module.exports = UndoManager;

UndoManager.prototype.constructor = UndoManager;

//===================================================
//
// Public
//
//===================================================

UndoManager.prototype.save = function () {
    var drawlayerData = _Common2.default.game.canvas.drawLayer.context.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);
    var drawDynOutlineData = _Common2.default.game.canvas.drawLayer.dynOutlineContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);
    var fillLayerData = _Common2.default.game.canvas.fillLayer.colourContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);
    var fillColourCodeData = _Common2.default.game.canvas.fillLayer.colourCodeContext.getImageData(0, 0, _Common2.default.game.canvas.WIDTH, _Common2.default.game.canvas.HEIGHT);

    if (this._arrLayerState.length == this.MAX_STACK_SIZE) this._arrLayerState.splice(0, 1);

    this._arrLayerState.push({
        drawlayerData: drawlayerData,
        drawDynOutlineData: drawDynOutlineData,
        fillLayerData: fillLayerData,
        fillColourCodeData: fillColourCodeData
    });

    // Signals.
    this.signals.onStackIncreased.dispatch();
};

UndoManager.prototype.undo = function () {
    if (this._arrLayerState.length == 0) return;

    var layerState = this._arrLayerState.splice(this._arrLayerState.length - 1, 1)[0];

    _Common2.default.game.canvas.fillLayer.setLayerData(layerState.fillLayerData, layerState.fillColourCodeData);
    _Common2.default.game.canvas.drawLayer.setLayerData(layerState.drawlayerData, layerState.drawDynOutlineData);

    // Signals.
    if (this._arrLayerState.length == 0) this.signals.onStackEmpty.dispatch();
};

UndoManager.prototype.clear = function () {
    this._arrLayerState = [];

    this.signals.onStackEmpty.dispatch();
};

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

// TODO:

},{"../Common":3,"../CommonGame":4}],25:[function(require,module,exports){
(function (global){
'use strict';

var _Main = require('./Main');

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.Main = _Main2.default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./Main":5}],26:[function(require,module,exports){
(function (global){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (f) {
    if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
        module.exports = f();
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }g.MultiStyleText = f();
    }
})(function () {
    var define, module, exports;return function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof require == "function" && require;if (!u && a) return a(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
                }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
                    var n = t[o][1][e];return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }return n[o].exports;
        }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
            s(r[o]);
        }return s;
    }({ 1: [function (require, module, exports) {
            module.exports = require("./pixi-multistyle-text").default;
        }, { "./pixi-multistyle-text": 2 }], 2: [function (require, module, exports) {
            var __extends = this && this.__extends || function () {
                var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                    d.__proto__ = b;
                } || function (d, b) {
                    for (var p in b) {
                        if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            (function (factory) {
                if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
                    var v = factory(require, exports);
                    if (v !== undefined) module.exports = v;
                } else if (typeof define === "function" && define.amd) {
                    define(["require", "exports"], factory);
                }
            })(function (require, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", { value: true });
                var MultiStyleText = function (_super) {
                    __extends(MultiStyleText, _super);
                    function MultiStyleText(text, styles) {
                        var _this = _super.call(this, text) || this;
                        _this.styles = styles;
                        return _this;
                    }
                    Object.defineProperty(MultiStyleText.prototype, "styles", {
                        set: function set(styles) {
                            this.textStyles = {};
                            this.textStyles["default"] = this.assign({}, MultiStyleText.DEFAULT_TAG_STYLE);
                            for (var style in styles) {
                                if (style === "default") {
                                    this.assign(this.textStyles["default"], styles[style]);
                                } else {
                                    this.textStyles[style] = this.assign({}, styles[style]);
                                }
                            }
                            this._style = new PIXI.TextStyle(this.textStyles["default"]);
                            this.dirty = true;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    MultiStyleText.prototype.setTagStyle = function (tag, style) {
                        if (tag in this.textStyles) {
                            this.assign(this.textStyles[tag], style);
                        } else {
                            this.textStyles[tag] = this.assign({}, style);
                        }
                        this._style = new PIXI.TextStyle(this.textStyles["default"]);
                        this.dirty = true;
                    };
                    MultiStyleText.prototype.deleteTagStyle = function (tag) {
                        if (tag === "default") {
                            this.textStyles["default"] = this.assign({}, MultiStyleText.DEFAULT_TAG_STYLE);
                        } else {
                            delete this.textStyles[tag];
                        }
                        this._style = new PIXI.TextStyle(this.textStyles["default"]);
                        this.dirty = true;
                    };
                    MultiStyleText.prototype._getTextDataPerLine = function (lines) {
                        var outputTextData = [];
                        var tags = Object.keys(this.textStyles).join("|");
                        var re = new RegExp("</?(" + tags + ")>", "g");
                        var styleStack = [this.assign({}, this.textStyles["default"])];
                        var tagNameStack = ["default"];
                        for (var i = 0; i < lines.length; i++) {
                            var lineTextData = [];
                            var matches = [];
                            var matchArray = void 0;
                            while (matchArray = re.exec(lines[i])) {
                                matches.push(matchArray);
                            }
                            if (matches.length === 0) {
                                lineTextData.push(this.createTextData(lines[i], styleStack[styleStack.length - 1], tagNameStack[tagNameStack.length - 1]));
                            } else {
                                var currentSearchIdx = 0;
                                for (var j = 0; j < matches.length; j++) {
                                    if (matches[j].index > currentSearchIdx) {
                                        lineTextData.push(this.createTextData(lines[i].substring(currentSearchIdx, matches[j].index), styleStack[styleStack.length - 1], tagNameStack[tagNameStack.length - 1]));
                                    }
                                    if (matches[j][0][1] === "/") {
                                        if (styleStack.length > 1) {
                                            styleStack.pop();
                                            tagNameStack.pop();
                                        }
                                    } else {
                                        styleStack.push(this.assign({}, styleStack[styleStack.length - 1], this.textStyles[matches[j][1]]));
                                        tagNameStack.push(matches[j][1]);
                                    }
                                    currentSearchIdx = matches[j].index + matches[j][0].length;
                                }
                                if (currentSearchIdx < lines[i].length) {
                                    lineTextData.push(this.createTextData(lines[i].substring(currentSearchIdx), styleStack[styleStack.length - 1], tagNameStack[tagNameStack.length - 1]));
                                }
                            }
                            outputTextData.push(lineTextData);
                        }
                        return outputTextData;
                    };
                    MultiStyleText.prototype.getFontString = function (style) {
                        return new PIXI.TextStyle(style).toFontString();
                    };
                    MultiStyleText.prototype.createTextData = function (text, style, tagName) {
                        return {
                            text: text,
                            style: style,
                            width: 0,
                            height: 0,
                            fontProperties: undefined,
                            tagName: tagName
                        };
                    };
                    MultiStyleText.prototype.getDropShadowPadding = function () {
                        var _this = this;
                        var maxDistance = 0;
                        var maxBlur = 0;
                        Object.keys(this.textStyles).forEach(function (styleKey) {
                            var _a = _this.textStyles[styleKey],
                                dropShadowDistance = _a.dropShadowDistance,
                                dropShadowBlur = _a.dropShadowBlur;
                            maxDistance = Math.max(maxDistance, dropShadowDistance || 0);
                            maxBlur = Math.max(maxBlur, dropShadowBlur || 0);
                        });
                        return maxDistance + maxBlur;
                    };
                    MultiStyleText.prototype.updateText = function () {
                        var _this = this;
                        if (!this.dirty) {
                            return;
                        }
                        this.texture.baseTexture.resolution = this.resolution;
                        var textStyles = this.textStyles;
                        var outputText = this.text;
                        if (this._style.wordWrap) {
                            outputText = this.wordWrap(this.text);
                        }
                        var lines = outputText.split(/(?:\r\n|\r|\n)/);
                        var outputTextData = this._getTextDataPerLine(lines);
                        var lineWidths = [];
                        var lineYMins = [];
                        var lineYMaxs = [];
                        var baselines = [];
                        var maxLineWidth = 0;
                        for (var i = 0; i < lines.length; i++) {
                            var lineWidth = 0;
                            var lineYMin = 0;
                            var lineYMax = 0;
                            var baseline = 0;
                            for (var j = 0; j < outputTextData[i].length; j++) {
                                var sty = outputTextData[i][j].style;
                                this.context.font = this.getFontString(sty);
                                outputTextData[i][j].width = this.context.measureText(outputTextData[i][j].text).width;
                                if (outputTextData[i][j].text.length === 0) {
                                    outputTextData[i][j].width += (outputTextData[i][j].text.length - 1) * sty.letterSpacing;
                                    if (j > 0) {
                                        lineWidth += sty.letterSpacing / 2;
                                    }
                                    if (j < outputTextData[i].length - 1) {
                                        lineWidth += sty.letterSpacing / 2;
                                    }
                                }
                                lineWidth += outputTextData[i][j].width;
                                outputTextData[i][j].fontProperties = PIXI.TextMetrics.measureFont(this.context.font);
                                outputTextData[i][j].height = outputTextData[i][j].fontProperties.fontSize + outputTextData[i][j].style.strokeThickness;
                                if (typeof sty.valign === "number") {
                                    lineYMin = Math.min(lineYMin, sty.valign - outputTextData[i][j].fontProperties.descent);
                                    lineYMax = Math.max(lineYMax, sty.valign + outputTextData[i][j].fontProperties.ascent);
                                } else {
                                    lineYMin = Math.min(lineYMin, -outputTextData[i][j].fontProperties.descent);
                                    lineYMax = Math.max(lineYMax, outputTextData[i][j].fontProperties.ascent);
                                }
                            }
                            //owain
                            var foo = Object.keys(textStyles).map(function (key) {
                                return textStyles[key];
                            });
                            var myValue;
                            var bar = foo.reduce(function (prev, cur) {
                                myValue = cur.strokeThickness;
                                return Math.max(prev, cur.strokeThickness || 0);
                            }, 0);
                            lineWidth += myValue * 8; //owain - hacky fix for cut off text when using a stroke (I think 8 is stroke width)
                            lineWidths[i] = lineWidth;
                            lineYMins[i] = lineYMin;
                            lineYMaxs[i] = lineYMax;
                            maxLineWidth = Math.max(maxLineWidth, lineWidth);
                        }
                        var stylesArray = Object.keys(textStyles).map(function (key) {
                            return textStyles[key];
                        });
                        var maxStrokeThickness = stylesArray.reduce(function (prev, cur) {
                            return Math.max(prev, cur.strokeThickness || 0);
                        }, 0);
                        var dropShadowPadding = this.getDropShadowPadding();
                        var totalHeight = lineYMaxs.reduce(function (prev, cur) {
                            return prev + cur;
                        }, 0) - lineYMins.reduce(function (prev, cur) {
                            return prev + cur;
                        }, 0);
                        var width = maxLineWidth + maxStrokeThickness + 2 * dropShadowPadding;
                        var height = totalHeight + 2 * dropShadowPadding;
                        this.canvas.width = (width + this.context.lineWidth) * this.resolution;
                        this.canvas.height = height * this.resolution;
                        this.context.scale(this.resolution, this.resolution);
                        this.context.textBaseline = "alphabetic";
                        this.context.lineJoin = "round";
                        var basePositionY = dropShadowPadding;
                        var drawingData = [];
                        for (var i = 0; i < outputTextData.length; i++) {
                            var line = outputTextData[i];
                            var linePositionX = void 0;
                            switch (this._style.align) {
                                case "left":
                                    linePositionX = dropShadowPadding;
                                    break;
                                case "center":
                                    linePositionX = dropShadowPadding + (maxLineWidth - lineWidths[i]) / 2;
                                    break;
                                case "right":
                                    linePositionX = dropShadowPadding + maxLineWidth - lineWidths[i];
                                    break;
                            }
                            for (var j = 0; j < line.length; j++) {
                                var _a = line[j],
                                    style = _a.style,
                                    text = _a.text,
                                    fontProperties = _a.fontProperties,
                                    width_1 = _a.width,
                                    height_1 = _a.height,
                                    tagName = _a.tagName;
                                linePositionX += maxStrokeThickness / 2;
                                var linePositionY = maxStrokeThickness / 2 + basePositionY + fontProperties.ascent;
                                switch (style.valign) {
                                    case "top":
                                        break;
                                    case "baseline":
                                        linePositionY += lineYMaxs[i] - fontProperties.ascent;
                                        break;
                                    case "middle":
                                        linePositionY += (lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent) / 2;
                                        break;
                                    case "bottom":
                                        linePositionY += lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent;
                                        break;
                                    default:
                                        linePositionY += lineYMaxs[i] - fontProperties.ascent - style.valign;
                                        break;
                                }
                                if (style.letterSpacing === 0) {
                                    drawingData.push({
                                        text: text,
                                        style: style,
                                        x: linePositionX,
                                        y: linePositionY,
                                        width: width_1,
                                        ascent: fontProperties.ascent,
                                        descent: fontProperties.descent,
                                        tagName: tagName
                                    });
                                    linePositionX += line[j].width;
                                } else {
                                    this.context.font = this.getFontString(line[j].style);
                                    for (var k = 0; k < text.length; k++) {
                                        if (k > 0 || j > 0) {
                                            linePositionX += style.letterSpacing / 2;
                                        }
                                        drawingData.push({
                                            text: text.charAt(k),
                                            style: style,
                                            x: linePositionX,
                                            y: linePositionY,
                                            width: width_1,
                                            ascent: fontProperties.ascent,
                                            descent: fontProperties.descent,
                                            tagName: tagName
                                        });
                                        linePositionX += this.context.measureText(text.charAt(k)).width;
                                        if (k < text.length - 1 || j < line.length - 1) {
                                            linePositionX += style.letterSpacing / 2;
                                        }
                                    }
                                }
                                linePositionX -= maxStrokeThickness / 2;
                            }
                            basePositionY += lineYMaxs[i] - lineYMins[i];
                        }
                        this.context.save();
                        drawingData.forEach(function (_a) {
                            var style = _a.style,
                                text = _a.text,
                                x = _a.x,
                                y = _a.y;
                            if (!style.dropShadow) {
                                return;
                            }
                            _this.context.font = _this.getFontString(style);
                            var dropFillStyle = style.dropShadowColor;
                            if (typeof dropFillStyle === "number") {
                                dropFillStyle = PIXI.utils.hex2string(dropFillStyle);
                            }
                            _this.context.shadowColor = dropFillStyle;
                            _this.context.shadowBlur = style.dropShadowBlur;
                            _this.context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
                            _this.context.shadowOffsetY = Math.sin(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
                            _this.context.fillText(text, x, y);
                        });
                        this.context.restore();
                        drawingData.forEach(function (_a) {
                            var style = _a.style,
                                text = _a.text,
                                x = _a.x,
                                y = _a.y,
                                width = _a.width,
                                ascent = _a.ascent,
                                descent = _a.descent,
                                tagName = _a.tagName;
                            _this.context.font = _this.getFontString(style);
                            var strokeStyle = style.stroke;
                            if (typeof strokeStyle === "number") {
                                strokeStyle = PIXI.utils.hex2string(strokeStyle);
                            }
                            _this.context.strokeStyle = strokeStyle;
                            _this.context.lineWidth = style.strokeThickness;
                            var fillStyle = style.fill;
                            if (typeof fillStyle === "number") {
                                fillStyle = PIXI.utils.hex2string(fillStyle);
                            } else if (Array.isArray(fillStyle)) {
                                for (var i = 0; i < fillStyle.length; i++) {
                                    var fill = fillStyle[i];
                                    if (typeof fill === "number") {
                                        fillStyle[i] = PIXI.utils.hex2string(fill);
                                    }
                                }
                            }
                            _this.context.fillStyle = _this._generateFillStyle(new PIXI.TextStyle(style), [text]);
                            if (style.stroke && style.strokeThickness) {
                                _this.context.strokeText(text, x, y);
                            }
                            if (style.fill) {
                                _this.context.fillText(text, x, y);
                            }
                            var debugSpan = style.debug === undefined ? MultiStyleText.debugOptions.spans.enabled : style.debug;
                            if (debugSpan) {
                                _this.context.lineWidth = 1;
                                if (MultiStyleText.debugOptions.spans.bounding) {
                                    _this.context.fillStyle = MultiStyleText.debugOptions.spans.bounding;
                                    _this.context.strokeStyle = MultiStyleText.debugOptions.spans.bounding;
                                    _this.context.beginPath();
                                    _this.context.rect(x, y - ascent, width, ascent + descent);
                                    _this.context.fill();
                                    _this.context.stroke();
                                    _this.context.stroke();
                                }
                                if (MultiStyleText.debugOptions.spans.baseline) {
                                    _this.context.strokeStyle = MultiStyleText.debugOptions.spans.baseline;
                                    _this.context.beginPath();
                                    _this.context.moveTo(x, y);
                                    _this.context.lineTo(x + width, y);
                                    _this.context.closePath();
                                    _this.context.stroke();
                                }
                                if (MultiStyleText.debugOptions.spans.top) {
                                    _this.context.strokeStyle = MultiStyleText.debugOptions.spans.top;
                                    _this.context.beginPath();
                                    _this.context.moveTo(x, y - ascent);
                                    _this.context.lineTo(x + width, y - ascent);
                                    _this.context.closePath();
                                    _this.context.stroke();
                                }
                                if (MultiStyleText.debugOptions.spans.bottom) {
                                    _this.context.strokeStyle = MultiStyleText.debugOptions.spans.bottom;
                                    _this.context.beginPath();
                                    _this.context.moveTo(x, y + descent);
                                    _this.context.lineTo(x + width, y + descent);
                                    _this.context.closePath();
                                    _this.context.stroke();
                                }
                                if (MultiStyleText.debugOptions.spans.text) {
                                    _this.context.fillStyle = "#ffffff";
                                    _this.context.strokeStyle = "#000000";
                                    _this.context.lineWidth = 2;
                                    _this.context.font = "8px monospace";
                                    _this.context.strokeText(tagName, x, y - ascent + 8);
                                    _this.context.fillText(tagName, x, y - ascent + 8);
                                    _this.context.strokeText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
                                    _this.context.fillText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
                                }
                            }
                        });
                        if (MultiStyleText.debugOptions.objects.enabled) {
                            if (MultiStyleText.debugOptions.objects.bounding) {
                                this.context.fillStyle = MultiStyleText.debugOptions.objects.bounding;
                                this.context.beginPath();
                                this.context.rect(0, 0, width, height);
                                this.context.fill();
                            }
                            if (MultiStyleText.debugOptions.objects.text) {
                                this.context.fillStyle = "#ffffff";
                                this.context.strokeStyle = "#000000";
                                this.context.lineWidth = 2;
                                this.context.font = "8px monospace";
                                this.context.strokeText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
                                this.context.fillText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
                            }
                        }
                        this.updateTexture();
                    };
                    MultiStyleText.prototype.wordWrap = function (text) {
                        var result = '';
                        var tags = Object.keys(this.textStyles).join("|");
                        var re = new RegExp("(</?(" + tags + ")>)", "g");
                        var lines = text.split("\n");
                        var wordWrapWidth = this._style.wordWrapWidth;
                        var styleStack = [this.assign({}, this.textStyles["default"])];
                        this.context.font = this.getFontString(this.textStyles["default"]);
                        for (var i = 0; i < lines.length; i++) {
                            var spaceLeft = wordWrapWidth;
                            var words = lines[i].split(" ");
                            for (var j = 0; j < words.length; j++) {
                                var parts = words[j].split(re);
                                for (var k = 0; k < parts.length; k++) {
                                    if (re.test(parts[k])) {
                                        result += parts[k];
                                        if (parts[k][1] === "/") {
                                            k++;
                                            styleStack.pop();
                                        } else {
                                            k++;
                                            styleStack.push(this.assign({}, styleStack[styleStack.length - 1], this.textStyles[parts[k]]));
                                        }
                                        this.context.font = this.getFontString(styleStack[styleStack.length - 1]);
                                        continue;
                                    }
                                    var partWidth = this.context.measureText(parts[k]).width;
                                    if (this._style.breakWords && partWidth > spaceLeft) {
                                        var characters = parts[k].split('');
                                        if (j > 0 && k === 0) {
                                            result += " ";
                                            spaceLeft -= this.context.measureText(" ").width;
                                        }
                                        for (var c = 0; c < characters.length; c++) {
                                            var characterWidth = this.context.measureText(characters[c]).width;
                                            if (characterWidth > spaceLeft) {
                                                result += "\n" + characters[c];
                                                spaceLeft = wordWrapWidth - characterWidth;
                                            } else {
                                                if (j > 0 && k === 0 && c === 0) {
                                                    result += " ";
                                                }
                                                result += characters[c];
                                                spaceLeft -= characterWidth;
                                            }
                                        }
                                    } else if (this._style.breakWords) {
                                        result += parts[k];
                                        spaceLeft -= partWidth;
                                    } else {
                                        var paddedPartWidth = partWidth + (k === 0 ? this.context.measureText(" ").width : 0);
                                        if (j === 0 || paddedPartWidth > spaceLeft) {
                                            if (j > 0) {
                                                result += "\n";
                                            }
                                            result += parts[k];
                                            spaceLeft = wordWrapWidth - partWidth;
                                        } else {
                                            spaceLeft -= paddedPartWidth;
                                            if (k === 0) {
                                                result += " ";
                                            }
                                            result += parts[k];
                                        }
                                    }
                                }
                            }
                            if (i < lines.length - 1) {
                                result += '\n';
                            }
                        }
                        return result;
                    };
                    MultiStyleText.prototype.updateTexture = function () {
                        var texture = this._texture;
                        var dropShadowPadding = this.getDropShadowPadding();
                        texture.baseTexture.hasLoaded = true;
                        texture.baseTexture.resolution = this.resolution;
                        texture.baseTexture.realWidth = this.canvas.width;
                        texture.baseTexture.realHeight = this.canvas.height;
                        texture.baseTexture.width = this.canvas.width / this.resolution;
                        texture.baseTexture.height = this.canvas.height / this.resolution;
                        texture.trim.width = texture.frame.width = this.canvas.width / this.resolution;
                        texture.trim.height = texture.frame.height = this.canvas.height / this.resolution;
                        texture.trim.x = -this._style.padding - dropShadowPadding;
                        texture.trim.y = -this._style.padding - dropShadowPadding;
                        texture.orig.width = texture.frame.width - (this._style.padding + dropShadowPadding) * 2;
                        texture.orig.height = texture.frame.height - (this._style.padding + dropShadowPadding) * 2;
                        this._onTextureUpdate();
                        texture.baseTexture.emit('update', texture.baseTexture);
                        this.dirty = false;
                    };
                    MultiStyleText.prototype.assign = function (destination) {
                        var sources = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            sources[_i - 1] = arguments[_i];
                        }
                        for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
                            var source = sources_1[_a];
                            for (var key in source) {
                                destination[key] = source[key];
                            }
                        }
                        return destination;
                    };
                    return MultiStyleText;
                }(PIXI.Text);
                MultiStyleText.DEFAULT_TAG_STYLE = {
                    align: "left",
                    breakWords: false,
                    dropShadow: false,
                    dropShadowAngle: Math.PI / 6,
                    dropShadowBlur: 0,
                    dropShadowColor: "#000000",
                    dropShadowDistance: 5,
                    fill: "black",
                    fillGradientType: PIXI.TEXT_GRADIENT.LINEAR_VERTICAL,
                    fontFamily: "Arial",
                    fontSize: 26,
                    fontStyle: "normal",
                    fontVariant: "normal",
                    fontWeight: "normal",
                    letterSpacing: 0,
                    lineHeight: 0,
                    lineJoin: "miter",
                    miterLimit: 10,
                    padding: 0,
                    stroke: "black",
                    strokeThickness: 0,
                    textBaseline: "alphabetic",
                    valign: "baseline",
                    wordWrap: false,
                    wordWrapWidth: 100
                };
                MultiStyleText.debugOptions = {
                    spans: {
                        enabled: false,
                        baseline: "#44BB44",
                        top: "#BB4444",
                        bottom: "#4444BB",
                        bounding: "rgba(255, 255, 255, 0.1)",
                        text: true
                    },
                    objects: {
                        enabled: false,
                        bounding: "rgba(255, 255, 255, 0.05)",
                        text: true
                    }
                };
                exports.default = MultiStyleText;
            });
        }, {}] }, {}, [1])(1);
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./pixi-multistyle-text":26}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _SimpleScene2 = require("./SimpleScene");

var _SimpleScene3 = _interopRequireDefault(_SimpleScene2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GallerySelectionScene = function (_SimpleScene) {
    _inherits(GallerySelectionScene, _SimpleScene);

    function GallerySelectionScene() {
        _classCallCheck(this, GallerySelectionScene);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (GallerySelectionScene.__proto__ || Object.getPrototypeOf(GallerySelectionScene)).call(this));

        _this._colourItBtn = null;
        _this._drawItBtn = null;
        _this._colourItText = null;
        _this._drawItText = null;
        _this._titleSprite = null;
        _this._titleText = null;
        _this._colourItSprite = null;
        _this._drawItSprite = null;
        return _this;
    }

    _createClass(GallerySelectionScene, [{
        key: "init",
        value: function init() {

            this._bgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("bg")); //not sure why this is like this, but must create background first
            _get(GallerySelectionScene.prototype.__proto__ || Object.getPrototypeOf(GallerySelectionScene.prototype), "init", this).call(this);

            /*
             deprecated title sprite and text
             */

            // Title sprite.
            // this._titleSprite = new PIXI.Sprite(Common.assets.getTexture("popup_box_title_bg"));
            //  this._titleSprite.y = this._titleSprite.height * 0.5;
            //  this._titleSprite.x = Common.STAGE_WIDTH * 0.5;
            //  this._titleSprite.anchor = new PIXI.Point(0.5, 0.75);
            //  this.addChild(this._titleSprite);

            // Title text.
            /*
             let bkText = P3.createText("GAMES", {
             fill: [0xfff8b3, 0xfac109],
             size: "90px",
             wordWrap: true,
             wordWrapWidth: 500,
             stroke: 0x23a838,
             strokeThickness: 14,
             align: "centre"
             });
               this._titleText = P3.createText("GAMES", {
             fill: [0xfff8b3, 0xfac109],
             size: "90px",
             wordWrap: true,
             wordWrapWidth: 500,
             stroke: 0x006130,
             align: "centre",
             strokeThickness: 8
             });
               this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
             this._titleText.y = bkText.y = -45;
             this._titleSprite.addChild(bkText, this._titleText);
             */

            // Colour gallery.
            // Image.
            var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("game_colour"), _Common2.default.assets.getTexture("game_colour"), _Common2.default.assets.getTexture("game_colour"));
            this._colourItSprite = new P3.Button(btnStatesAux);
            this._colourItSprite.signals.click.addOnce(this._onColourGalleryButton_Click, this);
            this._colourItSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._colourItSprite.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5 - 255, _Common2.default.STAGE_HEIGHT * 0.5);
            this.addChild(this._colourItSprite);

            var colourItTextConf = {
                size: "75px",
                fill: "#3992ff",
                stroke: "#2c1812",
                wordWrapWidth: 400
            };
            this._colourItText = P3.createMultiText("COLOUR_IT", colourItTextConf);

            this._colourItText.anchor = new PIXI.Point(0.5, 0.5);
            this._colourItText.y = -this._colourItSprite.height * 0.5 + 15;
            this._colourItSprite.addChild(this._colourItText);

            // Button.
            this._colourItBtn = createButton("play_large", "primary_large");
            this._colourItBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._colourItBtn.y = this._colourItSprite.y + this._colourItSprite.height * 0.5;
            this._colourItBtn.x = this._colourItSprite.x;
            this._colourItBtn.overSoundName = "sfx_ui_rollover_00";
            this._colourItBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
            this._colourItBtn.signals.click.addOnce(this._onColourGalleryButton_Click, this);
            this.addChild(this._colourItBtn);

            // Draw gallery.
            // Image.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("game_draw"), _Common2.default.assets.getTexture("game_draw"), _Common2.default.assets.getTexture("game_draw"));
            this._drawItSprite = new P3.Button(btnStatesAux);
            this._drawItSprite.signals.click.addOnce(this._onDrawGalleryButton_Click, this);

            this._drawItSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._drawItSprite.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5 + 255, _Common2.default.STAGE_HEIGHT * 0.5);
            this.addChild(this._drawItSprite);

            this._drawItText = P3.createText("DRAW_IT", {
                size: "75px",
                fill: "white",
                stroke: "#2c1812",
                stokeThickness: 6,
                wordWrap: true,
                wordWrapWidth: 300
            }, "truetype");

            this._drawItText.anchor = new PIXI.Point(0.5, 0.5);
            this._drawItText.y = -this._drawItSprite.height * 0.5 + 15;
            this._drawItSprite.addChild(this._drawItText);
            // Button.

            this._drawItBtn = createButton("play_large", "primary_large");
            this._drawItBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._drawItBtn.position.y = this._drawItSprite.y + this._drawItSprite.height * 0.5;
            this._drawItBtn.position.x = this._drawItSprite.x;
            this._drawItBtn.overSoundName = "sfx_ui_rollover_00";
            this._drawItBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
            this._drawItBtn.signals.click.addOnce(this._onDrawGalleryButton_Click, this);
            this.addChild(this._drawItBtn);

            _get(GallerySelectionScene.prototype.__proto__ || Object.getPrototypeOf(GallerySelectionScene.prototype), "createSharedControls", this).call(this, this);
            this._uiTopBarSharedControls.muteBtn.visible = true;
            this._uiTopBarSharedControls.backBtn.visible = true;
            this._uiTopBarSharedControls.signals.onBackBtn_Click.addOnce(function () {
                this.signals.previous.dispatch(this);
            }, this);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(GallerySelectionScene.prototype.__proto__ || Object.getPrototypeOf(GallerySelectionScene.prototype), "destroy", this).call(this, { children: true });
            TweenMax.killAll();
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            //this._titleSprite.y -= 100;
            // TweenMax.to(this._titleSprite, 1.5, {y: this._titleSprite.y + 100, ease: Elastic.easeOut});

            this._drawItSprite.x += 100;
            this._drawItSprite.alpha = 0;
            TweenMax.to(this._drawItSprite, 0.25, { alpha: 1, x: this._drawItSprite.x - 100, ease: Sine.easeOut });

            this._colourItSprite.x -= 100;
            this._colourItSprite.alpha = 0;
            TweenMax.to(this._colourItSprite, 0.25, { alpha: 1, x: this._colourItSprite.x + 100, ease: Sine.easeOut });

            this._drawItBtn.alpha = 0;
            this._drawItBtn.scale = new PIXI.Point();
            TweenMax.to(this._drawItBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.2 });
            TweenMax.to(this._drawItBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2 });

            this._colourItBtn.alpha = 0;
            this._colourItBtn.scale = new PIXI.Point();
            TweenMax.to(this._colourItBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.35 });
            TweenMax.to(this._colourItBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.35 });
        }

        //----EVENTS----//

    }, {
        key: "_onColourGalleryButton_Click",
        value: function _onColourGalleryButton_Click() {
            _CommonGame2.default.selectedGallery = _CommonGame2.default.GALLERY_ID_COLOUR_IT;
            this.signals.next.dispatch(this);
        }
    }, {
        key: "_onDrawGalleryButton_Click",
        value: function _onDrawGalleryButton_Click() {
            _CommonGame2.default.selectedGallery = _CommonGame2.default.GALLERY_ID_DRAW_IT;
            this.signals.next.dispatch(this);
        }
    }]);

    return GallerySelectionScene;
}(_SimpleScene3.default);

exports.default = GallerySelectionScene;

},{"../Common":3,"../CommonGame":4,"./SimpleScene":32}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _MyGame = require("../game/MyGame");

var _MyGame2 = _interopRequireDefault(_MyGame);

var _Tutorial = require("../game/Tutorial");

var _Tutorial2 = _interopRequireDefault(_Tutorial);

var _MenuPanel = require("../ui/overlays/MenuPanel");

var _MenuPanel2 = _interopRequireDefault(_MenuPanel);

var _PalettePanel = require("../ui/overlays/PalettePanel");

var _PalettePanel2 = _interopRequireDefault(_PalettePanel);

var _PaletteButton = require("../game/PaletteButton");

var _PaletteButton2 = _interopRequireDefault(_PaletteButton);

var _SimpleScene2 = require("./SimpleScene");

var _SimpleScene3 = _interopRequireDefault(_SimpleScene2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GameScene = function (_SimpleScene) {
    _inherits(GameScene, _SimpleScene);

    function GameScene() {
        _classCallCheck(this, GameScene);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (GameScene.__proto__ || Object.getPrototypeOf(GameScene)).call(this));

        _this._menuPanel = null;
        _this._tutorial = null;

        _this._gameLayer = null;
        _this._tutorialLayer = null;
        _this._overlayLayer = null;
        return _this;
    }

    _createClass(GameScene, [{
        key: "init",
        value: function init() {

            this._bgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("bg")); //not sure why this is like this, but must create background first
            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "init", this).call(this);

            // Layers.
            this._gameLayer = new PIXI.Container();
            this.addChild(this._gameLayer);
            this._tutorialLayer = new PIXI.Container();
            this.addChild(this._tutorialLayer);
            this._overlayLayer = new PIXI.Container();
            this.addChild(this._overlayLayer);

            // Overlay initialization. Order is important due to dependencies.
            // Menu.
            this._menuPanel = new _MenuPanel2.default(this.signals);
            this._menuPanel.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);
            this._menuPanel.init();
            this._overlayLayer.addChild(this._menuPanel);

            // Palette.
            this._palettePanel = new _PalettePanel2.default();
            this._palettePanel.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);
            this._palettePanel.init();
            this._overlayLayer.addChild(this._palettePanel);

            // Game.
            _Common2.default.game = new _MyGame2.default();
            _Common2.default.game.scene = this;
            _Common2.default.game.init();

            // Tutorial.
            if (_Common2.default.savedData.isDrawTutorial || _Common2.default.savedData.isToolTutorial || _Common2.default.savedData.isPaletteTutorial) {
                this._tutorial = new _Tutorial2.default();
                this._tutorial.init();
                this._tutorial.signals.onCompleted.addOnce(function () {
                    this._tutorial.end();
                    this._tutorial.destroy();
                    this._tutorial = null;
                }, this);
                this._tutorialLayer.addChild(this._tutorial);
            }

            // Signals.
            // Link the panels to the HUD buttons that show them.
            _Common2.default.game.hud.signals.onMenuClick.add(this._onMenuBtn_Click, this);
            _Common2.default.game.hud.signals.onPaletteClick.add(this._onPaletteBtn_Click, this);

            this.createSharedControls();
        }
    }, {
        key: "update",
        value: function update() {
            if (this._tutorial) this._tutorial.update();
            _Common2.default.game.update();
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            // Music.
            _Common2.default.audio.stopMusic();
            _Common2.default.audio.playMusic("sfx_ambient_desert_loop_00");

            _Common2.default.game.animateIn();
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (P3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;

            _Common2.default.game.resize();
            if (this._tutorial) this._tutorial.resize();
        }
    }, {
        key: "addTutorialEvent",
        value: function addTutorialEvent(tutorialEvent) {
            if (this._tutorial) this._tutorial.addEvent(tutorialEvent);
        }

        //----EVENTS----//

    }, {
        key: "_onMenuBtn_Click",
        value: function _onMenuBtn_Click() {
            this._menuPanel.show();
        }
    }, {
        key: "_onPaletteBtn_Click",
        value: function _onPaletteBtn_Click(toolType) {
            // Show palette panel.
            this._palettePanel.show(toolType);

            // Tutorial.
            _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.PALETTE_SELECTED);
        }
    }, {
        key: "gameLayer",
        get: function get() {
            return this._gameLayer;
        }
    }, {
        key: "palettePanel",
        get: function get() {
            return this._palettePanel;
        }
    }]);

    return GameScene;
}(_SimpleScene3.default);

exports.default = GameScene;

},{"../Common":3,"../CommonGame":4,"../game/MyGame":18,"../game/PaletteButton":19,"../game/Tutorial":23,"../ui/overlays/MenuPanel":37,"../ui/overlays/PalettePanel":38,"./SimpleScene":32}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _SimpleScene2 = require("./SimpleScene");

var _SimpleScene3 = _interopRequireDefault(_SimpleScene2);

var _UICarousel = require("../ui/UICarousel");

var _UICarousel2 = _interopRequireDefault(_UICarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageSelectionScene = function (_SimpleScene) {
    _inherits(ImageSelectionScene, _SimpleScene);

    function ImageSelectionScene() {
        _classCallCheck(this, ImageSelectionScene);

        // Constants.
        var _this = _possibleConstructorReturn(this, (ImageSelectionScene.__proto__ || Object.getPrototypeOf(ImageSelectionScene)).call(this));

        _this.ARR_DRAW_IT_TEXT_ID = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        _this.ARR_IMAGE_SPRITE_ID = []; //from legacy project, working around//--
        _this._imageLength = _this.ARR_DRAW_IT_TEXT_ID.length;

        for (var i = 0; i < _this._imageLength; i++) {
            _this.ARR_IMAGE_SPRITE_ID.push("image_" + (i + 1)); //--
        }

        // Attributes.
        _this._titleSprite = null;
        _this._titleText = null;

        // UI.
        _this._playBtn = null;
        _this._prevImageBtn = null;
        _this._nextImageBtn = null;
        _this._uiCarousel = null;
        return _this;
    }

    _createClass(ImageSelectionScene, [{
        key: "init",
        value: function init() {

            this._bgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("bg")); //for some reason bg must be created before super is called
            _get(ImageSelectionScene.prototype.__proto__ || Object.getPrototypeOf(ImageSelectionScene.prototype), "init", this).call(this);

            this.imagePrefix = _CommonGame2.default.selectedGallery == _CommonGame2.default.GALLERY_ID_COLOUR_IT ? "colour_" : "draw_";
            /*
             // Title sprite.
             this._titleSprite = new PIXI.Sprite(Common.assets.getTexture("popup_box_title_bg"));
             this._titleSprite.y = this._titleSprite.height * 0.5;
             this._titleSprite.x = Common.STAGE_WIDTH * 0.5;
             this._titleSprite.anchor = new PIXI.Point(0.5, 0.75);
             this.addChild(this._titleSprite);
               // Title text.
               // Title text.
             let bkText = P3.createText("DRAWINGS", {
             fill: [0xfff8b3, 0xfac109],
             size: "90px",
             wordWrap: true,
             wordWrapWidth: 500,
             stroke: 0x23a838,
             strokeThickness: 14,
             align: "centre"
             });
               this._titleText = P3.createText("DRAWINGS", {
             fill: [0xfff8b3, 0xfac109],
             size: "90px",
             wordWrap: true,
             wordWrapWidth: 500,
             stroke: 0x006130,
             align: "centre",
             strokeThickness: 8
             });
               this._titleText.y = bkText.y = -45;
             this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
             this._titleSprite.addChild(bkText, this._titleText);
             */
            // Carousel items.
            var arrCarouselItem = [];
            for (var i = 0; i < this._imageLength; i++) {
                // Container.
                var carouselItem = new PIXI.Container();
                carouselItem.scale = new PIXI.Point(0.6, 0.6);
                carouselItem.anchor = new PIXI.Point(0.5, 0.5);

                carouselItem.addChild(_CommonGame2.default.createCanvasBg());

                // Bg.
                var bgSprite = new PIXI.Sprite(_Common2.default.blankTexture);
                bgSprite.anchor = new PIXI.Point(0.5, 0.5);
                bgSprite.width = _CommonGame2.default.CANVAS_WIDTH;
                bgSprite.height = _CommonGame2.default.CANVAS_HEIGHT;
                bgSprite.tint = 0xffffff;

                carouselItem.addChild(bgSprite);

                var galleryKey = "drawing";
                if (_CommonGame2.default.selectedGallery === 1) galleryKey = "colouring";

                // Border.
                var borderSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("canvas_" + galleryKey));
                borderSprite.anchor = new PIXI.Point(0.5, 0.5);
                carouselItem.addChild(borderSprite);
                // Sprite.
                var imageSprite = new PIXI.Sprite(_Common2.default.assets.getTexture(this.imagePrefix + "image_" + (i + 1)));
                imageSprite.anchor = new PIXI.Point(0.5, 0.5);
                carouselItem.addChild(imageSprite);

                arrCarouselItem.push(carouselItem);
            }

            // UICarousel.
            this._uiCarousel = new _UICarousel2.default();
            this._uiCarousel.init(arrCarouselItem);
            this._uiCarousel.signals.onIndexChanged.add(this._onCarouselIndex_Changed, this);
            this._uiCarousel.signals.onItemSelected.add(this._onPlayButton_Click, this);
            this.addChild(this._uiCarousel);

            // Play button.
            var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("btn_primary_large_off"), _Common2.default.assets.getTexture("btn_primary_large_over"), _Common2.default.assets.getTexture("btn_primary_large_down"), _Common2.default.assets.getTexture("icon_play_large_off"));
            this._playBtn = createButton("play_large", "primary_large");
            this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._playBtn.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5 + 220);
            this._playBtn.overSoundName = "sfx_ui_rollover_00";
            this._playBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
            this._playBtn.signals.click.addOnce(this._onPlayButton_Click, this);
            this.addChild(this._playBtn);

            // Next image button.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_next_off"), _Common2.default.assets.getTexture("icon_next_over"), _Common2.default.assets.getTexture("icon_next_down"));

            this._nextImageBtn = new P3.Button(btnStatesAux);
            this._nextImageBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._nextImageBtn.scale = new PIXI.Point(1.5, 1.5);
            this._nextImageBtn.defaultScale = new PIXI.Point(1.5, 1.5);
            this._nextImageBtn.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5 + 400, _Common2.default.STAGE_HEIGHT * 0.5);
            this._nextImageBtn.signals.click.add(this._onNextImageButton_Click, this);
            this.addChild(this._nextImageBtn);

            // Prev image button.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_next_off"), _Common2.default.assets.getTexture("icon_next_over"), _Common2.default.assets.getTexture("icon_next_down"));

            this._prevImageBtn = new P3.Button(btnStatesAux);
            this._prevImageBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._prevImageBtn.scale = new PIXI.Point(-1.5, 1.5);
            this._prevImageBtn.alpha = 0;

            this._prevImageBtn.defaultScale = new PIXI.Point(-1.5, 1.5);
            this._prevImageBtn.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5 - 400, _Common2.default.STAGE_HEIGHT * 0.5);
            this._prevImageBtn.signals.click.add(this._onPrevImageButton_Click, this);
            this.addChild(this._prevImageBtn);

            this._updateUI();

            _get(ImageSelectionScene.prototype.__proto__ || Object.getPrototypeOf(ImageSelectionScene.prototype), "createSharedControls", this).call(this);
            this._uiTopBarSharedControls.muteBtn.visible = true;
            this._uiTopBarSharedControls.backBtn.visible = true;
            this._uiTopBarSharedControls.signals.onBackBtn_Click.addOnce(function () {
                this.signals.previous.dispatch(this);
            }, this);
        }
    }, {
        key: "update",
        value: function update() {
            this._uiCarousel.update();
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            // this._titleSprite.y -= 100;
            // TweenMax.to(this._titleSprite, 1.5, {y: this._titleSprite.y + 100, ease: Elastic.easeOut});

            this._uiCarousel.animateIn();

            this._playBtn.alpha = 0;
            this._playBtn.scale = new PIXI.Point();
            TweenMax.to(this._playBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.2 });
            TweenMax.to(this._playBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2 });
        }
    }, {
        key: "_updateUI",
        value: function _updateUI() {
            // Prev.
            this._prevImageBtn.interactive = this._uiCarousel.selectedIndex > 0;
            TweenMax.to(this._prevImageBtn, 0.25, { alpha: this._prevImageBtn.interactive ? 1 : 0, ease: Sine.easeOut });

            // Next.
            this._nextImageBtn.interactive = this._uiCarousel.selectedIndex < this._imageLength - 1;
            TweenMax.to(this._nextImageBtn, 0.25, { alpha: this._nextImageBtn.interactive ? 1 : 0, ease: Sine.easeOut });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(ImageSelectionScene.prototype.__proto__ || Object.getPrototypeOf(ImageSelectionScene.prototype), "destroy", this).call(this, { children: true });
            TweenMax.killAll();
        }

        //----EVENTS----//

    }, {
        key: "_onCarouselIndex_Changed",
        value: function _onCarouselIndex_Changed() {
            this._updateUI();
        }
    }, {
        key: "_onPlayButton_Click",
        value: function _onPlayButton_Click() {

            _CommonGame2.default.selectedImageId = this.ARR_IMAGE_SPRITE_ID[this._uiCarousel.selectedIndex];

            if (_CommonGame2.default.selectedGallery === _CommonGame2.default.GALLERY_ID_DRAW_IT) {
                _CommonGame2.default.drawItTextId = this.ARR_DRAW_IT_TEXT_ID[this._uiCarousel.selectedIndex];
            }

            // Sfx.
            //   Common.audio.playSound("vo_happo_ready_00");

            this.signals.next.dispatch(this);
        }
    }, {
        key: "_onPrevImageButton_Click",
        value: function _onPrevImageButton_Click() {
            this._uiCarousel.prev();
        }
    }, {
        key: "_onNextImageButton_Click",
        value: function _onNextImageButton_Click() {
            this._uiCarousel.next();
        }
    }]);

    return ImageSelectionScene;
}(_SimpleScene3.default);

exports.default = ImageSelectionScene;

},{"../Common":3,"../CommonGame":4,"../ui/UICarousel":34,"./SimpleScene":32}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _SimpleScene2 = require("./SimpleScene");

var _SimpleScene3 = _interopRequireDefault(_SimpleScene2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainScene = function (_SimpleScene) {
    _inherits(MainScene, _SimpleScene);

    function MainScene() {
        _classCallCheck(this, MainScene);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (MainScene.__proto__ || Object.getPrototypeOf(MainScene)).call(this));

        _this._playBtn = null;
        _this._titleSprite = null;
        return _this;
    }

    _createClass(MainScene, [{
        key: "init",
        value: function init() {

            this._bgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("splash_bg")); //must go first for some reason
            _get(MainScene.prototype.__proto__ || Object.getPrototypeOf(MainScene.prototype), "init", this).call(this);

            // Title sprite.
            this._titleSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("game_title"));
            this._titleSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._titleSprite.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5 - 45);
            //this._titleSprite.scale.set(0.9);
            this.addChild(this._titleSprite);

            // Play button.
            /*
             const btnStatesAux = new P3.ButtonStates(
             Common.assets.getTexture("btn_primary_large_off"),
             Common.assets.getTexture("btn_primary_large_over"),
             Common.assets.getTexture("btn_primary_large_down"),
             Common.assets.getTexture("icon_play_large_off")
             );*/

            this._playBtn = createButton("play_large", "primary_large");
            this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._playBtn.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5 + 325, _Common2.default.STAGE_HEIGHT - 110);
            this._playBtn.overSoundName = "sfx_ui_rollover_00";
            this._playBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
            this._playBtn.signals.click.addOnce(this._onPlayButton_Click, this);
            this.addChild(this._playBtn);

            _get(MainScene.prototype.__proto__ || Object.getPrototypeOf(MainScene.prototype), "createSharedControls", this).call(this, this);
            this._uiTopBarSharedControls.muteBtn.visible = true;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(MainScene.prototype.__proto__ || Object.getPrototypeOf(MainScene.prototype), "destroy", this).call(this, { children: true });
            TweenMax.killAll();
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            this._playBtn.alpha = 0;
            this._playBtn.scale = new PIXI.Point();
            TweenMax.to(this._playBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.2 });
            TweenMax.to(this._playBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2 });

            // Music.
            _Common2.default.audio.playMusic("music_mainmenu_loop_00");
        }

        //----EVENTS----//

    }, {
        key: "_onPlayButton_Click",
        value: function _onPlayButton_Click() {
            this.signals.next.dispatch(this);
        }
    }]);

    return MainScene;
}(_SimpleScene3.default);

exports.default = MainScene;

},{"../Common":3,"../CommonGame":4,"./SimpleScene":32}],31:[function(require,module,exports){
/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

"use strict";

//var Common = require("../Common");

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Application = require("../Application");

var _Application2 = _interopRequireDefault(_Application);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constructor
 * @extends {P3.Scene}
 */
function PreloaderScene() {

    /**
     * @type {number}
     * @private
     */
    this.loaded = 0;

    /**
     * @type {boolean}
     * @private
     */
    this._isPlayingAnim = false;

    /**
     * @type {PIXI.MovieClip}
     * @private
     */
    this._logoAnimation = null;

    /**
     * @type {PIXI.Sprite}
     * @private
     */
    this._bar = null;

    /**
     * @type {PIXI.Sprite}
     * @private
     */
    this._barOverlay = null;

    /**
     * @type {PIXI.Text}
     * @private
     */
    this._text = null;

    /**
     * @type {P3.Button}
     * @private
     */
    this._playButton = null;

    P3.Scene.call(this);

    this.signals.onAllLoaded = new signals.Signal();
}
exports.default = PreloaderScene;
//module.exports = PreloaderScene;

PreloaderScene.prototype = Object.create(P3.Scene.prototype);
PreloaderScene.prototype.constructor = PreloaderScene;

PreloaderScene.prototype.init = function () {

    console.log(_Common2.default);
    console.log(_Common2.default.assets);

    var g = new PIXI.Graphics();
    g.beginFill(0x872F87);
    g.drawRect(0, 0, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
    g.endFill();
    this.addChild(g);

    var holder = new PIXI.Container();
    holder.x = Math.floor(_Common2.default.STAGE_WIDTH * 0.5);
    holder.y = Math.floor(_Common2.default.STAGE_HEIGHT * 0.5) + 50;
    this.addChild(holder);

    var logoFrames = [_Common2.default.assets.getTexture('loader_animation0001'), _Common2.default.assets.getTexture('loader_animation0002'), _Common2.default.assets.getTexture('loader_animation0003'), _Common2.default.assets.getTexture('loader_animation0004'), _Common2.default.assets.getTexture('loader_animation0005'), _Common2.default.assets.getTexture('loader_animation0006'), _Common2.default.assets.getTexture('loader_animation0007'), _Common2.default.assets.getTexture('loader_animation0008'), _Common2.default.assets.getTexture('loader_animation0009'), _Common2.default.assets.getTexture('loader_animation0010')];

    this._logoAnimation = new PIXI.extras.MovieClip(logoFrames);
    this._logoAnimation.animationSpeed = 0.4;
    this._logoAnimation.gotoAndStop(0);
    this._logoAnimation.stop();
    this._logoAnimation.loop = false;
    this._logoAnimation.anchor.x = 0.5;
    this._logoAnimation.anchor.y = 1.0;
    this._logoAnimation.x += 50;
    this._logoAnimation.y -= 20;
    holder.addChild(this._logoAnimation);

    this._bar = new PIXI.Sprite(_Common2.default.assets.getTexture('preloader_bar'));
    this._bar.anchor.y = 0.5;
    this._bar.x -= this._bar.width * 0.5;
    this._bar.scale.x = 0;
    holder.addChild(this._bar);

    this._barOverlay = new PIXI.Sprite(_Common2.default.assets.getTexture('preloader_overlay'));
    this._barOverlay.anchor.y = 0.5;
    this._barOverlay.x -= this._barOverlay.width * 0.5;
    holder.addChild(this._barOverlay);

    this._text = new PIXI.Text("0%", { font: '28px Arial', 'fill': '#FFFFFF' });
    this._text.anchor.x = 0.5;
    this._text.position.y += 50;
    holder.addChild(this._text);

    // Start animation.
    this._logoAnimation.gotoAndPlay(0);

    var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("btn_primary_large_off"), _Common2.default.assets.getTexture("btn_primary_large_over"), _Common2.default.assets.getTexture("btn_primary_large_down"), _Common2.default.assets.getTexture("icon_play_large_off"));
    this._playButton = new P3.Button(btnStatesAux);
    this._playButton.y += 50;
    //this._playButton.downSoundName = "music_menu_playbtn_start_00";
    this._playButton.visible = false;
    this._playButton.signals.click.add(this._onPlayButtonClick, this);
    holder.addChild(this._playButton);
};

PreloaderScene.prototype.destroy = function () {
    P3.Scene.prototype.destroy.call(this);
};

PreloaderScene.prototype.appear = function () {
    this.animateIn();
};

PreloaderScene.prototype.show = function () {};

PreloaderScene.prototype.animateIn = function (callback, scope) {};

PreloaderScene.prototype.animateOut = function (callback, scope) {};

PreloaderScene.prototype.resize = function () {
    this.x = (P3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
};

PreloaderScene.prototype.update = function () {
    this._bar.scale.x = this.loaded;
    this._text.text = Math.floor(this._bar.scale.x * 100) + '%';

    if (this.loaded == 1) {
        if (P3.Device.isMobile) {
            if (!this._playButton.visible) {
                this._playButton.visible = true;
                this._playButton.alpha = 0;

                TweenMax.to(this._playButton, 0.25, { alpha: 1, ease: Sine.easeOut });
                TweenMax.to(this._bar, 0.25, { alpha: 0, ease: Sine.easeIn });
                TweenMax.to(this._barOverlay, 0.25, { alpha: 0, ease: Sine.easeIn });
                TweenMax.to(this._text, 0.25, { alpha: 0, ease: Sine.easeIn });
            }
        } else this.signals.onAllLoaded.dispatch(this);
    }
};

/**
 * @param {P3.Button} button
 */
PreloaderScene.prototype._onPlayButtonClick = function (button) {
    this._playButton.interactive = false;

    // Try only android fullscreen. The fullscreen API is not supported by iOS Safari.
    if (P3.Device.isAndroid && screenfull.enabled) {
        screenfull.request();
        setTimeout(function () {
            _Common2.default.view.resize();
        }, 1000);
    }

    TweenMax.to(this._playButton, 0.25, {
        alpha: 0,
        ease: Sine.easeIn,
        onComplete: _Application2.default.init,
        onCompleteScope: this
    });
};

},{"../Application":2,"../Common":3}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _UITopBarSharedControls = require("../ui/UITopBarSharedControls");

var _UITopBarSharedControls2 = _interopRequireDefault(_UITopBarSharedControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleScene = function (_P3$Scene) {
    _inherits(SimpleScene, _P3$Scene);

    function SimpleScene() {
        _classCallCheck(this, SimpleScene);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (SimpleScene.__proto__ || Object.getPrototypeOf(SimpleScene)).call(this));

        _this._uiTopBarSharedControls = null;
        _this._bgSprite = null;
        return _this;
    }

    _createClass(SimpleScene, [{
        key: "init",
        value: function init() {
            _get(SimpleScene.prototype.__proto__ || Object.getPrototypeOf(SimpleScene.prototype), "init", this).call(this);
            //  P3.Scene.prototype.init.call(this);

            // Bg sprite.
            if (this._bgSprite != null) {
                this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
                this._bgSprite.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);
                this.addChild(this._bgSprite);
            }
        }
    }, {
        key: "createSharedControls",
        value: function createSharedControls() {
            // UITopBarSharedControls.
            this._uiTopBarSharedControls = new _UITopBarSharedControls2.default();
            this._uiTopBarSharedControls.init();
            this.addChild(this._uiTopBarSharedControls);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (P3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
            this._uiTopBarSharedControls.resize();
        }

        //no need to override if your just going to call super, but I added params and kill tweens so is necessary now

    }, {
        key: "destroy",
        value: function destroy() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            params.children = true;
            _get(SimpleScene.prototype.__proto__ || Object.getPrototypeOf(SimpleScene.prototype), "destroy", this).call(this, params);
            TweenMax.killAll();
        }

        /**
         * @abstract
         * @param callback
         * @param scope
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            throw new Error('You have to implement the abstract method before use : ' + this.constructor.name + '#animateIn');
        }

        /**
         * @abstract
         * @param callback
         * @param scope
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {
            throw new Error('You have to implement the abstract method before use : ' + this.constructor.name + 'animateOut');
        }

        //strange pattern. why override parent function and do nothing..
        //// hide(callback, scope) {
        //  }

    }, {
        key: "bg",
        get: function get() {
            return this._bgSprite;
        }
    }]);

    return SimpleScene;
}(P3.Scene);

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
/*
 function SimpleScene() {
 P3.Scene.call(this);


 // Attributes.
 this._uiTopBarSharedControls = null;
 this._bgSprite = null;
 }
 export default SimpleScene;
 //module.exports = SimpleScene;
 SimpleScene.prototype = Object.create(P3.Scene.prototype);
 SimpleScene.prototype.constructor = SimpleScene;
 */

//===================================================
//
// Public
//
//===================================================
/*
 SimpleScene.prototype.init = function () {
 P3.Scene.prototype.init.call(this);


 // Bg sprite.
 if (this._bgSprite != null) {
 this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
 this._bgSprite.position = new PIXI.Point(
 Common.STAGE_WIDTH * 0.5,
 Common.STAGE_HEIGHT * 0.5);
 this.addChild(this._bgSprite);
 }
 };
 */

/*
 SimpleScene.prototype.createSharedControls = function () {
 // UITopBarSharedControls.
 this._uiTopBarSharedControls = new UITopBarSharedControls();
 this._uiTopBarSharedControls.init();
 this.addChild(this._uiTopBarSharedControls);
 };
 */

/*
 SimpleScene.prototype.resize = function () {
 this.x = ( P3.View.width - Common.STAGE_WIDTH ) * 0.5;
 this._uiTopBarSharedControls.resize();
 };
 */
/*
 SimpleScene.prototype.destroy = function () {
 P3.Scene.prototype.destroy.call(this);
 };
 */
/*
 // Override.
 SimpleScene.prototype.animateIn = function (callback, scope) {
 };

 // Override.
 SimpleScene.prototype.animateOut = function (callback, scope) {
 };

 // Override.
 SimpleScene.prototype.hide = function (callback, scope) {
 };
 */

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

exports.default = SimpleScene;
Object.defineProperty(SimpleScene.prototype, "bg", {
    get: function get() {
        return this._bgSprite;
    }
});

},{"../Common":3,"../CommonGame":4,"../ui/UITopBarSharedControls":35}],33:[function(require,module,exports){
"use strict";

/**
 * OutlineFilter, originally by mishaa
 * http://www.html5gamedevs.com/topic/10640-outline-a-sprite-change-certain-colors/?p=69966
 * http://codepen.io/mishaa/pen/emGNRB
 *
 * @class
 * @param thickness {number} The tickness of the outline. Make it 2 times more for resolution 2
 * @param color {number} The color of the glow.
 *
 * @example
 *  someSprite.shader = new OutlineFilter(9, 0xFF0000);
 */
function OutlineFilter(thickness, color) {
    thickness = thickness || 1;
    PIXI.Filter.call(this,
    // vertex shader
    "attribute vec2 aVertexPosition;" + "attribute vec2 aTextureCoord;" + "uniform mat3 projectionMatrix;" + "varying vec2 vTextureCoord;" + "void main(void){" + "gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);" + "vTextureCoord = aTextureCoord;" + "}",
    // fragment shader
    ("varying vec2 vTextureCoord;" + "uniform sampler2D uSampler;" + "uniform float thickness;" + "uniform vec4 outlineColor;" + "uniform vec4 filterArea;" + "uniform vec4 filterClamp;" + "vec2 px = vec2(1.0 / filterArea.x, 1.0 / filterArea.y);" + "void main(void) {" + "const float PI = 3.14159265358979323846264;" + "vec4 ownColor = texture2D(uSampler, vTextureCoord);" + "vec4 curColor;" + "float maxAlpha = 0.;" + "vec2 displaced;" + "for (float angle = 0.; angle < PI * 2.; angle += %THICKNESS% ) {" + "displaced.x = vTextureCoord.x + thickness * px.x * cos(angle);" + "displaced.y = vTextureCoord.y + thickness * px.y * sin(angle);" + "curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));" + "maxAlpha = max(maxAlpha, curColor.a);" + "}" + "float resultAlpha = max(maxAlpha, ownColor.a);" + "gl_FragColor = vec4((ownColor.rgb + outlineColor.rgb * (1. - ownColor.a)) * resultAlpha, resultAlpha); " + "}").replace(/%THICKNESS%/gi, (1.0 / thickness).toFixed(7)));

    this.uniforms.thickness = thickness;
    this.uniforms.outlineColor = new Float32Array([0, 0, 0, 1]);
    if (color) {
        this.color = color;
    }
}

OutlineFilter.prototype = Object.create(PIXI.Filter.prototype);
OutlineFilter.prototype.constructor = OutlineFilter;
module.exports = OutlineFilter;

Object.defineProperties(OutlineFilter.prototype, {
    color: {
        get: function get() {
            return PIXI.utils.rgb2hex(this.uniforms.outlineColor);
        },
        set: function set(value) {
            PIXI.utils.hex2rgb(value, this.uniforms.outlineColor);
        }
    }
});

},{}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function UICarousel() {
    PIXI.Container.call(this);

    // Constants.
    this.PAGE_WIDTH = 800;
    this.DEFAULT_ITEM_SCALE = 0; // To be later initialized.
    this.UNSELECTED_ITEM_SCALE_DELTA = 0.1; // If an item is not currently selected, scale it down by this amount.
    this.SELECTED_ITEM_EXIT_EASE_FACTOR = 0.2; // Decrease the distance of the swipe gesture for the selected item.


    // Attributes.
    this._pageContainer = null;
    this._interactiveArea = null;
    this._mask = null;
    this._startX = 0;
    this._lastX = 0;
    this._currentX = 0;
    this._itemIndex = 0;

    // Signals.
    this.signals = {};
    this.signals.onIndexChanged = new signals.Signal();
    this.signals.onItemSelected = new signals.Signal();
}
exports.default = UICarousel;
//module.exports                  	= UICarousel;

UICarousel.prototype = Object.create(PIXI.Container.prototype);
UICarousel.prototype.constructor = UICarousel;

//===================================================
//
// Public
//
//===================================================

UICarousel.prototype.init = function (items) {
    this.position = new PIXI.Point(_Common2.default.STAGE_WIDTH * 0.5, _Common2.default.STAGE_HEIGHT * 0.5);

    // Mask.
    this._mask = new PIXI.Graphics();
    this._mask.beginFill(0xFFFFFF, 0);
    this._mask.drawRect(-_Common2.default.STAGE_WIDTH * 0.5, -_Common2.default.STAGE_HEIGHT * 0.5, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
    this._mask.endFill();
    this.addChild(this._mask);

    // Interactive area.
    this._interactiveArea = new PIXI.Sprite(_Common2.default.blankTexture);
    this._interactiveArea.tint = 0xFFFFFF;
    this._interactiveArea.alpha = 0;
    this._interactiveArea.height = 400;
    this._interactiveArea.width = _Common2.default.STAGE_WIDTH;
    this._interactiveArea.anchor = new PIXI.Point(0.5, 0.5);
    this._interactiveArea.buttonMode = true;
    this._interactiveArea.interactive = true;
    this._interactiveArea.mousedown = this._interactiveArea.touchstart = this._onMouseDown.bind(this);
    this._interactiveArea.mouseup = this._interactiveArea.touchend = this._onMouseUp.bind(this);
    this._interactiveArea.mouseupoutside = this._interactiveArea.touchendoutside = this._onMouseUp.bind(this);

    this.addChild(this._interactiveArea);

    // Item container.
    this._pageContainer = new PIXI.Container();
    this._pageContainer.anchor = new PIXI.Point(0.5, 0.5);
    this._pageContainer.mask = this._mask;
    this._pageContainer.x = -this.PAGE_WIDTH * 0.5;
    this.addChild(this._pageContainer);

    // Items.
    var i = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (this.DEFAULT_ITEM_SCALE == 0) this.DEFAULT_ITEM_SCALE = item.scale.x;

            // Page.
            var page = new PIXI.Container();
            page.anchor = new PIXI.Point(0, 0.5);
            this._pageContainer.addChild(page);
            // So we can keep some distance between items.
            var pageBg = new PIXI.Sprite(_Common2.default.blankTexture);
            pageBg.alpha = 0;
            pageBg.anchor = new PIXI.Point(0, 0.5);
            pageBg.width = this.PAGE_WIDTH;
            pageBg.height = item.height;
            page.addChild(pageBg);
            // Item.
            item.x = item.width * 0.5 + (pageBg.width - item.width) * 0.5;
            page.addChild(item);
            // Initial scale.
            if (i > 0) item.scale = new PIXI.Point(this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA, this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA);

            page.x = i * page.width;

            ++i;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

UICarousel.prototype.update = function () {
    this._updateItemHiglighting();
};

UICarousel.prototype.animateIn = function () {
    this._pageContainer.children[0].y -= 100;
    this._pageContainer.children[0].alpha = 0;
    TweenMax.to(this._pageContainer.children[0], 0.25, {
        alpha: 1,
        y: this._pageContainer.children[0].y + 100,
        ease: Sine.easeOut
    });
};

UICarousel.prototype.next = function () {
    if (this._itemIndex < this._pageContainer.children.length - 1) {
        this._itemIndex += 1;

        TweenMax.to(this._pageContainer, 0.25, {
            x: -this._itemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
            ease: Sine.easeInOut,
            onComplete: function onComplete() {
                this.signals.onIndexChanged.dispatch();
            },
            onCompleteScope: this
        });

        // Sfx.
        _Common2.default.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};

UICarousel.prototype.prev = function () {
    if (this._itemIndex > 0) {
        this._itemIndex -= 1;

        TweenMax.to(this._pageContainer, 0.25, {
            x: -this._itemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
            ease: Sine.easeInOut,
            onComplete: function onComplete() {
                this.signals.onIndexChanged.dispatch();
            },
            onCompleteScope: this
        });

        // Sfx.
        _Common2.default.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};

//===================================================
//
// Private
//
//===================================================

UICarousel.prototype._updateItemHiglighting = function () {
    // Highlight selection.
    var pageFactor = Math.abs(this._pageContainer.x) / this.PAGE_WIDTH;
    var itemIndexAux = Math.floor(pageFactor);
    // Ease changing the selection of the current item.
    if (this._itemIndex == itemIndexAux) {
        if (Math.abs(this._itemIndex - pageFactor) <= 0.5 - this.SELECTED_ITEM_EXIT_EASE_FACTOR && this._itemIndex > 0) itemIndexAux -= 1;else if (Math.abs(this._itemIndex - pageFactor) >= 0.5 + this.SELECTED_ITEM_EXIT_EASE_FACTOR && this._itemIndex < this._pageContainer.children.length - 1) itemIndexAux += 1;
    }

    var itemIndex = 0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = this._pageContainer.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var page = _step2.value;

            var item = page.children[1];
            if (!TweenMax.isTweening(item.scale)) {
                if (itemIndex == itemIndexAux && item.scale.x != this.DEFAULT_ITEM_SCALE) TweenMax.to(item.scale, 0.12, {
                    x: this.DEFAULT_ITEM_SCALE,
                    y: this.DEFAULT_ITEM_SCALE,
                    ease: Sine.easeInOut
                });else if (itemIndex != itemIndexAux && item.scale.x != this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA) TweenMax.to(item.scale, 0.12, {
                    x: this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA,
                    y: this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA,
                    ease: Sine.easeInOut
                });
            }

            ++itemIndex;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

UICarousel.prototype._snap = function () {
    var pageFactor = Math.abs(this._pageContainer.x) / this.PAGE_WIDTH;
    var newItemIndex = Math.floor(pageFactor);
    // Ease changing the selection of the current item.
    if (newItemIndex == this._itemIndex) {
        if (Math.abs(newItemIndex - pageFactor) <= 0.5 - this.SELECTED_ITEM_EXIT_EASE_FACTOR && newItemIndex > 0) newItemIndex -= 1;else if (Math.abs(newItemIndex - pageFactor) >= 0.5 + this.SELECTED_ITEM_EXIT_EASE_FACTOR && newItemIndex < this._pageContainer.children.length - 1) newItemIndex += 1;
    }

    TweenMax.to(this._pageContainer, 0.25, {
        x: -newItemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
        ease: Sine.easeInOut,
        onComplete: function onComplete(newItemIndex) {
            this._itemIndex = newItemIndex;
            this.signals.onIndexChanged.dispatch();
        },
        onCompleteScope: this,
        onCompleteParams: [newItemIndex]
    });
};

//===================================================
//
// Events
//
//===================================================

UICarousel.prototype._onMouseDown = function (mouseData) {
    TweenMax.killTweensOf(this._pageContainer);

    var localPos = mouseData.data.getLocalPosition(this._interactiveArea);
    this._startX = localPos.x;
    this._lastX = this._startX;
    this._currentX = this._startX;

    this._interactiveArea.mousemove = this._interactiveArea.touchmove = this._onMouseMove.bind(this);
};

UICarousel.prototype._onMouseMove = function (mouseData) {
    var localPos = mouseData.data.getLocalPosition(this._interactiveArea);

    this._currentX = localPos.x;

    this._pageContainer.x += (this._currentX - this._lastX) * _Common2.default.STAGE_WIDTH;
    if (this._pageContainer.x > -this.PAGE_WIDTH * 0.5) this._pageContainer.x = -this.PAGE_WIDTH * 0.5;else if (this._pageContainer.x < -(this._pageContainer.children.length - 0.5) * this.PAGE_WIDTH) this._pageContainer.x = -(this._pageContainer.children.length - 0.5) * this.PAGE_WIDTH;

    this._lastX = this._currentX;
};

UICarousel.prototype._onMouseUp = function (mouseData) {
    var result = false;
    if (Math.abs(this._startX - this._currentX) <= 0.01) {
        var selectedItem = this._pageContainer.children[this._itemIndex].children[1];
        var localPos = mouseData.data.getLocalPosition(selectedItem);
        if (Math.abs(localPos.x) <= selectedItem.width * 0.8 && Math.abs(localPos.y) <= selectedItem.height * 0.8) {
            this.signals.onItemSelected.dispatch();

            result = true;
        }
    }

    if (!result) {
        this._interactiveArea.mousemove = this._interactiveArea.touchmove = null;

        this._snap();

        // Sfx.
        _Common2.default.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(UICarousel.prototype, "selectedIndex", {
    get: function get() {
        return this._itemIndex;
    }
});

},{"../Common":3,"../CommonGame":4}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
var UITopBarSharedControls = function (_PIXI$Container) {
    _inherits(UITopBarSharedControls, _PIXI$Container);

    function UITopBarSharedControls() {
        _classCallCheck(this, UITopBarSharedControls);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (UITopBarSharedControls.__proto__ || Object.getPrototypeOf(UITopBarSharedControls)).call(this));

        _this._homeBtn = null;
        _this._muteBtn = null;
        _this._backBtn = null;

        // Signals.
        _this.signals = {};
        _this.signals.onBackBtn_Click = new signals.Signal();
        return _this;
    }

    _createClass(UITopBarSharedControls, [{
        key: "init",
        value: function init() {

            this._homeBtn = createButton("home");
            this._homeBtn.anchor = new PIXI.Point(0, 0.5);
            this._homeBtn.position.y = this._homeBtn.height * 0.5 + 30;
            this._homeBtn.visible = false;
            this._homeBtn._icon.scale.x = -1;
            this._homeBtn.overSoundName = "sfx_ui_rollover_00";
            this._homeBtn.downSoundName = "sfx_ui_click_00";
            this._homeBtn.signals.click.add(this._onHomeButton_Click, this);
            this.addChild(this._homeBtn);

            // Mute button.
            this._muteBtn = createButton("sound");
            this._muteBtn.anchor = new PIXI.Point(1, 0.5);
            this._muteBtn.position.y = this._homeBtn.position.y;
            this._muteBtn.visible = false;
            this._muteBtn.overSoundName = "sfx_ui_rollover_00";
            this._muteBtn.downSoundName = "sfx_ui_click_00";
            this._muteBtn.signals.click.add(this._onMuteButton_Click, this);
            this.addChild(this._muteBtn);

            // Back button.
            this._backBtn = createButton("back");
            this._backBtn.anchor = new PIXI.Point(0, 0.5);
            this._backBtn.position.y = this._homeBtn.position.y;
            this._backBtn.overSoundName = "sfx_ui_rollover_00";
            this._backBtn.downSoundName = "sfx_ui_click_00";
            this._backBtn.signals.click.add(this._onBackButton_Click, this);
            this._backBtn.visible = false;
            this.addChild(this._backBtn);
        }
    }, {
        key: "resize",
        value: function resize() {
            this._homeBtn.position.x = _Common2.default.getScreenPositionLeft() + 70;
            this._muteBtn.position.x = _Common2.default.getScreenPositionRight() - 70;
            this._backBtn.position.x = _Common2.default.getScreenPositionLeft() + 70;
        }
    }, {
        key: "_onHomeButton_Click",
        value: function _onHomeButton_Click() {
            //todo swap for signals
            _Common2.default.main.application.loadScene(_CommonGame2.default.SCENE_ID_MAIN);
        }
    }, {
        key: "_onMuteButton_Click",
        value: function _onMuteButton_Click() {
            _Common2.default.isMute = !_Common2.default.isMute;

            // TODO:
            this._muteBtn._icon.texture = _Common2.default.assets.getTexture(_Common2.default.isMute ? "icon_mute_off" : "icon_sound_off");
            this._muteBtn._currentIconTexture = this._muteBtn._icon.texture;

            _Common2.default.audio.mute(_Common2.default.isMute);

            // Sfx.
            //Common.audio.playSound( "sfx_small_blip" );
        }
    }, {
        key: "_onBackButton_Click",
        value: function _onBackButton_Click() {
            this.signals.onBackBtn_Click.dispatch();
        }
    }, {
        key: "homeBtn",
        get: function get() {
            return this._homeBtn;
        }
    }, {
        key: "muteBtn",
        get: function get() {
            return this._muteBtn;
        }
    }, {
        key: "backBtn",
        get: function get() {
            return this._backBtn;
        }
    }]);

    return UITopBarSharedControls;
}(PIXI.Container);

exports.default = UITopBarSharedControls;

},{"../Common":3,"../CommonGame":4}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmationPanel = function (_PIXI$Container) {
  _inherits(ConfirmationPanel, _PIXI$Container);

  function ConfirmationPanel() {
    _classCallCheck(this, ConfirmationPanel);

    // Attributes.
    var _this = _possibleConstructorReturn(this, (ConfirmationPanel.__proto__ || Object.getPrototypeOf(ConfirmationPanel)).call(this));

    _this._bgSprite = null;
    _this._messageSprite = null;
    _this._messageText = null;
    _this._yesBtn = null;
    _this._noBtn = null;
    _this._selectedBtn = null;

    // Signals.
    _this.signals = {};
    _this.signals.onYes = new signals.Signal();
    _this.signals.onNo = new signals.Signal();
    return _this;
  }

  _createClass(ConfirmationPanel, [{
    key: "init",
    value: function init() {
      // Background sprite.
      this._bgSprite = new PIXI.Sprite(_Common2.default.blankTexture);
      this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
      this._bgSprite.tint = 0x000000;
      this._bgSprite.alpha = 0.3;
      this._bgSprite.interactive = true;
      this._bgSprite.width = _Common2.default.STAGE_WIDTH;
      this._bgSprite.height = _Common2.default.STAGE_HEIGHT;
      this.addChild(this._bgSprite);

      // Message sprite.
      this._messageSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("colour_palette_big_bg"));
      this._messageSprite.anchor = new PIXI.Point(0.5, 0.5);
      this.addChild(this._messageSprite);

      // Message text.
      this._messageText = P3.createText("COLOUR_IT", {
        size: "64px",
        fill: [0xfff8b3, 0xfac109],
        stroke: 0x006130,
        stokeThickness: 5,
        wordWrap: true,
        wordWrapWidth: this._messageSprite.width - 200
      }, "truetype");

      this._messageText.anchor = new PIXI.Point(0.5, 0.5);
      this._messageText.y = -80;
      this._messageSprite.addChild(this._messageText);

      // Yes button.
      this._yesBtn = createButton("tick", "primary_large");
      this._yesBtn.anchor = new PIXI.Point(0.5, 0.5);
      this._yesBtn.position = new PIXI.Point(100, this._messageSprite.height * 0.5 - 110);
      this._yesBtn.overSoundName = "sfx_ui_rollover_00";
      this._yesBtn.downSoundName = "sfx_ui_click_00";
      this._messageSprite.addChild(this._yesBtn);

      // No button.
      this._noBtn = createButton("cross", "primary_large");
      this._noBtn.anchor = new PIXI.Point(0.5, 0.5);
      this._noBtn.position = new PIXI.Point(-100, this._messageSprite.height * 0.5 - 110);
      this._noBtn.overSoundName = "sfx_ui_rollover_00";
      this._noBtn.downSoundName = "sfx_ui_click_00";
      this._messageSprite.addChild(this._noBtn);

      this.visible = false;
    }
  }, {
    key: "show",
    value: function show(message) {
      this.visible = true;
      this._messageText.text = message;

      this._messageSprite.alpha = 0;
      this._messageSprite.y = -100;
      TweenMax.to(this._messageSprite, 0.25, { y: this._messageSprite.y + 100, alpha: 1, ease: Sine.easeOut });

      this._bgSprite.alpha = 0;
      TweenMax.to(this._bgSprite, 0.25, { alpha: 0.3, ease: Sine.easeOut });

      this._noBtn.alpha = 0;
      this._noBtn.scale = new PIXI.Point();
      TweenMax.to(this._noBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.15 });
      TweenMax.to(this._noBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.15 });

      this._yesBtn.alpha = 0;
      this._yesBtn.scale = new PIXI.Point();
      TweenMax.to(this._yesBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.3 });
      TweenMax.to(this._yesBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.3 });

      // Signals.
      this._yesBtn.signals.click.addOnce(function () {
        this._selectedBtn = this._yesBtn;
        this._hide();
      }, this);
      this._noBtn.signals.click.addOnce(function () {
        this._selectedBtn = this._noBtn;
        this._hide();
      }, this);
    }
  }, {
    key: "_hide",
    value: function _hide() {
      TweenMax.to(this._messageSprite, 0.25, { y: this._messageSprite.y + 100, alpha: 0, ease: Sine.easeIn });
      TweenMax.to(this._bgSprite, 0.25, {
        alpha: 0,
        ease: Sine.easeIn,
        onComplete: this._onHidden,
        onCompleteScope: this
      });

      // Signals.
      this._yesBtn.signals.click.removeAll();
      this._noBtn.signals.click.removeAll();
    }

    //----EVENTS----//

  }, {
    key: "_onHidden",
    value: function _onHidden() {
      if (this._selectedBtn === this._yesBtn) {
        // Sfx.
        //Common.audio.playSound("vo_happo_ok_00");

        this.signals.onYes.dispatch();
      } else if (this._selectedBtn === this._noBtn) {
        this.signals.onNo.dispatch();
      }

      this._selectedBtn = null;

      this.visible = false;

      // Signals.
      this.signals.onYes.removeAll();
      this.signals.onNo.removeAll();
    }
  }]);

  return ConfirmationPanel;
}(PIXI.Container);

//===================================================
//
// Constructor
//
//===================================================
/*
 function ConfirmationPanel() {
 PIXI.Container.call(this);


 // Attributes.
 this._bgSprite = null;
 this._messageSprite = null;
 this._messageText = null;
 this._yesBtn = null;
 this._noBtn = null;
 this._selectedBtn = null;


 // Signals.
 this.signals = {};
 this.signals.onYes = new signals.Signal();
 this.signals.onNo = new signals.Signal();
 }

 export default ConfirmationPanel;
 //module.exports = ConfirmationPanel;
 ConfirmationPanel.prototype = Object.create(PIXI.Container.prototype);
 ConfirmationPanel.prototype.constructor = ConfirmationPanel;
 */

//===================================================
//
// Public
//
//===================================================
/*
 ConfirmationPanel.prototype.init = function () {
 // Background sprite.
 this._bgSprite = new PIXI.Sprite(Common.blankTexture);
 this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
 this._bgSprite.tint = 0x000000;
 this._bgSprite.alpha = 0.3;
 this._bgSprite.interactive = true;
 this._bgSprite.width = Common.STAGE_WIDTH;
 this._bgSprite.height = Common.STAGE_HEIGHT;
 this.addChild(this._bgSprite);

 // Message sprite.
 this._messageSprite = new PIXI.Sprite(Common.assets.getTexture("colour_palette_big_bg"));
 this._messageSprite.anchor = new PIXI.Point(0.5, 0.5);
 this.addChild(this._messageSprite);

 // Message text.
 this._messageText = P3.createText("COLOUR_IT", {
 size: "64px",
 fill: [0xfff8b3, 0xfac109],
 stroke: 0x4c2607,
 stokeThickness: 5,
 wordWrap: true,
 wordWrapWidth: this._messageSprite.width - 200
 }, "truetype");

 this._messageText.anchor = new PIXI.Point(0.5, 0.5);
 this._messageText.y = -80;
 this._messageSprite.addChild(this._messageText);

 // Yes button.
 var btnStatesAux = new P3.ButtonStates(
 Common.assets.getTexture("btn_primary_large_off"),
 Common.assets.getTexture("btn_primary_large_over"),
 Common.assets.getTexture("btn_primary_large_down"),
 Common.assets.getTexture("icon_tick")
 );
 btnStatesAux.iconOver = Common.assets.getTexture("icon_tick");
 btnStatesAux.iconDown = Common.assets.getTexture("icon_tick");
 this._yesBtn = new P3.Button(btnStatesAux);
 this._yesBtn.anchor = new PIXI.Point(0.5, 0.5);
 this._yesBtn.position = new PIXI.Point(100, this._messageSprite.height * 0.5 - 110);
 this._yesBtn.overSoundName = "sfx_ui_rollover_00";
 this._yesBtn.downSoundName = "sfx_ui_click_00";
 this._messageSprite.addChild(this._yesBtn);

 // No button.
 btnStatesAux = new P3.ButtonStates(
 Common.assets.getTexture("btn_primary_large_off"),
 Common.assets.getTexture("btn_primary_large_over"),
 Common.assets.getTexture("btn_primary_large_down"),
 Common.assets.getTexture("icon_cross")
 );
 btnStatesAux.iconOver = Common.assets.getTexture("icon_cross");
 btnStatesAux.iconDown = Common.assets.getTexture("icon_cross");
 this._noBtn = new P3.Button(btnStatesAux);
 this._noBtn.anchor = new PIXI.Point(0.5, 0.5);
 this._noBtn.position = new PIXI.Point(-100, this._messageSprite.height * 0.5 - 110);
 this._noBtn.overSoundName = "sfx_ui_rollover_00";
 this._noBtn.downSoundName = "sfx_ui_click_00";
 this._messageSprite.addChild(this._noBtn);

 this.visible = false;
 };
 */

/*
 ConfirmationPanel.prototype.show = function (message) {
 this.visible = true;
 this._messageText.text = message;

 this._messageSprite.alpha = 0;
 this._messageSprite.y = -100;
 TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 1, ease: Sine.easeOut});

 this._bgSprite.alpha = 0;
 TweenMax.to(this._bgSprite, 0.25, {alpha: 0.3, ease: Sine.easeOut});

 this._noBtn.alpha = 0;
 this._noBtn.scale = new PIXI.Point();
 TweenMax.to(this._noBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.15});
 TweenMax.to(this._noBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.15});

 this._yesBtn.alpha = 0;
 this._yesBtn.scale = new PIXI.Point();
 TweenMax.to(this._yesBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.3});
 TweenMax.to(this._yesBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.3});


 // Signals.
 this._yesBtn.signals.click.addOnce(function () {
 this._selectedBtn = this._yesBtn;
 this._hide();
 }, this);
 this._noBtn.signals.click.addOnce(function () {
 this._selectedBtn = this._noBtn;
 this._hide();
 }, this);
 };
 */

//===================================================
//
// Private
//
//===================================================
/*
 ConfirmationPanel.prototype._hide = function () {
 TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 0, ease: Sine.easeIn});
 TweenMax.to(this._bgSprite, 0.25, {alpha: 0, ease: Sine.easeIn, onComplete: this._onHidden, onCompleteScope: this});


 // Signals.
 this._yesBtn.signals.click.removeAll();
 this._noBtn.signals.click.removeAll();
 };
 */

//===================================================
//
// Events
//
//===================================================
/*
 ConfirmationPanel.prototype._onHidden = function () {
 if (this._selectedBtn == this._yesBtn) {
 this.signals.onYes.dispatch();

 // Sfx.
 Common.audio.playSound("vo_happo_ok_00");
 }
 else if (this._selectedBtn == this._noBtn)
 this.signals.onNo.dispatch();

 this._selectedBtn = null;

 this.visible = false;

 // Signals.
 this.signals.onYes.removeAll();
 this.signals.onNo.removeAll();
 };
 */
//===================================================
//
// Getters / Setters
//
//===================================================

// TODO:


exports.default = ConfirmationPanel;

},{"../../Common":3,"../../CommonGame":4}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _ConfirmationPanel = require("./ConfirmationPanel");

var _ConfirmationPanel2 = _interopRequireDefault(_ConfirmationPanel);

var _TrashConfirmationPanel = require("./TrashConfirmationPanel");

var _TrashConfirmationPanel2 = _interopRequireDefault(_TrashConfirmationPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPanel = function (_PIXI$Container) {
    _inherits(MenuPanel, _PIXI$Container);

    function MenuPanel(signals) {
        _classCallCheck(this, MenuPanel);

        var _this = _possibleConstructorReturn(this, (MenuPanel.__proto__ || Object.getPrototypeOf(MenuPanel)).call(this));

        _this._gameSceneSignals = signals;

        // Attributes.
        _this._quitBtn = null;
        _this._backBtn = null;
        _this._printBtn = null;
        _this._downloadBtn = null;
        _this._muteBtn = null;
        _this._binBtn = null;
        _this._boxBorderSprite = null;
        _this._popupContainer = null;
        _this._drawingActionContainer = null;
        _this._titleSprite = null;
        _this._bgGradientSprite = null;
        _this._titleText = null;
        _this._confirmationPanel = null;
        _this._trashConfirmationPanel = null;
        return _this;
    }

    _createClass(MenuPanel, [{
        key: "init",
        value: function init() {
            // Bg gradient sprite.
            this._bgGradientSprite = new PIXI.Sprite(_Common2.default.blankTexture);
            this._bgGradientSprite.tint = 0x000000;
            this._bgGradientSprite.alpha = 0.6;
            this._bgGradientSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._bgGradientSprite.scale.x = _Common2.default.STAGE_WIDTH * 1.25;
            this._bgGradientSprite.scale.y = _Common2.default.STAGE_HEIGHT;
            this._bgGradientSprite.interactive = true;
            this._bgGradientSprite.click = this._bgGradientSprite.touchend = this._onBackButton_Click.bind(this);
            this.addChild(this._bgGradientSprite);

            // Popup.
            this._popupContainer = new PIXI.Container();
            this._popupContainer.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._popupContainer);

            // Bg.
            /*
             //removed due to feedback
             //@deprecated
             var SCALE_FACTOR = 0.985;
             var popupTex = Common.assets.getTexture("popup_box");
               var popupBg = new PIXI.Graphics();
             popupBg.beginFill(CommonGame.GALLERY_BORDER_TINT[CommonGame.selectedGallery], 1);
             popupBg.drawRoundedRect(
             -popupTex.width * 0.5 * SCALE_FACTOR,
             -popupTex.height * 0.5 * SCALE_FACTOR,
             popupTex.width * SCALE_FACTOR,
             popupTex.height * SCALE_FACTOR,
             35
             );
             popupBg.endFill();
             popupBg.interactive = true;
             this._popupContainer.addChild(popupBg);
             */

            // Border.
            this._boxBorderSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("menu_panel"));
            this._boxBorderSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._popupContainer.addChild(this._boxBorderSprite);
            this._popupContainer.scale.set(0.9, 0.9);

            // Title sprite.
            this._titleSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._titleSprite.anchor = new PIXI.Point(0.5, 0.5);

            this._popupContainer.addChild(this._titleSprite);

            // Title text.
            var bkText = P3.createText("MENU", {
                fill: [0xfff8b3, 0xfac109],
                size: "90px",
                wordWrap: true,
                wordWrapWidth: 500,
                stroke: 0x23a838,
                strokeThickness: 14,
                align: "centre"
            });

            this._titleText = P3.createText("MENU", {
                fill: [0xfff8b3, 0xfac109],
                size: "90px",
                wordWrap: true,
                wordWrapWidth: 500,
                stroke: 0x006130,
                align: "centre",
                strokeThickness: 8
            });

            this._titleText.y = bkText.y = -this._boxBorderSprite.height * 0.5 + 145;
            this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
            this._titleSprite.addChild(bkText, this._titleText);

            // Quit button.
            this._quitBtn = createButton("home");
            this._quitBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._quitBtn.position = new PIXI.Point(-234, 248);
            this._quitBtn.overSoundName = "sfx_ui_rollover_00";
            this._quitBtn.downSoundName = "sfx_ui_click_00";
            this._quitBtn.signals.click.add(this._onQuitButton_Click, this);
            this._popupContainer.addChild(this._quitBtn);

            // Sound button.
            this._muteBtn = createButton("sound");
            this._muteBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._muteBtn.position = new PIXI.Point(238, 248);
            this._muteBtn.overSoundName = "sfx_ui_rollover_00";
            this._muteBtn.downSoundName = "sfx_ui_click_00";
            this._muteBtn.signals.click.add(this._onSoundButton_Click, this);
            this._popupContainer.addChild(this._muteBtn);

            // Container for Print, Download and Bin buttons.
            this._drawingActionContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._drawingActionContainer.anchor.set(0.5, 0.5);
            this._drawingActionContainer.y = -15;
            this._popupContainer.addChild(this._drawingActionContainer);

            var btnOffset = 240;
            var btnStatesAux = void 0;

            // Print button.
            if (_Common2.default.assets.getJSON("config").menuPanel.printBtn.isVisible) {
                btnStatesAux = new P3.ButtonStates(PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, _Common2.default.assets.getTexture("icon_print"));
                this._printBtn = new P3.Button(btnStatesAux);
                this._printBtn.anchor = new PIXI.Point(0.5, 0.5);
                this._printBtn.x = -btnOffset;

                this._printBtn.signals.click.add(this._onPrintButton_Click, this);
                this._drawingActionContainer.addChild(this._printBtn);
            }

            // Download button.
            if (_Common2.default.assets.getJSON("config").menuPanel.downloadBtn.isVisible) {
                btnStatesAux = new P3.ButtonStates(PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, _Common2.default.assets.getTexture("icon_save"));
                this._downloadBtn = new P3.Button(btnStatesAux);
                this._downloadBtn.anchor = new PIXI.Point(0.5, 0.5);
                this._downloadBtn.x = 0; //this._drawingActionContainer.children.length * btnOffset;

                this._downloadBtn.signals.click.add(this._onDownloadButton_Click, this);
                this._drawingActionContainer.addChild(this._downloadBtn);
            }

            // Bin button.
            if (_Common2.default.assets.getJSON("config").menuPanel.binBtn.isVisible) {
                btnStatesAux = new P3.ButtonStates(PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, PIXI.Texture.EMPTY, _Common2.default.assets.getTexture("icon_replay"));
                this._binBtn = new P3.Button(btnStatesAux);
                this._binBtn.anchor = new PIXI.Point(0.5, 0.5);
                this._binBtn.x = btnOffset;

                this._binBtn.signals.click.add(this._onBinButton_Click, this);
                this._drawingActionContainer.addChild(this._binBtn);
            }

            // Back button.
            this._backBtn = createButton("play_large", "primary_large");
            this._backBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._backBtn.position = new PIXI.Point(0, this._boxBorderSprite.height * 0.5 - 115);
            this._backBtn.overSoundName = "sfx_ui_rollover_00";
            this._backBtn.downSoundName = "sfx_ui_click_00";
            this._backBtn.signals.click.add(this._onBackButton_Click, this);
            this._popupContainer.addChild(this._backBtn);

            // Confirmation panel.
            this._confirmationPanel = new _ConfirmationPanel2.default();
            this._confirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
            this._confirmationPanel.init();
            this.addChild(this._confirmationPanel);

            // Trash confirmation panel.
            this._trashConfirmationPanel = new _TrashConfirmationPanel2.default();
            this._trashConfirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
            this._trashConfirmationPanel.init();
            this.addChild(this._trashConfirmationPanel);

            this.visible = false;
            this.alpha = 0;
        }
    }, {
        key: "show",
        value: function show() {
            // Animate-in.
            this.visible = true;
            this._popupContainer.y = -50;
            TweenMax.to(this, 0.25, { alpha: 1, ease: Quad.easeOut });
            TweenMax.to(this._popupContainer, 0.25, { y: 0, ease: Quad.easeOut });

            this._backBtn.alpha = 0;
            this._backBtn.scale = new PIXI.Point();
            TweenMax.to(this._backBtn, 0.25, { alpha: 1, ease: Sine.easeOut, delay: 0.2 });
            TweenMax.to(this._backBtn.scale, 0.5, { x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2 });

            _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.MENU_PANEL_SHOWN);
        }

        //----EVENTS----//

    }, {
        key: "_onQuitButton_Click",
        value: function _onQuitButton_Click() {
            var _this2 = this;

            this._confirmationPanel.signals.onYes.addOnce(function () {
                // Music.
                _Common2.default.audio.stopMusic();
                _Common2.default.audio.playMusic("music_mainmenu_loop_00");

                // Common.main.application.loadScene(CommonGame.SCENE_ID_IMAGE_SELECTION);
                _this2._gameSceneSignals.previous.dispatch(_this2);
            }, this);
            this._confirmationPanel.show(_Common2.default.assets.getJSON("languages").LEAVE_CONFIRMATION[_Common2.default.language]);
        }
    }, {
        key: "_onPrintButton_Click",
        value: function _onPrintButton_Click() {
            var _this3 = this;

            // Sfx.
            _Common2.default.audio.playSound("sfx_ui_newpage_00");

            this.visible = false;
            _Common2.default.game.hud.visible = false;

            //--timeout is needed. otherwise window.open returns null (according to SO must be initialised by a native event)--//
            setTimeout(function () {
                var canvas = _Common2.default.renderer.extract.canvas(_Common2.default.game.canvas);
                var myWindow = window.open();
                if (myWindow) {
                    myWindow.document.body.appendChild(canvas);

                    var css = "@page { size: landscape; margin-top: 1.4cm; margin-left: 2.3cm; }";
                    var head = myWindow.document.head || myWindow.document.getElementsByTagName("head")[0];
                    var style = document.createElement("style");

                    style.type = "text/css";
                    style.media = "print";

                    if (style.styleSheet) style.styleSheet.cssText = css;else style.appendChild(document.createTextNode(css));

                    head.appendChild(style);

                    myWindow.print();
                    myWindow.close();
                } else {
                    console.error("unable to open new window");
                    console.log(myWindow);
                }

                _this3.visible = true;
                _Common2.default.game.hud.visible = true;
            }, 2.5);
        }
    }, {
        key: "_onDownloadButton_Click",
        value: function _onDownloadButton_Click() {
            var _this4 = this;

            // Sfx.
            _Common2.default.audio.playSound("sfx_ui_folder_save_00");

            this.visible = false;
            _Common2.default.game.hud.visible = false;

            setTimeout(function () {
                var canvas = _Common2.default.renderer.extract.canvas(_Common2.default.game.canvas);
                var myWindow = window.open();
                if (myWindow != null) myWindow.document.body.appendChild(canvas);

                _this4.visible = true;
                _Common2.default.game.hud.visible = true;
            }, 2.5);
        }
    }, {
        key: "_onSoundButton_Click",
        value: function _onSoundButton_Click() {
            _Common2.default.isMute = !_Common2.default.isMute;

            // TODO:
            this._muteBtn._icon.texture = _Common2.default.assets.getTexture(_Common2.default.isMute ? "icon_mute_off" : "icon_sound_off");
            this._muteBtn._currentIconTexture = this._muteBtn._icon.texture;

            _Common2.default.audio.mute(_Common2.default.isMute);
        }
    }, {
        key: "_onBinButton_Click",
        value: function _onBinButton_Click() {
            this._trashConfirmationPanel.signals.onYes.addOnce(function () {
                // Sfx.
                _Common2.default.audio.playSound("sfx_tool_trashcan_select_00");

                _Common2.default.game.canvas.clear();
                _Common2.default.game.undoManager.clear();

                this.visible = false;
            }, this);
            this._trashConfirmationPanel.show(_Common2.default.assets.getJSON("languages").BIN_CONFIRMATION[_Common2.default.language]);
        }
    }, {
        key: "_onBackButton_Click",
        value: function _onBackButton_Click() {
            // Animate-out.
            TweenMax.to(this, 0.25, { alpha: 0, ease: Quad.easeOut });
            TweenMax.to(this._popupContainer, 0.25, {
                y: 50,
                ease: Quad.easeOut,
                onComplete: function onComplete() {
                    this.visible = false;
                    _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.MENU_PANEL_HIDDEN);
                },
                onCompleteScope: this
            });
        }
    }]);

    return MenuPanel;
}(PIXI.Container);

exports.default = MenuPanel;

},{"../../Common":3,"../../CommonGame":4,"./ConfirmationPanel":36,"./TrashConfirmationPanel":39}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PalettePanel = function (_PIXI$Container) {
    _inherits(PalettePanel, _PIXI$Container);

    function PalettePanel() {
        _classCallCheck(this, PalettePanel);

        // Constants.
        var _this = _possibleConstructorReturn(this, (PalettePanel.__proto__ || Object.getPrototypeOf(PalettePanel)).call(this));

        _this.ITEMS_PER_ROW = 5;
        _this.ITEMS_PER_PAGE = 15;
        _this.PALETTE_TOOLS = _Common2.default.assets.getJSON("config").palettePanel.tools;
        _this.PALETTE_TYPE_TO_TOOL = [_this.PALETTE_TOOLS.pencil, _this.PALETTE_TOOLS.brush, _this.PALETTE_TOOLS.stamp, _this.PALETTE_TOOLS.fill, _this.PALETTE_TOOLS.ink, _this.PALETTE_TOOLS.spray, _this.PALETTE_TOOLS.fill];

        // Attributes.
        _this._bgGradientSprite = null;
        _this._panel = null;
        _this._boxSprite = null;
        _this._type = null;
        _this._nextBtn = null;
        _this._prevBtn = null;
        _this._pageIndex = 0;
        _this._pageCount = 0;
        _this._arrBtnInfo = [];

        // Signals.
        _this.signals = {};
        _this.signals.onColourChanged = new signals.Signal();
        _this.signals.onStampChanged = new signals.Signal();
        return _this;
    }

    _createClass(PalettePanel, [{
        key: "init",
        value: function init() {
            // Bg gradient sprite.
            this._bgGradientSprite = new PIXI.Sprite(_Common2.default.blankTexture);
            this._bgGradientSprite.tint = 0x000000;
            this._bgGradientSprite.alpha = 0.6;
            this._bgGradientSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._bgGradientSprite.scale.x = _Common2.default.STAGE_WIDTH * 1.25;
            this._bgGradientSprite.scale.y = _Common2.default.STAGE_HEIGHT;
            this._bgGradientSprite.interactive = true;
            this._bgGradientSprite.click = this._bgGradientSprite.touchend = this.hide.bind(this);
            this.addChild(this._bgGradientSprite);

            // Panel.
            this._panel = new PIXI.Container();
            this.addChild(this._panel);

            // Box sprite.
            this._boxSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("colour_palette_big_bg"));
            this._boxSprite.interactive = true;
            this._boxSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.addChild(this._boxSprite);

            // Next button.
            var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_next_off"), _Common2.default.assets.getTexture("icon_next_over"), _Common2.default.assets.getTexture("icon_next_down"));
            this._nextBtn = new P3.Button(btnStatesAux);
            this._nextBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._nextBtn.scale = new PIXI.Point(1.5, 1.5);
            this._nextBtn.defaultScale = new PIXI.Point(1.5, 1.5);
            this._nextBtn.position.x = this._boxSprite.width * 0.5 + 50;
            this._nextBtn.alpha = 0;
            this._nextBtn.interactive = false;
            this._nextBtn.signals.click.add(this._onNextButton_Click, this);
            this._panel.addChild(this._nextBtn);

            // Prev button.
            btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture("icon_next_off"), _Common2.default.assets.getTexture("icon_next_over"), _Common2.default.assets.getTexture("icon_next_down"));
            this._prevBtn = new P3.Button(btnStatesAux);
            this._prevBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._prevBtn.scale = new PIXI.Point(-1.5, 1.5);
            this._prevBtn.defaultScale = new PIXI.Point(-1.5, 1.5);
            this._prevBtn.position.x = -this._boxSprite.width * 0.5 - 50;
            this._prevBtn.alpha = 0;
            this._prevBtn.interactive = false;
            this._prevBtn.signals.click.add(this._onPrevButton_Click, this);
            this._panel.addChild(this._prevBtn);

            this.visible = false;
        }
    }, {
        key: "show",
        value: function show(toolType) {
            this._type = toolType;

            this._arrBtnInfo = this._findItems(this._type);

            this._pageIndex = 0;
            this._updateNavControls();

            this._createItems(this._arrBtnInfo);

            // Animate-in.
            this.visible = true;
            this.alpha = 0;
            this._panel.y = -50;
            TweenMax.to(this._panel, 0.25, { y: 0, ease: Quad.easeOut });
            TweenMax.to(this, 0.25, { alpha: 1, ease: Quad.easeOut });

            // Sfx.
            _Common2.default.audio.playSound("sfx_palette_select_00");
        }
    }, {
        key: "changeType",
        value: function changeType(toolType) {
            if (this._type === toolType) return;

            this._type = toolType;

            this._removeItems();
            this._pageIndex = 0;
            this._arrBtnInfo = this._findItems(this._type);

            this._updateNavControls();

            this._createItems(this._arrBtnInfo);
        }
    }, {
        key: "hide",
        value: function hide() {
            // Animate-out.
            TweenMax.to(this._panel, 0.25, { y: 50, ease: Quad.easeOut });
            TweenMax.to(this, 0.25, {
                alpha: 0,
                ease: Quad.easeOut,
                onComplete: function onComplete() {
                    this.visible = false;

                    this._boxSprite.removeChildren();

                    // Tutorial
                    _Common2.default.game.scene.addTutorialEvent(_CommonGame2.default.TUT_EVENT.PALETTE_PANEL_HIDDEN);
                },
                onCompleteScope: this
            });

            // Sfx.
            _Common2.default.audio.playSound("sfx_palette_close_00");
        }
    }, {
        key: "_removeItems",
        value: function _removeItems() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._boxSprite.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var menuButton = _step.value;

                    menuButton.interactive = false;
                    TweenMax.to(menuButton.scale, 0.2, {
                        x: 0,
                        y: 0,
                        ease: Sine.easeIn,
                        delay: Math.random() * 0.2,
                        onComplete: function onComplete(menuBtn) {
                            this._boxSprite.removeChild(menuBtn);
                        },
                        onCompleteScope: this,
                        onCompleteParams: [menuButton]
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "_findItems",
        value: function _findItems(paletteType) {
            var result = [];

            var PALETTE_PAGES = _Common2.default.assets.getJSON("config").palettePanel.pages;
            var arrPageIndex = this.PALETTE_TYPE_TO_TOOL[paletteType];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = arrPageIndex[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var pageIndex = _step2.value;

                    result.push([]);
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = PALETTE_PAGES[pageIndex][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var item = _step3.value;

                            if (item.indexOf("#") == 0)
                                // Colour.
                                result[result.length - 1].push({
                                    out: "btns_colour_white",
                                    over: "btns_colour_white",
                                    down: "btns_colour_white",
                                    tint: parseInt("0x" + item.substring(1)),
                                    isShine: true
                                });else if (item.indexOf(_CommonGame2.default.TEXTURE_SPRITE_BASE_ID) != -1) {
                                // Texture.
                                var spriteId = _CommonGame2.default.TEXTURE_BUTTON_BASE_ID + item.substring(item.length - 2);
                                result[result.length - 1].push({ out: spriteId, over: spriteId, down: spriteId, isShine: true });
                            } else
                                // Stamp.
                                result[result.length - 1].push({ out: item, over: item, down: item, isShine: false });
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return result;
        }
    }, {
        key: "_createItems",
        value: function _createItems(arrBtnInfo) {
            // Create buttons for the selected page.
            var arrCurPageBtnInfo = this._arrBtnInfo[this._pageIndex];
            var btnIndex = 0;
            var colIndex = 0;
            var rowIndex = 0;
            var arcHeight = 7;
            var rowCount = Math.ceil(arrCurPageBtnInfo.length / this.ITEMS_PER_ROW);
            var startingX = -this._boxSprite.width * 0.5 + (this._boxSprite.width - this._findItemCount(rowIndex, arrCurPageBtnInfo.length) * 135 + 125) * 0.5;
            var startingY = -this._boxSprite.height * 0.5 + (this._boxSprite.height - (rowCount - 1) * 130) * 0.5;
            // TODO: Set starting X and Y according to the number of items for the given row and the number of rows.
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = arrCurPageBtnInfo[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var btnInfo = _step4.value;

                    var btnStatesAux = new P3.ButtonStates(_Common2.default.assets.getTexture(btnInfo.out), _Common2.default.assets.getTexture(btnInfo.over), _Common2.default.assets.getTexture(btnInfo.down));
                    var menuButton = new P3.Button(btnStatesAux);
                    menuButton.tint = btnInfo.tint != null ? btnInfo.tint : 0xffffff;
                    menuButton.anchor = new PIXI.Point(0.5, 0.5);
                    menuButton.x = startingX + colIndex * 135;
                    menuButton.y = startingY + rowIndex * 125;
                    if (colIndex % 2 != 0) {
                        menuButton.y += arcHeight;
                        arcHeight *= -1;
                    }
                    menuButton.index = btnIndex;
                    menuButton.signals.click.addOnce(this._onMenuButton_Click, this);
                    this._boxSprite.addChild(menuButton);

                    // Shine overlay.
                    if (btnInfo.isShine) {
                        var shineOverlay = new PIXI.Sprite(_Common2.default.assets.getTexture("btns_colour_overlay"));
                        shineOverlay.anchor = new PIXI.Point(0.5, 0.5);
                        shineOverlay.alpha = 0.4;
                        shineOverlay.blendMode = PIXI.BLEND_MODES.ADD;
                        menuButton.addChild(shineOverlay);
                    }

                    ++btnIndex;

                    ++colIndex;
                    if (colIndex >= this.ITEMS_PER_ROW) {
                        colIndex = 0;
                        ++rowIndex;

                        startingX = -this._boxSprite.width * 0.5 + (this._boxSprite.width - this._findItemCount(rowIndex, arrCurPageBtnInfo.length) * 135 + 125) * 0.5;
                    }

                    // Animate the button.
                    menuButton.scale = new PIXI.Point();
                    TweenMax.to(menuButton.scale, 0.2, { x: 1, y: 1, ease: Sine.easeOut, delay: Math.random() * 0.2 });
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    }, {
        key: "_findItemCount",
        value: function _findItemCount(rowIndex, btnCount) {
            var result = 0;

            var remainingBtnCount = btnCount - rowIndex * this.ITEMS_PER_ROW;
            if (remainingBtnCount / this.ITEMS_PER_ROW >= 1) result = this.ITEMS_PER_ROW;else result = remainingBtnCount % this.ITEMS_PER_ROW;

            return result;
        }
    }, {
        key: "_updateNavControls",
        value: function _updateNavControls() {
            if (this._prevBtn.alpha === 0) {
                if (this._pageIndex > 0) {
                    TweenMax.to(this._prevBtn, 0.25, { alpha: 1, ease: Sine.easeOut });
                    this._prevBtn.interactive = true;
                }
            } else {
                if (this._pageIndex === 0) {
                    TweenMax.to(this._prevBtn, 0.25, { alpha: 0, ease: Sine.easeIn });
                    this._prevBtn.interactive = false;
                }
            }

            if (this._nextBtn.alpha === 0) {
                if (this._pageIndex < this._arrBtnInfo.length - 1) {
                    TweenMax.to(this._nextBtn, 0.25, { alpha: 1, ease: Sine.easeOut });
                    this._nextBtn.interactive = true;
                }
            } else {
                if (this._pageIndex === this._arrBtnInfo.length - 1) {
                    TweenMax.to(this._nextBtn, 0.25, { alpha: 0, ease: Sine.easeIn });
                    this._nextBtn.interactive = false;
                }
            }
        }

        //----EVENTS----//

    }, {
        key: "_onPageIndex_Changed",
        value: function _onPageIndex_Changed() {
            // Navigation controls.
            this._updateNavControls();

            // Menu buttons.
            this._removeItems();
            this._createItems(this._arrBtnInfo);
        }
    }, {
        key: "_onNextButton_Click",
        value: function _onNextButton_Click() {
            if (this._pageIndex < this._arrBtnInfo.length - 1) {
                this._pageIndex += 1;

                this._onPageIndex_Changed();
            }
        }
    }, {
        key: "_onPrevButton_Click",
        value: function _onPrevButton_Click() {
            if (this._pageIndex > 0) {
                this._pageIndex -= 1;

                this._onPageIndex_Changed();
            }
        }
    }, {
        key: "_onMenuButton_Click",
        value: function _onMenuButton_Click(btn) {
            switch (this._type) {
                case _CommonGame2.default.TOOL.PENCIL:
                case _CommonGame2.default.TOOL.BRUSH:
                case _CommonGame2.default.TOOL.BUCKET:
                case _CommonGame2.default.TOOL.INK_POT:
                case _CommonGame2.default.TOOL.SPRAY:
                    {
                        this.signals.onColourChanged.dispatch(_Common2.default.assets.getJSON("config").palettePanel.pages[this.PALETTE_TYPE_TO_TOOL[this._type][this._pageIndex]][btn.index], this.PALETTE_TYPE_TO_TOOL[this._type][this._pageIndex], btn.index);

                        break;
                    }

                case _CommonGame2.default.TOOL.STAMP:
                    {
                        this.signals.onStampChanged.dispatch(_Common2.default.assets.getJSON("config").palettePanel.pages[this.PALETTE_TYPE_TO_TOOL[this._type][this._pageIndex]][btn.index], this.PALETTE_TYPE_TO_TOOL[this._type][this._pageIndex], btn.index);

                        break;
                    }
            }

            this.hide();

            // Sfx.
            _Common2.default.audio.playSound("sfx_generic_colour_type_change_00");
        }
    }]);

    return PalettePanel;
}(PIXI.Container);

exports.default = PalettePanel;

},{"../../Common":3,"../../CommonGame":4}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../../Common");

var _Common2 = _interopRequireDefault(_Common);

var _CommonGame = require("../../CommonGame");

var _CommonGame2 = _interopRequireDefault(_CommonGame);

var _ConfirmationPanel2 = require("./ConfirmationPanel");

var _ConfirmationPanel3 = _interopRequireDefault(_ConfirmationPanel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrashConfirmationPanel = function (_ConfirmationPanel) {
    _inherits(TrashConfirmationPanel, _ConfirmationPanel);

    function TrashConfirmationPanel() {
        _classCallCheck(this, TrashConfirmationPanel);

        // Attributes.
        var _this = _possibleConstructorReturn(this, (TrashConfirmationPanel.__proto__ || Object.getPrototypeOf(TrashConfirmationPanel)).call(this));

        _this._canvasContainer = null;
        _this._trashBgSprite = null;
        _this._trashFgSprite = null;
        return _this;
    }

    _createClass(TrashConfirmationPanel, [{
        key: "init",
        value: function init() {
            _get(TrashConfirmationPanel.prototype.__proto__ || Object.getPrototypeOf(TrashConfirmationPanel.prototype), "init", this).call(this);
            //  ConfirmationPanel.prototype.init.call(this);
            this._messageText.y += 20;

            // Trash bg sprite.
            this._trashBgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("icon_replay_bg"));
            this._trashBgSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._trashBgSprite.y = this._messageText.y - 150;
            this._messageSprite.addChild(this._trashBgSprite);

            // Canvas container.
            this._canvasContainer = new PIXI.Container();
            this._canvasContainer.anchor = new PIXI.Point(0.5, 0.5);
            this._canvasContainer.scale = new PIXI.Point(0.11, 0.11);
            this._canvasContainer.y = this._messageText.y - 250;
            this._canvasContainer.rotation = Math.PI * 0.5;
            this._messageSprite.addChild(this._canvasContainer);

            this._canvasContainer.addChild(_CommonGame2.default.createCanvasBg());

            var galleryKey = "drawing";
            if (_CommonGame2.default.selectedGallery === 1) galleryKey = "colouring";

            // Border.
            var borderSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("canvas_" + galleryKey));
            borderSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._canvasContainer.addChild(borderSprite);
            // Sprite.
            var contentSprite = new PIXI.Sprite(_Common2.default.blankTexture);
            contentSprite.tint = 0xffffff;
            contentSprite.width = _CommonGame2.default.CANVAS_WIDTH;
            contentSprite.height = _CommonGame2.default.CANVAS_HEIGHT;
            contentSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._canvasContainer.addChild(contentSprite);

            // Trash fg sprite.
            this._trashFgSprite = new PIXI.Sprite(_Common2.default.assets.getTexture("icon_replay_fg"));
            this._trashFgSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._trashFgSprite.x = this._trashBgSprite.x;
            this._trashFgSprite.y = this._trashBgSprite.y;
            this._messageSprite.addChild(this._trashFgSprite);
        }
    }, {
        key: "show",
        value: function show(message) {
            _get(TrashConfirmationPanel.prototype.__proto__ || Object.getPrototypeOf(TrashConfirmationPanel.prototype), "show", this).call(this, message);

            this._canvasContainer.y = this._messageText.y - 250;
            this._canvasContainer.alpha = 1;
            this._trashFgSprite.scale = new PIXI.Point(1, 1);
            this._trashBgSprite.scale = new PIXI.Point(1, 1);

            TweenMax.to(this._canvasContainer, 1, {
                y: this._trashBgSprite.y,
                ease: Sine.easeOut,
                repeat: -1,
                repeatDelay: 0.5,
                onRepeat: function onRepeat() {
                    this._canvasContainer.alpha = 1;
                },
                onRepeatScope: this
            });
            TweenMax.to(this._canvasContainer, 0.5, { alpha: 0, ease: Sine.easeOut, repeat: -1, repeatDelay: 1, delay: 0.5 });
            TweenMax.fromTo(this._trashBgSprite.scale, 0.5, { x: 0.99, y: 0.99 }, {
                x: 1,
                y: 1,
                ease: Back.easeOut.config(100),
                repeat: -1,
                delay: 0.75,
                repeatDelay: 1
            });
            TweenMax.fromTo(this._trashFgSprite.scale, 0.5, { x: 0.99, y: 0.99 }, {
                x: 1,
                y: 1,
                ease: Back.easeOut.config(100),
                repeat: -1,
                delay: 0.75,
                repeatDelay: 1
            });
        }
    }, {
        key: "_hide",
        value: function _hide() {
            _get(TrashConfirmationPanel.prototype.__proto__ || Object.getPrototypeOf(TrashConfirmationPanel.prototype), "_hide", this).call(this);

            TweenMax.killTweensOf(this._canvasContainer);
            TweenMax.killTweensOf(this._trashBgSprite.scale);
            TweenMax.killTweensOf(this._trashFgSprite.scale);
        }
    }]);

    return TrashConfirmationPanel;
}(_ConfirmationPanel3.default);

exports.default = TrashConfirmationPanel;

},{"../../Common":3,"../../CommonGame":4,"./ConfirmationPanel":36}]},{},[25])

